<template>
  <h3 class="tltleFont setCenter" style="text-align: center">
    {{ titleText }}
  </h3>

  <!-- use the modal component -->
  <Teleport to="body">
    <!-- use the modal component, pass in the prop -->
    <modal :show="showModal" @close="showModal = false">
      <template #header>
        <h3>custom header</h3>
      </template>
    </modal>
  </Teleport>
  <transition name="modal">
    <modal v-if="showModal" @close="showModal = false">
      <!--
        you can use custom content here to overwrite
        default content
      -->
      <template v-slot:header>
        <h3>custom header</h3>
      </template>
    </modal>
  </transition>
  <!-- <input type="text" placeholder="Type enemy Japan Name" v-model="search" /> -->
  <!-- overlay -->
  <!-- <div class="overlay" v-if="showModal" @click="showModal = false">888</div> -->
  <!-- modal -->
  <div class="modal" v-if="showModal" id="mam">
    <button class="close" @click="showModal = false">x</button>
    <h3>Title</h3>
    <p>Description</p>
  </div>
  <div class="row" style="margin: 0px; margin-top: 20px">
    <!-- <button
      class="btn btn-danger col-2 offset-5"
      type="button"
      aria-expanded="true"
      @click="debug()"
    >
      debug
    </button> -->
    <div class="form-group col-12 setCenter">
      <div class="col-8">
        <div class="input-group col-12 setCenter">
          <div id="radioBtn" class="btn-group">
            <a
              class="btn btn-secondary btn-sm notActive"
              data-toggle="fun"
              data-title="JP"
              @click="changeVersion('JP')"
              >日本語版</a
            >
            <a
              class="btn btn-secondary btn-sm active"
              data-toggle="fun"
              data-title="TW"
              @click="changeVersion('TW')"
              >台版</a
            >
            <a
              class="btn btn-secondary btn-sm notActive"
              data-toggle="fun"
              data-title="US"
              @click="changeVersion('US')"
              >US version</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="dropdown col-12 setCenter"
      style="margin: 0px; margin-top: 10px"
    >
      <button
        class="btn btn-primary dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="true"
      >
        {{ currentStageName }}
      </button>
      <ul class="dropdown-menu">
        <div v-for="(value, key) in stageList" :key="key">
          <a class="dropdown-item" @click="changeStage(key, value)">{{
            comboBoxStageList[key].name
          }}</a>
        </div>
      </ul>
    </div>
    <div class="col-12" style="margin: 0px; margin-top: 10px">
      <div class="col-lg-2 offset-lg-5 col-6 offset-3">
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            id="searchEnemyInput"
            placeholder="請輸入敵人關鍵字"
            aria-label="請輸入敵人關鍵字"
            aria-describedby="basic-addon2"
            required
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary"
              type="button"
              @click="startSearch()"
            >
              <span class="fa-solid fa-magnifying-glass"></span>
            </button>
            <button
              class="btn btn-outline-secondary"
              type="button"
              @click="resetSearch()"
            >
              <span class="fa-solid fa-x"></span>
            </button>
          </div>
        </div>
      </div>
      <table
        class="table table-warning table-striped"
        style="text-align: center"
      >
        <thead>
          <tr>
            <th scope="col">{{ subTitle1 }}</th>
          </tr>
        </thead>
        <tbody class="row setCenter" style="margin: 0px">
          <div
            class="row col-12"
            id="jpQuickSearch"
            style="margin-top: 10px; display: none"
          >
            <tr
              class="col-md-1 col-1 table-primary setCenter unSelectFliter"
              v-for="(value, key) in firstWordList"
              :key="key"
              style="
                font-weight: bold;
                padding: 10px 5px;
                background-color: rgb(255 241 159);
                border: solid 2px red;
              "
              :id="key"
              @click="dofilter(key, true)"
            >
              <td class="col-1 setCenter">
                {{ key }}
              </td>
            </tr>
          </div>

          <tr
            class="col-xl-2 col-lg-3 col-4 table-success setCenter"
            v-for="(value, key) in filterStageEnemyList"
            :key="key"
            style="font-weight: bold; padding: 10px 5px"
            :id="key"
          >
            <td
              class="row col-10 offset-1"
              style="
                margin: 0px;
                padding: 0px;
                height: 140px;
                border-radius: 20px;
              "
            >
              <div style="height: 100%">
                <img
                  class="col-4"
                  :src="value.imgSrc"
                  style="width: 60px; padding-top: 10px"
                  @click="selectEnemy(key)"
                />
                <p
                  class="col-12 enemyList"
                  style="padding: 0px; padding-top: 10px"
                >
                  {{ value.jpName }}<br />{{ value.ctName }}<br />{{
                    value.enName
                  }}
                </p>
              </div>
              <div
                class="selectCircle setCenter unSelect"
                :id="value.selectId"
                style="
                  height: 100%;
                  background-color: yellow;
                  border-radius: 20px;
                "
                @click="selectEnemy(key)"
              >
                <span class="fa-solid fa-bullseye" style="color: red"></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <div class="row col-10 offset-1">
      <div class="col-4 setCenter">
        <button class="btn addBtn" id="show-modal" @click="showModal = true">
          <span class="fa-solid fa-circle-plus"></span>
        </button>
      </div>
      <div class="col-4 setCenter">
        <button class="btn addBtn">
          <span class="fa-solid fa-circle-plus"></span>
        </button>
      </div>
      <div class="col-4 setCenter">
        <button class="btn addBtn">
          <span class="fa-solid fa-circle-plus"></span>
        </button>
      </div>
    </div> -->

    <div class="col-12" style="margin-top: 10px">
      <table
        class="table table-warning table-striped"
        style="text-align: center"
      >
        <thead>
          <tr>
            <th scope="col">{{ subTitle3 + " " + subTitle2 }}</th>
          </tr>
        </thead>
        <tbody
          class="row col-12 table-danger"
          v-for="(value, key) in ansStageSort3"
          :key="key"
          style="padding: 0px; margin: 0px"
        >
          <tr
            class="col-12 table-danger setCenter"
            style="font-weight: bold; padding: 0px; margin: 0px"
          >
            <th class="col-12">
              {{ stageLegendConvert[key][currentVer] }} [{{ staminaConvert }}:
              {{ stageStamina[currentStageKey][key] }}]
            </th>
          </tr>
          <tr
            class="col-12 table-primary setCenter"
            style="font-weight: bold; padding: 0px; margin: 0px"
          >
            <td
              class="table-info stageEnemyTable"
              v-for="(v, k) in value"
              :key="k"
            >
              <div>
                <img class="col-4 stageEnemyImg" :src="v.imgSrc" />
                <p
                  class="col-12 stageEnemyName"
                  style="padding: 0px; padding-top: 5px; font-size: 0.8rem"
                >
                  {{ v.jpName }}<br />{{ v.ctName }}<br />{{ v.enName }}
                </p>
              </div>
              <div
                class="selectCircle stageEnemyBullseye setCenter unSelect"
                :id="key + '_' + k"
                style="height: 85%; border-radius: 100px"
              >
                <span class="fa-solid fa-bullseye" style="color: red"></span>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody
          class="row col-12 table-danger"
          v-for="(value, key) in ansStageSort2"
          :key="key"
          style="padding: 0px; margin: 0px"
        >
          <tr
            class="col-12 table-danger setCenter"
            style="font-weight: bold; padding: 0px; margin: 0px"
          >
            <th class="col-12">
              {{ stageLegendConvert[key][currentVer] }} [{{ staminaConvert }}:
              {{ stageStamina[currentStageKey][key] }}]
            </th>
          </tr>
          <tr
            class="col-12 table-primary setCenter"
            style="font-weight: bold; padding: 0px; margin: 0px"
          >
            <td
              class="table-info stageEnemyTable"
              v-for="(v, k) in value"
              :key="k"
            >
              <div>
                <img class="col-4 stageEnemyImg" :src="v.imgSrc" />
                <p
                  class="col-12 stageEnemyName"
                  style="padding: 0px; padding-top: 5px; font-size: 0.8rem"
                >
                  {{ v.jpName }}<br />{{ v.ctName }}<br />{{ v.enName }}
                </p>
              </div>
              <div
                class="selectCircle stageEnemyBullseye setCenter unSelect"
                :id="key + '_' + k"
                style="height: 85%; border-radius: 100px"
              >
                <span class="fa-solid fa-bullseye" style="color: red"></span>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody
          class="row col-12 table-danger"
          v-for="(value, key) in ansStageSort"
          :key="key"
          style="padding: 0px; margin: 0px"
        >
          <tr
            class="col-12 table-danger setCenter"
            style="font-weight: bold; padding: 0px; margin: 0px"
          >
            <th class="col-12">
              {{ stageLegendConvert[key][currentVer] }} [{{ staminaConvert }}:
              {{ stageStamina[currentStageKey][key] }}]
            </th>
          </tr>
          <tr
            class="col-12 table-primary setCenter"
            style="font-weight: bold; padding: 0px; margin: 0px"
          >
            <td
              class="table-info stageEnemyTable"
              v-for="(v, k) in value"
              :key="k"
            >
              <div>
                <img class="col-4 stageEnemyImg" :src="v.imgSrc" />
                <p
                  class="col-12 stageEnemyName"
                  style="padding: 0px; padding-top: 5px; font-size: 0.8rem"
                >
                  {{ v.jpName }}<br />{{ v.ctName }}<br />{{ v.enName }}
                </p>
              </div>
              <div
                class="selectCircle stageEnemyBullseye setCenter unSelect"
                :id="key + '_' + k"
                style="height: 85%; border-radius: 100px"
              >
                <span class="fa-solid fa-bullseye" style="color: red"></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <div class="dropdown col-12">
      <button
        class="btn btn-primary dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="true"
      >
        {{ enemyName }}
      </button>
      <ul class="dropdown-menu">
        <div v-for="(value, index) in enemyList" :key="index">
          <a class="dropdown-item" @click="changeTitle(value)">{{
            value.jpName
          }}</a>
        </div>
      </ul>
    </div>
    <div class="col-12" style="margin-top: 10px">
      <table
        class="table table-warning table-striped"
        style="text-align: center"
      >
        <thead>
          <tr>
            <th scope="col">現在選取</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-success" style="font-weight: bold">
            <td>{{ enemyName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12" style="margin-top: 10px; text-align: center">
      <img :src="imageSrc" />
    </div> -->
  </div>
</template>

<script>
import Modal from "./Modal.vue";
import $ from "jquery";

export default {
  id: "06page",
  name: "06Page",
  components: {
    Modal,
  },
  setup() {
    return {};
  },
  mounted() {
    $("#radioBtn a").on("click", function () {
      //console.log($(this).data("title"));
      var sel = $(this).data("title");
      var tog = $(this).data("toggle");
      $("#" + tog).prop("value", sel);

      $('a[data-toggle="' + tog + '"]')
        .not('[data-title="' + sel + '"]')
        .removeClass("active")
        .addClass("notActive");
      $('a[data-toggle="' + tog + '"][data-title="' + sel + '"]')
        .removeClass("notActive")
        .addClass("active");
    });
  },
  methods: {
    debug() {
      //console.log("debug");
      //var keys1 = Object.keys(this.stageLegendConvert);
      //console.log(keys1);
      var keys2 = Object.keys(this.stageDetailList);

      for (var i = 0; i < keys2.length; i++) {
        var keys3 = Object.keys(this.stageDetailList[keys2[i]]);
        for (var j = 0; j < keys3.length; j++) {
          var tmp = this.stageLegendConvert[keys3[j]];
          if (tmp === undefined) {
            //console.log(keys3[j]);
            //console.log(this.stageLegendConvert[keys3[j]]);
          }
        }
      }
      //console.log(keys3);
    },
    changeVersion(v) {
      this.resetMemory();
      var searchInputDom = document.getElementById("searchEnemyInput");
      var keys = Object.keys(this.comboBoxStageList);
      var dom = document.getElementById("jpQuickSearch");
      var i = 0;
      if (v == "TW") {
        dom.style.display = "none";
        this.staminaConvert = "統率力";
        this.titleText = "每月任務敵人關卡查找";
        searchInputDom.placeholder = "輸入敵人關鍵字";
        this.subTitle1 = "關卡敵人一覧";
        this.subTitle2 = "結果一覧";
        this.currentStageName = "請選擇關卡篇章";
        this.currentVer = "ct";
        for (i = 0; i < Object.keys(this.comboBoxStageList).length; i++)
          this.comboBoxStageList[keys[i]]["name"] =
            this.stageList[keys[i]]["ct"];
      } else if (v == "US") {
        dom.style.display = "none";
        this.staminaConvert = "Energy";
        this.titleText = "Monthly Missions Finder";
        searchInputDom.placeholder = "Enter enemy keyword";
        this.subTitle1 = "All enemies in stage";
        this.subTitle2 = "Result";
        this.currentStageName = "select stage";
        this.currentVer = "en";
        for (i = 0; i < Object.keys(this.comboBoxStageList).length; i++)
          this.comboBoxStageList[keys[i]]["name"] =
            this.stageList[keys[i]]["en"];
      } else if (v == "JP") {
        dom.style.display = "flex";
        this.staminaConvert = "統率力";
        this.titleText = "マンスリーミッションのステージ検索";
        searchInputDom.placeholder = "敵のキーワードを入力";
        this.subTitle1 = "ステージの敵キャラ";
        this.subTitle2 = "検索結果";
        this.currentStageName = "ステージを選択";
        this.currentVer = "jp";
        for (i = 0; i < Object.keys(this.comboBoxStageList).length; i++)
          this.comboBoxStageList[keys[i]]["name"] =
            this.stageList[keys[i]]["jp"];
      }
    },
    startSearch() {
      var val = document.getElementById("searchEnemyInput").value;
      if (val == "") {
        //console.log("no input");
      } else {
        //console.log(val);
        this.dofilter(val, false);
      }
    },
    resetSearch() {
      this.filterStageEnemyList = this.stageEnemyList;

      var keys = Object.keys(this.firstWordList);
      for (var j = 0; j < keys.length; j++) {
        var id = this.firstWordList[keys[j]];
        if (!document.getElementById(id).classList.contains("unSelectFliter"))
          document.getElementById(id).classList.toggle("unSelectFliter");
      }

      var tmpList = this.alreadySelectEnemyList;
      setTimeout(function () {
        for (var ii = 0; ii < tmpList.length; ii++) {
          var idd = tmpList[ii];
          var element = document.getElementById("select_".concat(idd));
          //處理選擇 / 取消選擇;
          if (element != null) element.classList.remove("unSelect");
          var element2 = document.getElementById(idd);
          //處理選擇 / 取消選擇;
          if (element2 != null) element2.classList.remove("unSelect");
        }
      }, 10);
    },
    resetMemory() {
      for (var i = 0; i < this.alreadySelectEnemyList.length; i++) {
        var element = document.getElementById(
          "select_".concat(this.alreadySelectEnemyList[i])
        );
        if (element != null) element.classList.toggle("unSelect");
      }

      var keys = Object.keys(this.firstWordList);
      for (var j = 0; j < keys.length; j++) {
        var id = this.firstWordList[keys[j]];
        var dom = document.getElementById(id);
        if (dom != null)
          if (!dom.classList.contains("unSelectFliter"))
            dom.classList.toggle("unSelectFliter");
      }

      this.alreadySelectEnemyList = [];
      this.ansStage = {};
      this.firstWordList = {};
      this.filterStageEnemyList = {};
      this.subTitle3 = "";
      this.ansStageSort3 = {};
      this.ansStageSort2 = {};
      this.ansStageSort = {};
    },
    changeTitle(value) {
      this.enemyName = value.jpName;
      this.imageSrc = value.imgSrc;
      this.productModal.show();
    },
    changeStage(key, value) {
      this.resetMemory();

      this.stageName = value.ct;
      this.currentStageName = this.comboBoxStageList[key].name;
      this.currentStageKey = key;
      this.subTitle3 = this.currentStageName;
      this.stageEnemyList = {};
      this.filterStageEnemyList = {};
      // 取得篇章所有敵人
      var keys = Object.keys(this.stageDetailList[key]);
      for (var i = 0; i < keys.length; i++) {
        var enemyInfo = this.stageDetailList[key][keys[i]]["info"];
        for (var j = 0; j < enemyInfo.length; j++) {
          var tmpId = enemyInfo[j]["id"];
          this.stageEnemyList[tmpId] = {};

          this.stageEnemyList[tmpId]["selectId"] = "select_".concat(tmpId);
          this.stageEnemyList[tmpId]["ctName"] =
            this.enemyList["id_".concat(tmpId)]["ctName"];
          this.stageEnemyList[tmpId]["jpName"] =
            this.enemyList["id_".concat(tmpId)]["jpName"];
          this.stageEnemyList[tmpId]["enName"] =
            this.enemyList["id_".concat(tmpId)]["enName"];
          this.stageEnemyList[tmpId]["imgSrc"] =
            this.enemyList["id_".concat(tmpId)]["imgSrc"];
        }
      }
      keys = Object.keys(this.stageEnemyList);
      // var firstWordList = {};
      for (i = 0; i < keys.length; i++) {
        this.firstWordList[this.stageEnemyList[keys[i]]["jpName"][0]] =
          this.stageEnemyList[keys[i]]["jpName"][0];
        //console.log(this.stageEnemyList[keys[i]]["jpName"][0]);
        this.filterStageEnemyList = this.stageEnemyList;
      }
      //console.log(this.filterStageEnemyList);

      var firstWordKeys = Object.keys(this.firstWordList);
      firstWordKeys.sort();
      var tmpFirstWordMap = {};
      for (i = 0; i < firstWordKeys.length; i++) {
        tmpFirstWordMap[firstWordKeys[i]] = firstWordKeys[i];
      }
      this.firstWordList = tmpFirstWordMap;
    },
    selectEnemy(id) {
      var element = document.getElementById("select_".concat(id));

      // 處理選擇/取消選擇
      if (
        this.alreadySelectEnemyList.length < 3 &&
        element.classList.contains("unSelect")
      ) {
        element.classList.toggle("unSelect");
        this.alreadySelectEnemyList.push(id);
      } else if (!element.classList.contains("unSelect")) {
        element.classList.toggle("unSelect");
        const index = this.alreadySelectEnemyList.indexOf(id);
        this.alreadySelectEnemyList.splice(index, 1);
      }

      //console.log("sele"ct": " + this.alreadySelectEnemyList.length);

      // find enemies in stage
      var keys = Object.keys(this.stageList);
      var stageKey = "";
      for (var i = 0; i < keys.length; i++) {
        if (this.stageList[keys[i]].ct == this.stageName) {
          stageKey = keys[i];
          break;
        }
      }

      keys = Object.keys(this.stageDetailList[stageKey]);
      this.ansStage = {};

      for (i = 0; i < keys.length; i++) {
        var stageEnemyList = this.stageDetailList[stageKey][keys[i]]["info"];

        for (var j = 0; j < stageEnemyList.length; j++) {
          for (var k = 0; k < this.alreadySelectEnemyList.length; k++) {
            if (stageEnemyList[j].id == this.alreadySelectEnemyList[k]) {
              //this.ansStage[keys[j]] = {};
              var enemyInfo = this.stageDetailList[stageKey][keys[i]]["info"];

              var tmpStageEnemyInfo = {};

              for (var l = 0; l < enemyInfo.length; l++) {
                tmpStageEnemyInfo[enemyInfo[l]["id"]] =
                  this.enemyList["id_".concat(enemyInfo[l]["id"])];
                tmpStageEnemyInfo[enemyInfo[l]["id"]]["select"] = false;

                if (this.alreadySelectEnemyList.includes(enemyInfo[l]["id"])) {
                  tmpStageEnemyInfo[enemyInfo[l]["id"]]["select"] = true;
                }
              }

              this.ansStage[keys[i]] = tmpStageEnemyInfo;
              //console.log(this.ansStage);
            }
          }
        }
      }

      var tmpK = Object.keys(this.ansStage);
      for (i = 0; i < tmpK.length; i++) {
        this.sortStageByEnemyCount[tmpK[i]] = 0;
        var ks = Object.keys(this.ansStage[tmpK[i]]);
        for (j = 0; j < ks.length; j++) {
          if (this.ansStage[tmpK[i]][ks[j]]["select"])
            this.sortStageByEnemyCount[tmpK[i]] =
              this.sortStageByEnemyCount[tmpK[i]] + 1;
        }
      }

      //console.log(this.sortStageByEnemyCount);
      this.ansStageSort = {};
      this.ansStageSort2 = {};
      this.ansStageSort3 = {};

      for (i = 0; i < tmpK.length; i++) {
        var sortIdx = this.sortStageByEnemyCount[tmpK[i]];
        if (sortIdx == 3) this.ansStageSort3[tmpK[i]] = this.ansStage[tmpK[i]];
        else if (sortIdx == 2)
          this.ansStageSort2[tmpK[i]] = this.ansStage[tmpK[i]];
        else if (sortIdx == 1)
          this.ansStageSort[tmpK[i]] = this.ansStage[tmpK[i]];
      }

      // for (i = 0; i < tmpK.length; i++) {
      //   if (this.sortStageByEnemyCount[tmpK[i]] == 0)
      //     ansStageSort[tmpK[i]] = this.ansStage[tmpK[i]];
      // }
      // console.log("====");
      // console.log(this.ansStageSort);
      // console.log("====");

      // sort by enemy appear count
      // var tmpSort = {};
      // var tmpK = Object.keys(this.ansStage);
      // console.log(this.sortStageByEnemyCount);
      // for (i = 0; i < tmpK.length; i++) {
      //   console.log(this.sortStageByEnemyCount[tmpK[i]]);
      //   if (this.sortStageByEnemyCount[tmpK[i]] == 3) tmpSort[tmpK[i]] = this.ansStage[tmpK[i]];
      // }
      // for (i = 0; i < tmpK.length; i++) {
      //   if (this.sortStageByEnemyCount[tmpK[i]] == 2) tmpSort[tmpK[i]] = this.ansStage[tmpK[i]];
      // }
      // for (i = 0; i < tmpK.length; i++) {
      //   if (this.sortStageByEnemyCount[tmpK[i]] == 1) tmpSort[tmpK[i]] = this.ansStage[tmpK[i]];
      // }
      // for (i = 0; i < tmpK.length; i++) {
      //   if (this.sortStageByEnemyCount[tmpK[i]] == 0) tmpSort[tmpK[i]] = this.ansStage[tmpK[i]];
      // }
      // this.ansStage = tmpSort;

      //console.log(this.ansStage);

      var tmpAnsStage = this.ansStage;
      var tmpAlreadySelectEnemyList = this.alreadySelectEnemyList;

      setTimeout(function () {
        var stageKeys = Object.keys(tmpAnsStage);
        for (var idx = 0; idx < stageKeys.length; idx++) {
          var stageEnemyKeys = Object.keys(tmpAnsStage[stageKeys[idx]]);
          //console.log(stageKeys);

          for (var idx2 = 0; idx2 < stageEnemyKeys.length; idx2++) {
            // console.log(stageKeys[idx] + "_" + stageEnemyKeys[idx2]);
            var stageEnemyUnSelectId =
              stageKeys[idx] + "_" + stageEnemyKeys[idx2];
            //console.log(stageEnemySelectId);
            var addDom = document.getElementById(stageEnemyUnSelectId);
            if (addDom != null) addDom.classList.add("unSelect");
          }
          for (var idx3 = 0; idx3 < tmpAlreadySelectEnemyList.length; idx3++) {
            var stageEnemySelectId =
              stageKeys[idx] + "_" + tmpAlreadySelectEnemyList[idx3];
            //console.log(stageEnemySelectId);
            var removeDom = document.getElementById(stageEnemySelectId);

            if (removeDom != null) removeDom.classList.remove("unSelect");
          }
        }
      }, 100);
    },
    dofilter(k, isQuickSearch) {
      //console.log(k.length);
      var temAlready = this.alreadySelectEnemyList;
      var keys = Object.keys(this.firstWordList);
      if (k.length == 1 && isQuickSearch) {
        // 控制日文快選
        var preFliterId = "";
        for (var j = 0; j < keys.length; j++) {
          var id = this.firstWordList[keys[j]];
          if (
            !document.getElementById(id).classList.contains("unSelectFliter")
          ) {
            document.getElementById(id).classList.toggle("unSelectFliter");
            preFliterId = id;
          }
        }

        this.filterStageEnemyList = this.stageEnemyList;
        if (preFliterId == k[0]) {
          setTimeout(function () {
            for (var ii = 0; ii < temAlready.length; ii++) {
              var idd = temAlready[ii];
              var element = document.getElementById("select_".concat(idd));
              //處理選擇 / 取消選擇;
              if (element != null) element.classList.remove("unSelect");
              var element2 = document.getElementById(idd);
              //處理選擇 / 取消選擇;
              if (element2 != null) element2.classList.remove("unSelect");
            }
          }, 10);
          return;
        }

        var dom = document.getElementById(k[0]);
        if (dom != null) dom.classList.toggle("unSelectFliter");

        keys = Object.keys(this.filterStageEnemyList);
        var tmpAns = {};
        for (var i = 0; i < keys.length; i++) {
          if (k == this.filterStageEnemyList[keys[i]]["jpName"][0])
            tmpAns[keys[i]] = this.filterStageEnemyList[keys[i]];
        }
        this.filterStageEnemyList = tmpAns;
        return;
      } else {
        for (j = 0; j < keys.length; j++) {
          id = this.firstWordList[keys[j]];
          document.getElementById(id).classList.add("unSelectFliter");
        }
      }

      keys = Object.keys(this.stageEnemyList);
      tmpAns = {};

      //console.log(this.stageEnemyList);

      for (i = 0; i < keys.length; i++) {
        if (
          this.stageEnemyList[keys[i]]["ctName"].includes(k) ||
          this.stageEnemyList[keys[i]]["jpName"].includes(k) ||
          this.stageEnemyList[keys[i]]["enName"]
            .toUpperCase()
            .includes(k.toUpperCase())
        )
          tmpAns[keys[i]] = this.stageEnemyList[keys[i]];
      }

      //console.log(tmpAns);
      this.filterStageEnemyList = tmpAns;

      setTimeout(function () {
        for (var ii = 0; ii < temAlready.length; ii++) {
          var idd = temAlready[ii];
          var element = document.getElementById("select_".concat(idd));
          //處理選擇 / 取消選擇;
          if (element != null) element.classList.remove("unSelect");
          var element2 = document.getElementById(idd);
          //處理選擇 / 取消選擇;
          if (element2 != null) element2.classList.remove("unSelect");
        }
      }, 10);

      //console.log(this.filterStageEnemyList);
    },
    refreshPage() {
      console.log("refresh");
      console.log(this.alreadySelectEnemyList);
      for (var ii = 0; ii < this.alreadySelectEnemyList.length; ii++) {
        var idd = this.alreadySelectEnemyList[ii];
        var element = document.getElementById("select_".concat(idd));
        console.log("idd: " + "select_".concat(idd));
        console.log(element);
        // 處理選擇/取消選擇
        if (element != null) element.classList.remove("unSelect");
      }
    },
  },
  watch: {},
  data() {
    return {
      showModal: false,
      productModal: null,
      titleText: "每月任務敵人關卡查找",
      enemyName: "未選擇",
      stageName: "",
      currentStageName: "請選擇關卡篇章",
      currentStageKey: "",
      staminaConvert: "統率力",
      subTitle1: "關卡敵人一覧",
      subTitle2: "結果一覧",
      subTitle3: "",
      currentVer: "ct",
      stageEnemyList: {},
      filterStageEnemyList: {},
      alreadySelectEnemyList: [],
      ansStage: {},
      ansStageSort: {},
      ansStageSort2: {},
      ansStageSort3: {},
      sortStageByEnemyCount: {},
      firstWordList: {},
      imageSrc: require("../img/noImages.jpg"),
      stageStamina: {
        stageJP01: {
          "01_長崎県": "5",
          "02_佐賀県": "5",
          "03_鹿児島県": "8",
          "04_熊本県": "8",
          "05_宮崎県": "10",
          "06_大分県": "10",
          "07_福岡県": "16",
          "08_高知県": "12",
          "09_愛媛県": "12",
          "10_徳島県": "14",
          "11_香川県": "18",
          "12_山口県": "20",
          "13_広島県": "18",
          "14_島根県": "20",
          "15_岡山県": "24",
          "16_鳥取県": "26",
          "17_兵庫県": "20",
          "18_和歌山県": "24",
          "19_大阪府": "28",
          "20_京都府": "30",
          "21_奈良県": "24",
          "22_三重県": "28",
          "23_滋賀県": "32",
          "24_福井県": "40",
          "25_石川県": "25",
          "26_愛知県": "30",
          "27_岐阜県": "32",
          "28_富山県": "36",
          "29_静岡県": "40",
          "30_山梨県": "24",
          "31_長野県": "26",
          "32_新潟県": "30",
          "33_神奈川県": "35",
          "34_千葉県": "28",
          "35_東京都": "30",
          "36_埼玉県": "40",
          "37_群馬県": "30",
          "38_栃木県": "35",
          "39_茨城県": "40",
          "40_福島県": "30",
          "41_宮城県": "32",
          "42_山形県": "35",
          "43_岩手県": "30",
          "44_秋田県": "32",
          "45_青森県": "40",
          "46_北海道": "50",
          "47_沖縄県": "50",
          "48_西表島": "50",
        },
        stageJP02: {
          "01_長崎県": "15",
          "02_佐賀県": "15",
          "03_鹿児島県": "18",
          "04_熊本県": "18",
          "05_宮崎県": "20",
          "06_大分県": "20",
          "07_福岡県": "26",
          "08_高知県": "22",
          "09_愛媛県": "22",
          "10_徳島県": "24",
          "11_香川県": "28",
          "12_山口県": "30",
          "13_広島県": "28",
          "14_島根県": "30",
          "15_岡山県": "34",
          "16_鳥取県": "36",
          "17_兵庫県": "30",
          "18_和歌山県": "34",
          "19_大阪府": "38",
          "20_京都府": "40",
          "21_奈良県": "34",
          "22_三重県": "38",
          "23_滋賀県": "42",
          "24_福井県": "50",
          "25_石川県": "35",
          "26_愛知県": "40",
          "27_岐阜県": "42",
          "28_富山県": "46",
          "29_静岡県": "50",
          "30_山梨県": "34",
          "31_長野県": "36",
          "32_新潟県": "40",
          "33_神奈川県": "45",
          "34_千葉県": "38",
          "35_東京都": "40",
          "36_埼玉県": "50",
          "37_群馬県": "40",
          "38_栃木県": "45",
          "39_茨城県": "50",
          "40_福島県": "40",
          "41_宮城県": "42",
          "42_山形県": "45",
          "43_岩手県": "40",
          "44_秋田県": "42",
          "45_青森県": "50",
          "46_北海道": "60",
          "47_沖縄県": "60",
          "48_西表島": "60",
        },
        stageJP03: {
          "01_長崎県": "25",
          "02_佐賀県": "25",
          "03_鹿児島県": "28",
          "04_熊本県": "28",
          "05_宮崎県": "30",
          "06_大分県": "30",
          "07_福岡県": "36",
          "08_高知県": "32",
          "09_愛媛県": "32",
          "10_徳島県": "34",
          "11_香川県": "38",
          "12_山口県": "40",
          "13_広島県": "38",
          "14_島根県": "40",
          "15_岡山県": "44",
          "16_鳥取県": "46",
          "17_兵庫県": "40",
          "18_和歌山県": "44",
          "19_大阪府": "48",
          "20_京都府": "50",
          "21_奈良県": "44",
          "22_三重県": "48",
          "23_滋賀県": "52",
          "24_福井県": "60",
          "25_石川県": "45",
          "26_愛知県": "50",
          "27_岐阜県": "52",
          "28_富山県": "56",
          "29_静岡県": "60",
          "30_山梨県": "44",
          "31_長野県": "46",
          "32_新潟県": "50",
          "33_神奈川県": "55",
          "34_千葉県": "48",
          "35_東京都": "50",
          "36_埼玉県": "60",
          "37_群馬県": "50",
          "38_栃木県": "55",
          "39_茨城県": "60",
          "40_福島県": "50",
          "41_宮城県": "52",
          "42_山形県": "55",
          "43_岩手県": "50",
          "44_秋田県": "52",
          "45_青森県": "60",
          "46_北海道": "70",
          "47_沖縄県": "70",
          "48_西表島": "70",
        },
        stageFuture01: {
          "01_日本": "30",
          "02_韓国": "30",
          "03_中国": "32",
          "04_モンゴル": "32",
          "05_ロシア": "34",
          "06_ノルウェー": "34",
          "07_イギリス": "35",
          "08_デンマーク": "32",
          "09_ドイツ": "34",
          "10_フランス": "35",
          "11_スペイン": "40",
          "12_モナコ": "38",
          "13_イタリア": "40",
          "14_ギリシャ": "42",
          "15_トルコ": "45",
          "16_ドバイ": "50",
          "17_インド": "48",
          "18_ネパール": "46",
          "19_タイ": "50",
          "20_カンボジア": "48",
          "21_フィリピン": "46",
          "22_シンガポール": "50",
          "23_オーストラリア": "52",
          "24_深淵の大渦": "70",
          "25_マダガスカル": "48",
          "26_ケニア": "52",
          "27_サウジアラビア": "53",
          "28_エジプト": "55",
          "29_サハラ": "60",
          "30_ガーナ": "50",
          "31_南アフリカ": "50",
          "32_アルゼンチン": "52",
          "33_イースター島": "60",
          "34_マチュピチュ": "50",
          "35_コロンビア": "52",
          "36_ジャマイカ": "54",
          "37_メキシコ": "56",
          "38_ハリウッド": "56",
          "39_ラスベガス": "58",
          "40_アラスカ": "57",
          "41_カナダ": "60",
          "42_グリーンランド": "60",
          "43_ニューヨーク": "65",
          "44_NASA": "60",
          "45_バミューダ": "62",
          "46_ブラジル": "60",
          "47_浮遊大陸": "75",
          "48_月": "80",
        },
        stageFuture02: {
          "01_日本": "40",
          "02_韓国": "40",
          "03_中国": "42",
          "04_モンゴル": "42",
          "05_ロシア": "44",
          "06_ノルウェー": "44",
          "07_イギリス": "45",
          "08_デンマーク": "42",
          "09_ドイツ": "44",
          "10_フランス": "45",
          "11_スペイン": "50",
          "12_モナコ": "48",
          "13_イタリア": "50",
          "14_ギリシャ": "52",
          "15_トルコ": "55",
          "16_ドバイ": "60",
          "17_インド": "58",
          "18_ネパール": "56",
          "19_タイ": "60",
          "20_カンボジア": "58",
          "21_フィリピン": "56",
          "22_シンガポール": "60",
          "23_オーストラリア": "62",
          "24_深淵の大渦": "80",
          "25_マダガスカル": "58",
          "26_ケニア": "62",
          "27_サウジアラビア": "63",
          "28_エジプト": "65",
          "29_サハラ": "70",
          "30_ガーナ": "60",
          "31_南アフリカ": "60",
          "32_アルゼンチン": "62",
          "33_イースター島": "70",
          "34_マチュピチュ": "60",
          "35_コロンビア": "62",
          "36_ジャマイカ": "64",
          "37_メキシコ": "66",
          "38_ハリウッド": "66",
          "39_ラスベガス": "68",
          "40_アラスカ": "67",
          "41_カナダ": "70",
          "42_グリーンランド": "70",
          "43_ニューヨーク": "75",
          "44_NASA": "70",
          "45_バミューダ": "72",
          "46_ブラジル": "70",
          "47_浮遊大陸": "85",
          "48_月": "90",
        },
        stageFuture03: {
          "01_日本": "50",
          "02_韓国": "50",
          "03_中国": "52",
          "04_モンゴル": "52",
          "05_ロシア": "54",
          "06_ノルウェー": "54",
          "07_イギリス": "55",
          "08_デンマーク": "52",
          "09_ドイツ": "54",
          "10_フランス": "55",
          "11_スペイン": "60",
          "12_モナコ": "58",
          "13_イタリア": "60",
          "14_ギリシャ": "62",
          "15_トルコ": "65",
          "16_ドバイ": "70",
          "17_インド": "68",
          "18_ネパール": "66",
          "19_タイ": "70",
          "20_カンボジア": "68",
          "21_フィリピン": "66",
          "22_シンガポール": "70",
          "23_オーストラリア": "72",
          "24_深淵の大渦": "90",
          "25_マダガスカル": "68",
          "26_ケニア": "72",
          "27_サウジアラビア": "73",
          "28_エジプト": "75",
          "29_サハラ": "80",
          "30_ガーナ": "70",
          "31_南アフリカ": "70",
          "32_アルゼンチン": "72",
          "33_イースター島": "80",
          "34_マチュピチュ": "70",
          "35_コロンビア": "72",
          "36_ジャマイカ": "74",
          "37_メキシコ": "76",
          "38_ハリウッド": "76",
          "39_ラスベガス": "78",
          "40_アラスカ": "77",
          "41_カナダ": "80",
          "42_グリーンランド": "80",
          "43_ニューヨーク": "85",
          "44_NASA": "80",
          "45_バミューダ": "82",
          "46_ブラジル": "80",
          "47_浮遊大陸": "95",
          "48_月": "100",
        },
        stageUniverse01: {
          "01_地球": "50",
          "02_火星": "50",
          "03_木星": "52",
          "04_土星": "52",
          "05_金星": "54",
          "06_水星": "54",
          "07_太陽": "55",
          "08_ウラヌス": "52",
          "09_ネプチューン": "54",
          "10_トリトン": "55",
          "11_プルートゥ": "58",
          "12_赤い長方形星雲": "57",
          "13_エスキモー星雲": "60",
          "14_キャッツアイ星雲": "62",
          "15_卵星雲": "65",
          "16_ひょうたん星雲": "64",
          "17_アルタイル": "70",
          "18_シリウス": "68",
          "19_カノープス": "72",
          "20_ベガ": "70",
          "21_アルデバラン": "73",
          "22_ベテルギウス": "71",
          "23_デネブ": "75",
          "24_惑星スナック": "80",
          "25_サイータ星": "72",
          "26_魁皇星": "74",
          "27_大マゼラン星雲": "77",
          "28_ブータラ星": "70",
          "29_モスカンダグ": "75",
          "30_コロン星": "73",
          "31_ヤキソパーン": "72",
          "32_ウメ星": "74",
          "33_ダラララ": "75",
          "34_マイドムリ": "72",
          "35_メルトズ": "70",
          "36_ウラルー": "73",
          "37_アグハムム": "75",
          "38_ソモロン": "77",
          "39_アバ・ ブア": "76",
          "40_ティターン": "78",
          "41_デススタン": "80",
          "42_ゴリラの惑星": "82",
          "43_チョイバトロン星": "80",
          "44_クリムゾン星": "83",
          "45_N77星雲": "77",
          "46_アンドロメダ": "85",
          "47_ブラックホール": "95",
          "48_ビッグバン": "100",
        },
        stageUniverse02: {
          "01_地球": "60",
          "02_火星": "60",
          "03_木星": "62",
          "04_土星": "62",
          "05_金星": "64",
          "06_水星": "64",
          "07_太陽": "65",
          "08_ウラヌス": "62",
          "09_ネプチューン": "64",
          "10_トリトン": "65",
          "11_プルートゥ": "68",
          "12_赤い長方形星雲": "67",
          "13_エスキモー星雲": "70",
          "14_キャッツアイ星雲": "72",
          "15_卵星雲": "75",
          "16_ひょうたん星雲": "74",
          "17_アルタイル": "80",
          "18_シリウス": "78",
          "19_カノープス": "82",
          "20_ベガ": "80",
          "21_アルデバラン": "83",
          "22_ベテルギウス": "81",
          "23_デネブ": "85",
          "24_惑星スナック": "90",
          "25_サイータ星": "82",
          "26_魁皇星": "84",
          "27_大マゼラン星雲": "87",
          "28_ブータラ星": "80",
          "29_モスカンダグ": "85",
          "30_コロン星": "83",
          "31_ヤキソパーン": "82",
          "32_ウメ星": "84",
          "33_ダラララ": "85",
          "34_マイドムリ": "82",
          "35_メルトズ": "80",
          "36_ウラルー": "83",
          "37_アグハムム": "85",
          "38_ソモロン": "87",
          "39_アバ・ ブア": "86",
          "40_ティターン": "88",
          "41_デススタン": "90",
          "42_ゴリラの惑星": "92",
          "43_チョイバトロン星": "90",
          "44_クリムゾン星": "93",
          "45_N77星雲": "87",
          "46_アンドロメダ": "95",
          "47_ブラックホール": "105",
          "48_ビッグバン": "110",
        },
        stageUniverse03: {
          "01_地球": "70",
          "02_火星": "70",
          "03_木星": "72",
          "04_土星": "72",
          "05_金星": "74",
          "06_水星": "74",
          "07_太陽": "75",
          "08_ウラヌス": "72",
          "09_ネプチューン": "74",
          "10_トリトン": "75",
          "11_プルートゥ": "78",
          "12_赤い長方形星雲": "77",
          "13_エスキモー星雲": "80",
          "14_キャッツアイ星雲": "82",
          "15_卵星雲": "85",
          "16_ひょうたん星雲": "84",
          "17_アルタイル": "90",
          "18_シリウス": "88",
          "19_カノープス": "92",
          "20_ベガ": "90",
          "21_アルデバラン": "93",
          "22_ベテルギウス": "91",
          "23_デネブ": "95",
          "24_惑星スナック": "100",
          "25_サイータ星": "92",
          "26_魁皇星": "94",
          "27_大マゼラン星雲": "97",
          "28_ブータラ星": "90",
          "29_モスカンダグ": "95",
          "30_コロン星": "93",
          "31_ヤキソパーン": "92",
          "32_ウメ星": "94",
          "33_ダラララ": "95",
          "34_マイドムリ": "92",
          "35_メルトズ": "90",
          "36_ウラルー": "93",
          "37_アグハムム": "95",
          "38_ソモロン": "97",
          "39_アバ・ブア": "96",
          "40_ティターン": "98",
          "41_デススタン": "100",
          "42_ゴリラの惑星": "102",
          "43_チョイバトロン星": "100",
          "44_クリムゾン星": "103",
          "45_N77星雲": "97",
          "46_アンドロメダ": "105",
          "47_ブラックホール": "115",
          "48_ビッグバン": "120",
        },
        stageLegend: {
          "01_伝説のはじまり → 01_大地を揺るがす": "50",
          "01_伝説のはじまり → 02_あの恐怖、再び": "50",
          "01_伝説のはじまり → 03_おつかれサンセット": "55",
          "01_伝説のはじまり → 04_メランコリー湿地": "60",
          "01_伝説のはじまり → 05_ぷるるん広場": "60",
          "01_伝説のはじまり → 06_愛情のまなざし": "60",
          "01_伝説のはじまり → 07_牧場の守護者": "70",
          "01_伝説のはじまり → 08_眠れる獅子": "90",
          "02_情熱の国 → 01_ニャンダルシア": "60",
          "02_情熱の国 → 02_パエリア草原": "60",
          "02_情熱の国 → 03_フラメン坑": "65",
          "02_情熱の国 → 04_サングリア川": "70",
          "02_情熱の国 → 05_ガスパチョ高原": "70",
          "02_情熱の国 → 06_チュロス・ナイト": "70",
          "02_情熱の国 → 07_乾いた庭園": "80",
          "02_情熱の国 → 08_タパス砂漠": "100",
          "03_グルコサミン砂漠 → 01_コンドロイチン砂丘": "65",
          "03_グルコサミン砂漠 → 02_セサ民遺跡": "70",
          "03_グルコサミン砂漠 → 03_イソフラボン洞窟": "75",
          "03_グルコサミン砂漠 → 04_カテキン丘陵": "75",
          "03_グルコサミン砂漠 → 05_リコピンの夕焼け": "80",
          "03_グルコサミン砂漠 → 06_プロポリスオアシス": "80",
          "03_グルコサミン砂漠 → 07_ペプチド雪原": "90",
          "03_グルコサミン砂漠 → 08_ヒアルロン山": "120",
          "04_ネコども海を渡る → 01_無茶ぶり進水式": "70",
          "04_ネコども海を渡る → 02_ユーザン海原": "75",
          "04_ネコども海を渡る → 03_人魚の入り江": "75",
          "04_ネコども海を渡る → 04_カオスラグーン": "80",
          "04_ネコども海を渡る → 05_なんちゃって海賊": "80",
          "04_ネコども海を渡る → 06_ホコタテ漁場": "85",
          "04_ネコども海を渡る → 07_テングサ島": "90",
          "04_ネコども海を渡る → 08_海の水は塩辛い": "120",
          "05_見つめてキャッツアイ → 01_ぽろり鉱石": "70",
          "05_見つめてキャッツアイ → 02_セクシー鍾乳洞": "75",
          "05_見つめてキャッツアイ → 03_ドキドキ穴": "80",
          "05_見つめてキャッツアイ → 04_ぷりぷりくぼみ": "90",
          "05_見つめてキャッツアイ → 05_フタこぶ岩": "95",
          "05_見つめてキャッツアイ → 06_スリルの代償": "120",
          "06_ウエスタン街道 → 01_ガンマンの黄昏": "70",
          "06_ウエスタン街道 → 02_カウボーイ天国": "75",
          "06_ウエスタン街道 → 03_お尋ね者の夜": "80",
          "06_ウエスタン街道 → 04_マカロニタウン": "80",
          "06_ウエスタン街道 → 05_さすらいの口笛": "85",
          "06_ウエスタン街道 → 06_がっかり用心棒": "85",
          "06_ウエスタン街道 → 07_テンガロン山": "90",
          "06_ウエスタン街道 → 08_ロデオナイト": "120",
          "07_マグロ海域 → 01_ベニマグロ海岸": "70",
          "07_マグロ海域 → 02_ピチピチ漁場": "75",
          "07_マグロ海域 → 03_ぷらっとオーシャン": "80",
          "07_マグロ海域 → 04_カルパッチョ沖": "80",
          "07_マグロ海域 → 05_排他的経済水域": "85",
          "07_マグロ海域 → 06_最終兵器トロ": "85",
          "07_マグロ海域 → 07_冷凍マグロ戦線": "90",
          "07_マグロ海域 → 08_解体ショー洞窟": "130",
          "08_バンブー島 → 01_チクチク高原": "75",
          "08_バンブー島 → 02_タケノコ海岸": "80",
          "08_バンブー島 → 03_殺人鬼ジャングル": "80",
          "08_バンブー島 → 04_げろげろ沼": "85",
          "08_バンブー島 → 05_もっさり坑道": "85",
          "08_バンブー島 → 06_星くず街道": "90",
          "08_バンブー島 → 07_キノコ崖": "95",
          "08_バンブー島 → 08_暁フロンティア": "120",
          "09_ぷにぷに鍾乳洞 → 01_ミルキートンネル": "75",
          "09_ぷにぷに鍾乳洞 → 02_ふわふわ暗黒兵器": "80",
          "09_ぷにぷに鍾乳洞 → 03_悪魔の壁画": "80",
          "09_ぷにぷに鍾乳洞 → 04_隙間風のささやき": "85",
          "09_ぷにぷに鍾乳洞 → 05_甘えんぼ暗殺者": "85",
          "09_ぷにぷに鍾乳洞 → 06_うろたえる岩": "90",
          "09_ぷにぷに鍾乳洞 → 07_雨漏り洞窟": "110",
          "09_ぷにぷに鍾乳洞 → 08_ぽっちゃり性善説": "140",
          "10_ボルケーノ火山 → 01_半身浴岩": "80",
          "10_ボルケーノ火山 → 02_ほっこり間欠泉": "85",
          "10_ボルケーノ火山 → 03_とろーりマグマ": "100",
          "10_ボルケーノ火山 → 04_炎の檻": "90",
          "10_ボルケーノ火山 → 05_火口を守る者": "120",
          "10_ボルケーノ火山 → 06_メラメラカルデラ": "200",
          "11_千里の道 → 01_ポテンシャルロード": "80",
          "11_千里の道 → 02_憂愁の木": "80",
          "11_千里の道 → 03_そよかぜの歌声": "85",
          "11_千里の道 → 04_哲学の道": "90",
          "11_千里の道 → 05_境界線の晩鐘": "90",
          "11_千里の道 → 06_流した涙の川": "90",
          "11_千里の道 → 07_輝く道": "100",
          "11_千里の道 → 08_試練の谷底": "120",
          "12_アオ・ザ・カナ → 01_磯のささやき": "85",
          "12_アオ・ザ・カナ → 02_サザナミ・アイランド": "90",
          "12_アオ・ザ・カナ → 03_ダークオクトパスの海": "95",
          "12_アオ・ザ・カナ → 04_ポセイドンのこしかけ": "95",
          "12_アオ・ザ・カナ → 05_月明かりのビーチ": "100",
          "12_アオ・ザ・カナ → 06_コーラルサンゴ礁": "100",
          "12_アオ・ザ・カナ → 07_月の箱舟": "110",
          "12_アオ・ザ・カナ → 08_殺戮兵器 シラ・ス": "140",
          "13_軍艦島 → 01_ネギトロ平野": "90",
          "13_軍艦島 → 02_カニミソ草原": "95",
          "13_軍艦島 → 03_イクラ岩窟": "95",
          "13_軍艦島 → 04_ウニ街道": "100",
          "13_軍艦島 → 05_トビコ原生林": "100",
          "13_軍艦島 → 06_納豆海岸": "105",
          "13_軍艦島 → 07_エンガワの森": "110",
          "13_軍艦島 → 08_アマエビフロンティア": "140",
          "14_つめとぎの廊下 → 01_ダンボール回廊": "90",
          "14_つめとぎの廊下 → 02_マタタビの夢": "95",
          "14_つめとぎの廊下 → 03_ガリガリウォール": "100",
          "14_つめとぎの廊下 → 04_木くずを掻き分けて": "110",
          "14_つめとぎの廊下 → 05_バリバリ柱": "115",
          "14_つめとぎの廊下 → 06_乱暴者の番人": "140",
          "15_パルテノン神殿 → 01_ゼウスの祭壇": "90",
          "15_パルテノン神殿 → 02_アキレスの剣": "95",
          "15_パルテノン神殿 → 03_エロスの街道": "100",
          "15_パルテノン神殿 → 04_ガイアの夜明け": "110",
          "15_パルテノン神殿 → 05_アフロディテの門": "125",
          "15_パルテノン神殿 → 06_ハデスの迷宮": "150",
          "16_ずんどこ海水浴場 → 01_潮干狩りの浜": "90",
          "16_ずんどこ海水浴場 → 02_ムツゴロウパーク": "120",
          "16_ずんどこ海水浴場 → 03_水着美女の面影": "95",
          "16_ずんどこ海水浴場 → 04_イモ洗いプール": "100",
          "16_ずんどこ海水浴場 → 05_ビーチパラソル畑": "110",
          "16_ずんどこ海水浴場 → 06_いにしえのビキニ": "115",
          "16_ずんどこ海水浴場 → 07_カラフルカクテル": "130",
          "16_ずんどこ海水浴場 → 08_星降る大海": "145",
          "17_アルカトラズ島 → 01_カモメ海岸": "100",
          "17_アルカトラズ島 → 02_ペリカン島": "105",
          "17_アルカトラズ島 → 03_地下制御室": "110",
          "17_アルカトラズ島 → 04_悪党の密林": "112",
          "17_アルカトラズ島 → 05_バラバラチキンレース": "120",
          "17_アルカトラズ島 → 06_ねこ裁判": "145",
          "17_アルカトラズ島 → 07_監獄草原": "150",
          "17_アルカトラズ島 → 08_看守と墓守": "160",
          "18_脱獄トンネル → 01_茶罪～ギル・ティ～": "100",
          "18_脱獄トンネル → 02_実刑判決": "105",
          "18_脱獄トンネル → 03_ハリートンネル": "110",
          "18_脱獄トンネル → 04_夜のしじま": "115",
          "18_脱獄トンネル → 05_落とし穴地帯": "130",
          "18_脱獄トンネル → 06_大脱走": "160",
          "19_カポネの監獄 → 01_脱獄日誌": "110",
          "19_カポネの監獄 → 02_ラスト・ギャング": "90",
          "19_カポネの監獄 → 03_プリズン・破": "110",
          "19_カポネの監獄 → 04_シャバの王者": "100",
          "19_カポネの監獄 → 05_嘘つきの末路": "120",
          "19_カポネの監獄 → 06_豚小屋のタブー": "140",
          "20_シルクロード → 01_ガンダーラ休憩所": "85",
          "20_シルクロード → 02_ユートピアはあちら": "90",
          "20_シルクロード → 03_ゴダイゴ峠": "100",
          "20_シルクロード → 04_モンキーマジック": "95",
          "20_シルクロード → 05_異国の門": "100",
          "20_シルクロード → 06_マルコ・ポーロード": "100",
          "20_シルクロード → 07_豚の残飯": "95",
          "20_シルクロード → 08_河童の冷や汗": "120",
          "21_闇へと続く地下道 → 01_転ばぬ先の杖": "85",
          "21_闇へと続く地下道 → 02_暗い・狭い・怖い道": "90",
          "21_闇へと続く地下道 → 03_レッド・アラート": "90",
          "21_闇へと続く地下道 → 04_人生の落とし穴": "95",
          "21_闇へと続く地下道 → 05_かすかな晩鐘": "100",
          "21_闇へと続く地下道 → 06_アンダーワールド": "125",
          "22_魔王の豪邸 → 01_セレブな玄関": "85",
          "22_魔王の豪邸 → 02_バスルーム": "90",
          "22_魔王の豪邸 → 03_オシャレVIPルーム": "90",
          "22_魔王の豪邸 → 04_拷問部屋": "50",
          "22_魔王の豪邸 → 05_独裁者の庭": "100",
          "22_魔王の豪邸 → 06_魔王の寝室": "125",
          "23_終わりを告げる夜 → 01_裏切りの宴": "80",
          "23_終わりを告げる夜 → 02_終焉のカタルシス": "85",
          "23_終わりを告げる夜 → 03_黒い予感": "90",
          "23_終わりを告げる夜 → 04_砕けた仮面": "95",
          "23_終わりを告げる夜 → 05_アガペーの檻": "100",
          "23_終わりを告げる夜 → 06_赤いきつねの聖者": "150",
          "24_バトルロワイアル → 01_ロイヤル・ミル・クティ": "80",
          "24_バトルロワイアル → 02_怒りと闘争心": "85",
          "24_バトルロワイアル → 03_忍び寄る戦慄の詩": "85",
          "24_バトルロワイアル → 04_卑怯者の罠": "90",
          "24_バトルロワイアル → 05_闇より生まれし宿敵": "95",
          "24_バトルロワイアル → 06_魚介類と血のにおい": "120",
          "25_戦争のつめあと → 01_ワルキューレ平原": "75",
          "25_戦争のつめあと → 02_ぶっとび地雷原": "80",
          "25_戦争のつめあと → 03_クーゲルシュライバー": "80",
          "25_戦争のつめあと → 04_ぬかるみ塹壕": "85",
          "25_戦争のつめあと → 05_スナイパージャングル": "85",
          "25_戦争のつめあと → 06_斜陽のソルジャー": "90",
          "25_戦争のつめあと → 07_父の背中": "100",
          "25_戦争のつめあと → 08_境界線奪還作戦": "120",
          "26_海を汚す悪しき者 → 01_石油プラットホーム": "75",
          "26_海を汚す悪しき者 → 02_汗とアルデヒド": "80",
          "26_海を汚す悪しき者 → 03_いにしえの裁判": "80",
          "26_海を汚す悪しき者 → 04_あやしい自治体": "85",
          "26_海を汚す悪しき者 → 05_ポイステ海岸": "70",
          "26_海を汚す悪しき者 → 06_ベンゼン畑": "90",
          "26_海を汚す悪しき者 → 07_政府の犬": "95",
          "26_海を汚す悪しき者 → 08_あまくだり海流": "120",
          "27_心と体、繋ぐもの → 01_夕焼けの咆哮": "80",
          "27_心と体、繋ぐもの → 02_ゲシュタルト、崩壊": "90",
          "27_心と体、繋ぐもの → 03_戦士の黎明": "90",
          "27_心と体、繋ぐもの → 04_呪われた永久凍土": "95",
          "27_心と体、繋ぐもの → 05_ねこの証": "95",
          "27_心と体、繋ぐもの → 06_愚者の絶望": "100",
          "27_心と体、繋ぐもの → 07_メタボリック症候群": "110",
          "27_心と体、繋ぐもの → 08_愛と死": "125",
          "28_脆弱性と弱酸性 → 01_せめて、ネコらしく": "100",
          "28_脆弱性と弱酸性 → 02_円卓の騎士": "105",
          "28_脆弱性と弱酸性 → 03_おにゃんこカタルシス": "105",
          "28_脆弱性と弱酸性 → 04_美しい終わり": "110",
          "28_脆弱性と弱酸性 → 05_悪夢からの覚醒": "115",
          "28_脆弱性と弱酸性 → 06_おぼえたての愛": "140",
          "29_導かれしネコ達 → 01_新たなる戦い": "100",
          "29_導かれしネコ達 → 02_ミステリーサークル": "105",
          "29_導かれしネコ達 → 03_野鳥観察": "90",
          "29_導かれしネコ達 → 04_言葉の端のトゲ": "115",
          "29_導かれしネコ達 → 05_ブラックウェーブ": "125",
          "30_暗黒コスモポリス → 01_ハングリーフォレスト": "105",
          "30_暗黒コスモポリス → 02_身の程知らずの巣": "110",
          "30_暗黒コスモポリス → 03_通勤ラッシュ": "90",
          "30_暗黒コスモポリス → 04_ドッキングジェノサイダー": "110",
          "30_暗黒コスモポリス → 05_地下帝国からの刺客": "115",
          "30_暗黒コスモポリス → 06_暗黒街の支配者": "130",
          "31_ガラ・パ・ゴス → 01_DNAとDHA": "110",
          "31_ガラ・パ・ゴス → 02_夕焼けの密猟者": "90",
          "31_ガラ・パ・ゴス → 03_遭難者の群れ": "105",
          "31_ガラ・パ・ゴス → 04_異星生態調査団": "110",
          "31_ガラ・パ・ゴス → 05_楽園のいきもの達": "115",
          "31_ガラ・パ・ゴス → 06_環境保護団体": "130",
          "32_岩海苔半島 → 01_りんりん防風林": "105",
          "32_岩海苔半島 → 02_イベリコ平野": "95",
          "32_岩海苔半島 → 03_泣き砂海岸": "110",
          "32_岩海苔半島 → 04_ゴールデン街": "105",
          "32_岩海苔半島 → 05_鈍足ドライブウェイ": "115",
          "32_岩海苔半島 → 06_武家屋敷お家騒動": "135",
          "33_恐ろし連邦 → 01_クリムゾン広場": "110",
          "33_恐ろし連邦 → 02_インテリゲンチャ": "115",
          "33_恐ろし連邦 → 03_ポッポー領土": "70",
          "33_恐ろし連邦 → 04_バトル海の決戦": "110",
          "33_恐ろし連邦 → 05_宇宙開発局": "120",
          "33_恐ろし連邦 → 06_スパイより愛を込めて": "135",
          "34_亡者の住まう地 → 01_死霊の館": "110",
          "34_亡者の住まう地 → 02_いけにえ沼": "115",
          "34_亡者の住まう地 → 03_ムール街の悪夢": "120",
          "34_亡者の住まう地 → 04_ポルターガイストリート": "110",
          "34_亡者の住まう地 → 05_ホワイト・ライト・ナイト": "120",
          "34_亡者の住まう地 → 06_猫たちの沈黙": "140",
          "35_絶島パンデミック → 01_感染者密航": "110",
          "35_絶島パンデミック → 02_ハイテク昆布漁": "120",
          "35_絶島パンデミック → 03_先祖の行進": "105",
          "35_絶島パンデミック → 04_脱出を阻む者": "115",
          "35_絶島パンデミック → 05_怒りのマグロ戦線": "125",
          "35_絶島パンデミック → 06_感染、島の主": "140",
          "36_ふくろのねずみランド → 01_お出迎え入場門": "120",
          "36_ふくろのねずみランド → 02_無気力コースター": "110",
          "36_ふくろのねずみランド → 03_リアルVR地獄": "125",
          "36_ふくろのねずみランド → 04_プラス50度の世界": "115",
          "36_ふくろのねずみランド → 05_誘惑のチキンルーム": "130",
          "36_ふくろのねずみランド → 06_ボーンデッドアパートメント": "145",
          "37_ハリーウッド帝国 → 01_パパラッチフィーバー": "125",
          "37_ハリーウッド帝国 → 02_因縁ゴシップスター": "130",
          "37_ハリーウッド帝国 → 03_バブリーヒルズ白書": "115",
          "37_ハリーウッド帝国 → 04_子役上がり": "130",
          "37_ハリーウッド帝国 → 05_セクシースキャンダル": "120",
          "37_ハリーウッド帝国 → 06_ウニバーサンスタジオ": "160",
          "38_こしぎんちゃくの浜辺 → 01_よたもの遊泳大会": "135",
          "38_こしぎんちゃくの浜辺 → 02_ヘアーサロン潮風": "140",
          "38_こしぎんちゃくの浜辺 → 03_ディープシー決死隊": "120",
          "38_こしぎんちゃくの浜辺 → 04_ぺこぺこパレード": "135",
          "38_こしぎんちゃくの浜辺 → 05_大御所大博覧会": "140",
          "38_こしぎんちゃくの浜辺 → 06_もう陸には帰れない": "150",
          "39_雲泥温泉郷 → 01_自家製電気風呂": "140",
          "39_雲泥温泉郷 → 02_熱湯風呂我慢大会": "145",
          "39_雲泥温泉郷 → 03_ケミカル長寿の湯": "135",
          "39_雲泥温泉郷 → 04_垢い敵、黒い汗": "135",
          "39_雲泥温泉郷 → 05_源泉に潜む者達": "145",
          "39_雲泥温泉郷 → 06_湯けむり極楽地獄": "160",
          "40_風待ちアイランド → 01_むっちり隠れ港": "140",
          "40_風待ちアイランド → 02_ロマンスグレーハイウェイ": "150",
          "40_風待ちアイランド → 03_泥酔マッサージャー": "140",
          "40_風待ちアイランド → 04_豚箱恋愛沼": "150",
          "40_風待ちアイランド → 05_フェロモン門": "155",
          "40_風待ちアイランド → 06_天空秘宝の館": "165",
          "41_ITカタコンベ → 01_キリバンの番人": "150",
          "41_ITカタコンベ → 02_ダイヤルアップ回廊": "160",
          "41_ITカタコンベ → 03_テレホー台座": "100",
          "41_ITカタコンベ → 04_Mrs.ドスの墓": "155",
          "41_ITカタコンベ → 05_聖人ブラクラの遺骨": "160",
          "41_ITカタコンベ → 06_怨叫カプラ": "175",
          "42_変覧会の絵 → 01_ヘタうまキュビズム": "150",
          "42_変覧会の絵 → 02_癒し系地獄絵図": "155",
          "42_変覧会の絵 → 03_和尚のスケベな水墨画": "150",
          "42_変覧会の絵 → 04_一筆三億五千万円": "145",
          "42_変覧会の絵 → 05_ヤンキー宗教画": "155",
          "42_変覧会の絵 → 06_館長の自画像": "175",
          "43_エリア22 → 01_ローズウェイ事件": "160",
          "43_エリア22 → 02_キャットミューティレーション": "155",
          "43_エリア22 → 03_マダムスキー型UFO": "155",
          "43_エリア22 → 04_チュパチュパカブラ遭遇": "150",
          "43_エリア22 → 05_グースカツンツン大爆発": "160",
          "43_エリア22 → 06_あなた疲れてるのよ": "180",
          "44_超越サバンナ → 01_弱肉朝食": "165",
          "44_超越サバンナ → 02_霊峰ニクマンジャロ": "160",
          "44_超越サバンナ → 03_原始の強敵、再び": "150",
          "44_超越サバンナ → 04_ウキウキ乾季": "160",
          "44_超越サバンナ → 05_エレクトロサファリパーク": "170",
          "44_超越サバンナ → 06_天国に一番近い水飲み場": "185",
          "45_ブリザード自動車道 → 01_あかぎれジャンクション": "170",
          "45_ブリザード自動車道 → 02_ダダ洩れ海底トンネル": "160",
          "45_ブリザード自動車道 → 03_しもやけパーキングエリア": "150",
          "45_ブリザード自動車道 → 04_ぬくもり対向車線": "165",
          "45_ブリザード自動車道 → 05_眠眠交通警備隊": "175",
          "45_ブリザード自動車道 → 06_料金所ヒートショック": "190",
          "46_シンギュラリティ村 → 01_ユビキタス販売所": "175",
          "46_シンギュラリティ村 → 02_VR稲刈り場": "165",
          "46_シンギュラリティ村 → 03_ウェアラブル一軒家": "155",
          "46_シンギュラリティ村 → 04_8K肥溜め": "165",
          "46_シンギュラリティ村 → 05_夕焼けブロックチェーン": "180",
          "46_シンギュラリティ村 → 06_ゲノム盆踊り": "190",
          "47_オワーリ大陸 → 01_最果ての祠": "180",
          "47_オワーリ大陸 → 02_終末の谷": "160",
          "47_オワーリ大陸 → 03_ファイナルタワー": "160",
          "47_オワーリ大陸 → 04_ラストラビリンス": "170",
          "47_オワーリ大陸 → 05_終焉の洞窟": "180",
          "47_オワーリ大陸 → 06_フィナーレ神殿": "200",
          "48_伝説のおわり → 01_決断の時": "190",
          "48_伝説のおわり → 02_復讐の準備": "170",
          "48_伝説のおわり → 03_栄光のグローリー": "170",
          "48_伝説のおわり → 04_命のせせらぎ": "180",
          "48_伝説のおわり → 05_復活の偽呪文": "180",
          "48_伝説のおわり → 06_契約の杯": "190",
          "48_伝説のおわり → 07_風そよぐ黄昏時": "200",
          "48_伝説のおわり → 08_破られた誓い": "800",
          "49_古代研究所 → 01_太古の力": "200",
        },
      },
      stageList: {
        stageJP01: {
          en: "Empire of Cats 1",
          ct: "世界篇第1章",
          jp: "日本編第1章",
        },
        stageJP02: {
          en: "Empire of Cats 2",
          ct: "世界篇第2章",
          jp: "日本編第2章",
        },
        stageJP03: {
          en: "Empire of Cats 3",
          ct: "世界篇第3章",
          jp: "日本編第3章",
        },
        stageFuture01: {
          en: "Into The Future 1",
          ct: "未來篇第1章",
          jp: "未来編第1章",
        },
        stageFuture02: {
          en: "Into The Future 2",
          ct: "未來篇第2章",
          jp: "未来編第2章",
        },
        stageFuture03: {
          en: "Into The Future 3",
          ct: "未來篇第3章",
          jp: "未来編第3章",
        },
        stageUniverse01: {
          en: "Cats of the Cosmos Chapter 1",
          ct: "宇宙篇第1章",
          jp: "宇宙編第1章",
        },
        stageUniverse02: {
          en: "Cats of the Cosmos Chapter 2",
          ct: "宇宙篇第2章",
          jp: "宇宙編第2章",
        },
        stageUniverse03: {
          en: "Cats of the Cosmos Chapter 3",
          ct: "宇宙篇第3章",
          jp: "宇宙編第3章",
        },
        stageLegend: {
          en: "Legend Stages",
          ct: "傳奇關卡",
          jp: "レジェンドステージ",
        },
      },
      comboBoxStageList: {
        stageJP01: {
          name: "世界篇第1章",
        },
        stageJP02: {
          name: "世界篇第2章",
        },
        stageJP03: {
          name: "世界篇第3章",
        },
        stageFuture01: {
          name: "未來篇第1章",
        },
        stageFuture02: {
          name: "未來篇第2章",
        },
        stageFuture03: {
          name: "未來篇第3章",
        },
        stageUniverse01: {
          name: "宇宙篇第1章",
        },
        stageUniverse02: {
          name: "宇宙篇第2章",
        },
        stageUniverse03: {
          name: "宇宙篇第3章",
        },
        stageLegend: {
          name: "傳奇關卡",
        },
      },
      enemyList: {
        id_002: {
          id: "id_002",
          imgSrc: require("../img/enemyImg/enemy_icon_000.png"),
          ctName: "狗仔",
          jpName: "わんこ",
          enName: "Doge",
          type: "白色敵人",
        },
        id_003: {
          id: "id_003",
          imgSrc: require("../img/enemyImg/enemy_icon_001.png"),
          ctName: "扭扭蛇",
          jpName: "にょろ",
          enName: "Snache",
          type: "白色敵人",
        },
        id_004: {
          id: "id_004",
          imgSrc: require("../img/enemyImg/enemy_icon_002.png"),
          ctName: "團結筷子幫",
          jpName: "例のヤツ",
          enName: "Those Guys",
          type: "白色敵人",
        },
        id_005: {
          id: "id_005",
          imgSrc: require("../img/enemyImg/enemy_icon_003.png"),
          ctName: "河馬將",
          jpName: "カバ ちゃん",
          enName: "Hippoe",
          type: "白色敵人",
        },
        id_006: {
          id: "id_006",
          imgSrc: require("../img/enemyImg/enemy_icon_004.png"),
          ctName: "豬野郎",
          jpName: "ブタヤロウ",
          enName: "Pigge",
          type: "紅色敵人",
        },
        id_007: {
          id: "id_007",
          imgSrc: require("../img/enemyImg/enemy_icon_005.png"),
          ctName: "企鵝大哥",
          jpName: "ジャッキー・ペン",
          enName: "Jackie Peng",
          type: "白色敵人",
        },
        id_008: {
          id: "id_008",
          imgSrc: require("../img/enemyImg/enemy_icon_006.png"),
          ctName: "大猩猩",
          jpName: "ゴリさん",
          enName: "Gory",
          type: "白色敵人",
        },
        id_009: {
          id: "id_009",
          imgSrc: require("../img/enemyImg/enemy_icon_007.png"),
          ctName: "咩咩",
          jpName: "メェメェ",
          enName: "Baa Baa",
          type: "白色敵人",
        },
        id_010: {
          id: "id_010",
          imgSrc: require("../img/enemyImg/enemy_icon_008.png"),
          ctName: "斑海豹桑",
          jpName: "ゴマさま",
          enName: "Sir Seal",
          type: "紅色敵人",
        },
        id_011: {
          id: "id_011",
          imgSrc: require("../img/enemyImg/enemy_icon_009.png"),
          ctName: "澎湃",
          jpName: "パオン",
          enName: "Le'boin",
          type: "白色敵人",
        },
        id_012: {
          id: "id_012",
          imgSrc: require("../img/enemyImg/enemy_icon_010.png"),
          ctName: "袋拳",
          jpName: "カ・ンガリュ",
          enName: "Kang Roo",
          type: "白色敵人",
        },
        id_013: {
          id: "id_013",
          imgSrc: require("../img/enemyImg/enemy_icon_011.png"),
          ctName: "一角君",
          jpName: "一角くん",
          enName: "One Horn",
          type: "紅色敵人",
        },
        id_014: {
          id: "id_014",
          imgSrc: require("../img/enemyImg/enemy_icon_012.png"),
          ctName: "熊熊老師",
          jpName: "クマ先生",
          enName: "Teacher Bear",
          type: "白色敵人",
        },
        id_015: {
          id: "id_015",
          imgSrc: require("../img/enemyImg/enemy_icon_013.png"),
          ctName: "鱷魚宅宅",
          jpName: "ワニック",
          enName: "Croco",
          type: "白色敵人",
        },
        id_016: {
          id: "id_016",
          imgSrc: require("../img/enemyImg/enemy_icon_014.png"),
          ctName: "臭老兔",
          jpName: "ウサ銀",
          enName: "B.B.Bunny",
          type: "紅色敵人",
        },
        id_017: {
          id: "id_017",
          imgSrc: require("../img/enemyImg/enemy_icon_015.png"),
          ctName: "松鼠阿嘎",
          jpName: "リッスントゥミー",
          enName: "Squire Rel",
          type: "白色敵人",
        },
        id_018: {
          id: "id_018",
          imgSrc: require("../img/enemyImg/enemy_icon_016.png"),
          ctName: "黑熊",
          jpName: "ブラックマ",
          enName: "Assassin Bear",
          type: "黑色敵人",
        },
        id_019: {
          id: "id_019",
          imgSrc: require("../img/enemyImg/enemy_icon_017.png"),
          ctName: "赤面歌王",
          jpName: "赤羅我王",
          enName: "Shy Boy",
          type: '紅色敵人, <a href="enemies.aspx?attribute_id=5"',
        },
        id_020: {
          id: "id_020",
          imgSrc: require("../img/enemyImg/enemy_icon_018.png"),
          ctName: "臉君",
          jpName: "カオル君",
          enName: "The Face",
          type: "漂浮敵人",
        },
        id_023: {
          id: "id_023",
          imgSrc: require("../img/enemyImg/enemy_icon_021.png"),
          ctName: "看板小妹",
          jpName: "カンバン娘",
          enName: "Ms. Sign",
          type: "白色敵人",
        },
        id_024: {
          id: "id_024",
          imgSrc: require("../img/enemyImg/enemy_icon_022.png"),
          ctName: "蛾蛾蛾蛾",
          jpName: "ガガガガ",
          enName: "Mooth",
          type: "漂浮敵人",
        },
        id_025: {
          id: "id_025",
          imgSrc: require("../img/enemyImg/enemy_icon_023.png"),
          ctName: "惡之帝王貓彈",
          jpName: "悪 の帝王ニャンダム",
          enName: "Dark Emperor Nyandam",
          type: "紅色敵人",
        },
        id_026: {
          id: "id_026",
          imgSrc: require("../img/enemyImg/enemy_icon_024.png"),
          ctName: "噴噴老師",
          jpName: "ぶんぶん先生",
          enName: "Teacher Bun Bun",
          type: "漂浮敵人",
        },
        id_027: {
          id: "id_027",
          imgSrc: require("../img/enemyImg/enemy_icon_025.png"),
          ctName: "劍客",
          jpName: "剣士",
          enName: "Swordsman",
          type: "白色敵人",
        },
        id_028: {
          id: "id_028",
          imgSrc: require("../img/enemyImg/enemy_icon_026.png"),
          ctName: "小暴龍",
          jpName: "ガウガウ",
          enName: "Chibigau",
          type: "白色敵人",
        },
        id_029: {
          id: "id_029",
          imgSrc: require("../img/enemyImg/enemy_icon_027.png"),
          ctName: "飛踢公主",
          jpName: "ケリ姫",
          enName: "Princess Punt",
          type: "白色敵人",
        },
        id_030: {
          id: "id_030",
          imgSrc: require("../img/enemyImg/enemy_icon_028.png"),
          ctName: "劍客",
          jpName: "剣士",
          enName: "Swordsman",
          type: "白色敵人",
        },
        id_031: {
          id: "id_031",
          imgSrc: require("../img/enemyImg/enemy_icon_029.png"),
          ctName: "小暴龍",
          jpName: "ガウガウ",
          enName: "Chibigau",
          type: "白色敵人",
        },
        id_032: {
          id: "id_032",
          imgSrc: require("../img/enemyImg/enemy_icon_030.png"),
          ctName: "飛踢公主",
          jpName: "ケリ姫",
          enName: "Princess Punt",
          type: "白色敵人",
        },
        id_033: {
          id: "id_033",
          imgSrc: require("../img/enemyImg/enemy_icon_031.png"),
          ctName: "師匠",
          jpName: "師匠",
          enName: "Master A.",
          type: "白色敵人",
        },
        id_034: {
          id: "id_034",
          imgSrc: require("../img/enemyImg/enemy_icon_032.png"),
          ctName: "鴕鳥愛美惠",
          jpName: "ダチョウ同好会",
          enName: "R. Ost",
          type: "白色敵人",
        },
        id_035: {
          id: "id_035",
          imgSrc: require("../img/enemyImg/enemy_icon_033.png"),
          ctName: "破壞一族",
          jpName: "フルぼっこ",
          enName: "Otta-smack-u",
          type: "白色敵人",
        },
        id_036: {
          id: "id_036",
          imgSrc: require("../img/enemyImg/enemy_icon_034.png"),
          ctName: "無尾熊球",
          jpName: "コアラッキョ",
          enName: "Kory",
          type: "白色敵人",
        },
        id_037: {
          id: "id_037",
          imgSrc: require("../img/enemyImg/enemy_icon_035.png"),
          ctName: "駝背",
          jpName: "こぶへい",
          enName: "Camelle",
          type: "白色敵人",
        },
        id_038: {
          id: "id_038",
          imgSrc: require("../img/enemyImg/enemy_icon_036.png"),
          ctName: "鴨子倫倫",
          jpName: "アヒルンルン",
          enName: "Duche",
          type: "白色敵人",
        },
        id_039: {
          id: "id_039",
          imgSrc: require("../img/enemyImg/enemy_icon_037.png"),
          ctName: "眉毛鳥",
          jpName: "まゆげどり",
          enName: "Owlbrow",
          type: "漂浮敵人",
        },
        id_040: {
          id: "id_040",
          imgSrc: require("../img/enemyImg/enemy_icon_038.png"),
          ctName: "獅豬",
          jpName: "イノシャシ",
          enName: "Bore",
          type: "紅色敵人",
        },
        id_041: {
          id: "id_041",
          imgSrc: require("../img/enemyImg/enemy_icon_039.png"),
          ctName: "樹懶賴",
          jpName: "ナマルケモルル",
          enName: "The Sloth",
          type: "白色敵 人",
        },
        id_042: {
          id: "id_042",
          imgSrc: require("../img/enemyImg/enemy_icon_040.png"),
          ctName: "粥董",
          jpName: "ナカイくん",
          enName: "Rain D.",
          type: "白色敵人",
        },
        id_043: {
          id: "id_043",
          imgSrc: require("../img/enemyImg/enemy_icon_041.png"),
          ctName: "拉腸狗",
          jpName: "だっふんど",
          enName: "Dagshund",
          type: "白色敵人",
        },
        id_044: {
          id: "id_044",
          imgSrc: require("../img/enemyImg/enemy_icon_042.png"),
          ctName: "貴賓",
          jpName: "セレブ",
          enName: "Celeboodle",
          type: "白色敵人",
        },
        id_045: {
          id: "id_045",
          imgSrc: require("../img/enemyImg/enemy_icon_043.png"),
          ctName: "鬣狼",
          jpName: "ハイ・エナジー",
          enName: "H. Nah",
          type: "白色敵人",
        },
        id_046: {
          id: "id_046",
          imgSrc: require("../img/enemyImg/enemy_icon_044.png"),
          ctName: "瀟灑哥",
          jpName: "ダディ",
          enName: "Dober P.D",
          type: "白色敵人",
        },
        id_047: {
          id: "id_047",
          imgSrc: require("../img/enemyImg/enemy_icon_045.png"),
          ctName: "狼與少女",
          jpName: "ウルフとウルルン",
          enName: "Ururun Wolf",
          type: "白色敵人",
        },
        id_048: {
          id: "id_048",
          imgSrc: require("../img/enemyImg/enemy_icon_046.png"),
          ctName: "殺意狗",
          jpName: "殺意のわんこ",
          enName: "Doge Dark",
          type: "黑色敵人",
        },
        id_049: {
          id: "id_049",
          imgSrc: require("../img/enemyImg/enemy_icon_047.png"),
          ctName: "鋼鐵河馬將",
          jpName: "メタルカバちゃん",
          enName: "Metal Hippoe",
          type: "鋼鐵敵人",
        },
        id_050: {
          id: "id_050",
          imgSrc: require("../img/enemyImg/enemy_icon_048.png"),
          ctName: "伊麗莎白2世",
          jpName: "エリザベス2世",
          enName: "St. Pigge the 2nd",
          type: "紅色敵人",
        },
        id_051: {
          id: "id_051",
          imgSrc: require("../img/enemyImg/enemy_icon_049.png"),
          ctName: "赤井噴太郎",
          jpName: "赤井ブン太郎",
          enName: "J.K Bun Bun",
          type: '紅色敵人, <a href="enemies.aspx?attribute_id=5"',
        },
        id_052: {
          id: "id_052",
          imgSrc: require("../img/enemyImg/enemy_icon_050.png"),
          ctName: "黑色噴噴",
          jpName: "ブラックブンブン",
          enName: "Bun Bun Black",
          type: '黑色敵人, <a href="enemies.aspx?attribute_id=5"',
        },
        id_053: {
          id: "id_053",
          imgSrc: require("../img/enemyImg/enemy_icon_051.png"),
          ctName: "黑猩猩",
          jpName: "ブラッゴリ",
          enName: "Gory Black",
          type: "黑色敵人",
        },
        id_054: {
          id: "id_054",
          imgSrc: require("../img/enemyImg/enemy_icon_052.png"),
          ctName: "影子拳擊手",
          jpName: "シャドウボクサー",
          enName: "Shadow Boxer K",
          type: "黑色敵人",
        },
        id_055: {
          id: "id_055",
          imgSrc: require("../img/enemyImg/enemy_icon_053.png"),
          ctName: "黑澤導演",
          jpName: "クロサワ監督",
          enName: "Director Kurosawah",
          type: "黑色敵人",
        },
        id_056: {
          id: "id_056",
          imgSrc: require("../img/enemyImg/enemy_icon_054.png"),
          ctName: "超級鋼鐵河馬將",
          jpName: "超メタルカバちゃん",
          enName: "Super Metal Hippoe",
          type: "鋼鐵敵人",
        },
        id_057: {
          id: "id_057",
          imgSrc: require("../img/enemyImg/enemy_icon_055.png"),
          ctName: "10式戰車",
          jpName: "10式戦車",
          enName: "Type 10",
          type: "鋼鐵敵人",
        },
        id_058: {
          id: "id_058",
          imgSrc: require("../img/enemyImg/enemy_icon_056.png"),
          ctName: "鋼鐵犀一角",
          jpName: "メタルサイボーグ",
          enName: "Metal One Horn",
          type: "鋼鐵敵人",
        },
        id_059: {
          id: "id_059",
          imgSrc: require("../img/enemyImg/enemy_icon_057.png"),
          ctName: "鋼鐵熊",
          jpName: "メタックマ",
          enName: "Teacher Cybear",
          type: "鋼鐵敵人",
        },
        id_060: {
          id: "id_060",
          imgSrc: require("../img/enemyImg/enemy_icon_058.png"),
          ctName: "鋼鐵臉君",
          jpName: "メタルカオ ル君",
          enName: "CyberFace",
          type: "鋼鐵敵人",
        },
        id_061: {
          id: "id_061",
          imgSrc: require("../img/enemyImg/enemy_icon_059.png"),
          ctName: "鋼鐵斑海豹桑",
          jpName: "メタルゴマさま",
          enName: "Sir Metal Seal",
          type: "鋼鐵敵人",
        },
        id_062: {
          id: "id_062",
          imgSrc: require("../img/enemyImg/enemy_icon_060.png"),
          ctName: "幽靈鷙",
          jpName: "ユーリンチー",
          enName: "Yuurinchii",
          type: "漂浮敵人",
        },
        id_063: {
          id: "id_063",
          imgSrc: require("../img/enemyImg/enemy_icon_061.png"),
          ctName: "超魅惑公主",
          jpName: "プリンセスカオル",
          enName: "Princess Head",
          type: "漂浮敵人",
        },
        id_064: {
          id: "id_064",
          imgSrc: require("../img/enemyImg/enemy_icon_062.png"),
          ctName: "企課長",
          jpName: "ペ課長",
          enName: "Chief Peng",
          type: "白色敵人",
        },
        id_065: {
          id: "id_065",
          imgSrc: require("../img/enemyImg/enemy_icon_063.png"),
          ctName: "黑暗皇帝聖誕老人",
          jpName: "悪魔王サンタ",
          enName: "Dark Emperor Santa",
          type: "紅色敵人",
        },
        id_066: {
          id: "id_066",
          imgSrc: require("../img/enemyImg/enemy_icon_064.png"),
          ctName: "赤色旋風",
          jpName: "レッドサイクロン",
          enName: "Red Cyclone",
          type: '紅色敵人, <a href="enemies.aspx?attribute_id=5"',
        },
        id_067: {
          id: "id_067",
          imgSrc: require("../img/enemyImg/enemy_icon_065.png"),
          ctName: "河馬開口獅",
          jpName: "獅子カバブー",
          enName: "Lione Hippoe",
          type: "白色敵人",
        },
        id_068: {
          id: "id_068",
          imgSrc: require("../img/enemyImg/enemy_icon_066.png"),
          ctName: "福神",
          jpName: "福の神",
          enName: "Lucky Sloth",
          type: "白色敵人",
        },
        id_069: {
          id: "id_069",
          imgSrc: require("../img/enemyImg/enemy_icon_067.png"),
          ctName: "熊熊敢死隊",
          jpName: "クマトーク",
          enName: "Audience Bears",
          type: "白色敵人",
        },
        id_070: {
          id: "id_070",
          imgSrc: require("../img/enemyImg/enemy_icon_068.png"),
          ctName: "猿王",
          jpName: "猿王",
          enName: "Monkey King",
          type: "白色敵人",
        },
        id_071: {
          id: "id_071",
          imgSrc: require("../img/enemyImg/enemy_icon_069.png"),
          ctName: "白色旋風",
          jpName: "ホワイトサイクロン",
          enName: "White Cyclone",
          type: "漂浮敵人",
        },
        id_072: {
          id: "id_072",
          imgSrc: require("../img/enemyImg/enemy_icon_070.png"),
          ctName: "黑色旋風",
          jpName: "ブラックサイクロン",
          enName: "Black Cyclone",
          type: '黑色敵人, <a href="enemies.aspx?attribute_id=5"',
        },
        id_073: {
          id: "id_073",
          imgSrc: require("../img/enemyImg/enemy_icon_071.png"),
          ctName: "鋼鐵 旋風",
          jpName: "メタルサイクロン",
          enName: "Metal Cyclone",
          type: "鋼鐵敵人",
        },
        id_074: {
          id: "id_074",
          imgSrc: require("../img/enemyImg/enemy_icon_072.png"),
          ctName: "妮妙",
          jpName: "ニムエ",
          enName: "Nimue",
          type: "漂浮敵人",
        },
        id_075: {
          id: "id_075",
          imgSrc: require("../img/enemyImg/enemy_icon_073.png"),
          ctName: "歸化型妮妙",
          jpName: "帰化型ニムエ",
          enName: "Neutralization Type Nimue",
          type: "漂浮敵人",
        },
        id_076: {
          id: "id_076",
          imgSrc: require("../img/enemyImg/enemy_icon_074.png"),
          ctName: "SSS猿王",
          jpName: "SSS猿王",
          enName: "SSS Monkey King",
          type: "白色敵人",
        },
        id_077: {
          id: "id_077",
          imgSrc: require("../img/enemyImg/enemy_icon_075.png"),
          ctName: "狂亂貓",
          jpName: "狂乱のネコ",
          enName: "Crazed Cat",
          type: "白色敵人",
        },
        id_078: {
          id: "id_078",
          imgSrc: require("../img/enemyImg/enemy_icon_076.png"),
          ctName: "狂亂坦克貓",
          jpName: "狂乱のタンクネコ",
          enName: "Crazed Tank Cat",
          type: "白色敵人",
        },
        id_079: {
          id: "id_079",
          imgSrc: require("../img/enemyImg/enemy_icon_077.png"),
          ctName: "狂亂戰鬥貓",
          jpName: "狂乱のバトルネコ",
          enName: "Crazed Axe Cat",
          type: "白色敵人",
        },
        id_080: {
          id: "id_080",
          imgSrc: require("../img/enemyImg/enemy_icon_078.png"),
          ctName: "狂亂噁心貓",
          jpName: "狂乱のキモネコ",
          enName: "Crazed Gross Cat",
          type: "白色敵人",
        },
        id_081: {
          id: "id_081",
          imgSrc: require("../img/enemyImg/enemy_icon_079.png"),
          ctName: "狂亂牛 貓",
          jpName: "狂乱のウシネコ",
          enName: "Crazed Cow Cat",
          type: "白色敵人",
        },
        id_082: {
          id: "id_082",
          imgSrc: require("../img/enemyImg/enemy_icon_080.png"),
          ctName: "狂亂鳥貓",
          jpName: "狂乱のネ コノトリ",
          enName: "Crazed Bird Cat",
          type: "漂浮敵人",
        },
        id_083: {
          id: "id_083",
          imgSrc: require("../img/enemyImg/enemy_icon_081.png"),
          ctName: "狂亂魚貓",
          jpName: "狂乱のネコフィッシュ",
          enName: "Crazed Fish Cat",
          type: "白色敵人",
        },
        id_084: {
          id: "id_084",
          imgSrc: require("../img/enemyImg/enemy_icon_082.png"),
          ctName: "狂亂蜥蝪貓",
          jpName: "狂乱のネコトカゲ",
          enName: "Crazed Lizard Cat",
          type: "白色敵人",
        },
        id_085: {
          id: "id_085",
          imgSrc: require("../img/enemyImg/enemy_icon_083.png"),
          ctName: "狂亂巨神貓",
          jpName: "狂乱の巨神ネコ",
          enName: "Crazed Titan Cat",
          type: "白色敵人",
        },
        id_086: {
          id: "id_086",
          imgSrc: require("../img/enemyImg/enemy_icon_084.png"),
          ctName: "高校教師",
          jpName: "高校教師",
          enName: "Teacher A.",
          type: "白色敵人",
        },
        id_087: {
          id: "id_087",
          imgSrc: require("../img/enemyImg/enemy_icon_085.png"),
          ctName: "武者狗仔",
          jpName: "武者わんこ",
          enName: "Samurai Doggy",
          type: '紅色敵人, <a href="enemies.aspx?attribute_id=4"',
        },
        id_088: {
          id: "id_088",
          imgSrc: require("../img/enemyImg/enemy_icon_086.png"),
          ctName: "歌后貓",
          jpName: "メガにゃんこ",
          enName: "Mega Cat",
          type: "鋼鐵敵人",
        },
        id_089: {
          id: "id_089",
          imgSrc: require("../img/enemyImg/enemy_icon_087.png"),
          ctName: "大猩猩女婿",
          jpName: "ゴリ婿",
          enName: "Gory Groom",
          type: "黑色敵人",
        },
        id_090: {
          id: "id_090",
          imgSrc: require("../img/enemyImg/enemy_icon_088.png"),
          ctName: "賽蕾絲",
          jpName: "セレス",
          enName: "Celesse",
          type: "漂浮敵人",
        },
        id_091: {
          id: "id_091",
          imgSrc: require("../img/enemyImg/enemy_icon_089.png"),
          ctName: "諾諾",
          jpName: "ノノ",
          enName: "Nono",
          type: "白色敵人",
        },
        id_092: {
          id: "id_092",
          imgSrc: require("../img/enemyImg/enemy_icon_090.png"),
          ctName: "奧爾加",
          jpName: "オルガ",
          enName: "Olga",
          type: "白色敵人",
        },
        id_093: {
          id: "id_093",
          imgSrc: require("../img/enemyImg/enemy_icon_091.png"),
          ctName: "諾倫",
          jpName: "ノルン",
          enName: "Norun",
          type: "白色敵人",
        },
        id_094: {
          id: "id_094",
          imgSrc: require("../img/enemyImg/enemy_icon_092.png"),
          ctName: "優依",
          jpName: "よいち",
          enName: "Yoichi",
          type: "白色敵人",
        },
        id_095: {
          id: "id_095",
          imgSrc: require("../img/enemyImg/enemy_icon_093.png"),
          ctName: "賽拉姆",
          jpName: "セラム",
          enName: "Serum",
          type: "漂浮敵人",
        },
        id_096: {
          id: "id_096",
          imgSrc: require("../img/enemyImg/enemy_icon_094.png"),
          ctName: "弗舞",
          jpName: "フウ",
          enName: "Fuu",
          type: "漂浮 敵人",
        },
        id_097: {
          id: "id_097",
          imgSrc: require("../img/enemyImg/enemy_icon_095.png"),
          ctName: "阿烏拉",
          jpName: "アウラ",
          enName: "Aura",
          type: "白色敵人",
        },
        id_098: {
          id: "id_098",
          imgSrc: require("../img/enemyImg/enemy_icon_096.png"),
          ctName: "雷依",
          jpName: "レイ",
          enName: "Rei",
          type: "漂浮敵人",
        },
        id_099: {
          id: "id_099",
          imgSrc: require("../img/enemyImg/enemy_icon_097.png"),
          ctName: "飛翼龍",
          jpName: "ワイバーン",
          enName: "Wyvern",
          type: "漂浮敵人",
        },
        id_100: {
          id: "id_100",
          imgSrc: require("../img/enemyImg/enemy_icon_098.png"),
          ctName: "癒術士",
          jpName: "癒術士",
          enName: "More Warlock",
          type: "白色敵人",
        },
        id_101: {
          id: "id_101",
          imgSrc: require("../img/enemyImg/enemy_icon_099.png"),
          ctName: "陽傘貴賓",
          jpName: "夏セレブ",
          enName: "Sunny Celeboodle",
          type: "白色敵人",
        },
        id_102: {
          id: "id_102",
          imgSrc: require("../img/enemyImg/enemy_icon_100.png"),
          ctName: "比基尼熊熊",
          jpName: "ビキニグマ",
          enName: "Bearkini",
          type: "白色敵人",
        },
        id_103: {
          id: "id_103",
          imgSrc: require("../img/enemyImg/enemy_icon_101.png"),
          ctName: "閻魔王",
          jpName: "閻 魔大王",
          enName: "Lord Enma",
          type: "紅色敵人",
        },
        id_104: {
          id: "id_104",
          imgSrc: require("../img/enemyImg/enemy_icon_102.png"),
          ctName: "奔跑君",
          jpName: "ハシル君",
          enName: "Leggsy",
          type: "白色敵人",
        },
        id_105: {
          id: "id_105",
          imgSrc: require("../img/enemyImg/enemy_icon_103.png"),
          ctName: "幽靈狗",
          jpName: "ゴーストわんこ",
          enName: "Ecto Doge",
          type: "漂浮敵人",
        },
        id_106: {
          id: "id_106",
          imgSrc: require("../img/enemyImg/enemy_icon_104.png"),
          ctName: "幽靈扭扭蛇",
          jpName: "ゴーストにょろ",
          enName: "Ecto Snache",
          type: "漂浮敵人",
        },
        id_107: {
          id: "id_107",
          imgSrc: require("../img/enemyImg/enemy_icon_105.png"),
          ctName: "幽靈咩咩",
          jpName: "ゴーストメェメェ",
          enName: "Ecto Baa Baa",
          type: "漂浮敵人",
        },
        id_108: {
          id: "id_108",
          imgSrc: require("../img/enemyImg/enemy_icon_106.png"),
          ctName: "花火職人",
          jpName: "花火職人",
          enName: "Firework Guys 1",
          type: "白色敵人",
        },
        id_109: {
          id: "id_109",
          imgSrc: require("../img/enemyImg/enemy_icon_107.png"),
          ctName: "花火職人",
          jpName: "花火職人",
          enName: "Firework Guys 2",
          type: "白色敵人",
        },
        id_110: {
          id: "id_110",
          imgSrc: require("../img/enemyImg/enemy_icon_108.png"),
          ctName: "戰鬥肌熊",
          jpName: "バトルクマッチョ",
          enName: "Mighty Gui Zuli",
          type: "白色敵人",
        },
        id_111: {
          id: "id_111",
          imgSrc: require("../img/enemyImg/enemy_icon_109.png"),
          ctName: "企仙人",
          jpName: "ペ仙人",
          enName: "Hermit Peng",
          type: "白色敵人",
        },
        id_112: {
          id: "id_112",
          imgSrc: require("../img/enemyImg/enemy_icon_110.png"),
          ctName: "拉腸狗老師",
          jpName: "マスターダッフン",
          enName: "Master Da Xun",
          type: "白色敵人",
        },
        id_113: {
          id: "id_113",
          imgSrc: require("../img/enemyImg/enemy_icon_111.png"),
          ctName: "豬狗仔",
          jpName: "豚戦わんこ",
          enName: "Pigge Back",
          type: "紅色敵人",
        },
        id_114: {
          id: "id_114",
          imgSrc: require("../img/enemyImg/enemy_icon_112.png"),
          ctName: "天使旋風",
          jpName: "エンジェルサイクロン",
          enName: "Divine Cyclone",
          type: "天使",
        },
        id_115: {
          id: "id_115",
          imgSrc: require("../img/enemyImg/enemy_icon_113.png"),
          ctName: "河馬將天使",
          jpName: "天使カバちゃん",
          enName: "Heavenly Hippoe",
          type: "天使",
        },
        id_116: {
          id: "id_116",
          imgSrc: require("../img/enemyImg/enemy_icon_114.png"),
          ctName: "加百列天使",
          jpName: "天使ガブリエル",
          enName: "Gabriel",
          type: "天使",
        },
        id_117: {
          id: "id_117",
          imgSrc: require("../img/enemyImg/enemy_icon_115.png"),
          ctName: "落猩天使",
          jpName: "天使ゴンザレス",
          enName: "Angelic Gory",
          type: "天使",
        },
        id_118: {
          id: "id_118",
          imgSrc: require("../img/enemyImg/enemy_icon_116.png"),
          ctName: "天使愛好家",
          jpName: "天使愛好家",
          enName: "Angel Fanboy",
          type: "鋼鐵敵人",
        },
        id_119: {
          id: "id_119",
          imgSrc: require("../img/enemyImg/enemy_icon_117.png"),
          ctName: "壁犬",
          jpName: "カベわんこ",
          enName: "Wall Doge",
          type: "白色敵人",
        },
        id_120: {
          id: "id_120",
          imgSrc: require("../img/enemyImg/enemy_icon_118.png"),
          ctName: "紅髮扭扭蛇",
          jpName: "赤毛のにょろ",
          enName: "Ginger Snache",
          type: "紅色敵人",
        },
        id_121: {
          id: "id_121",
          imgSrc: require("../img/enemyImg/enemy_icon_119.png"),
          ctName: "生化魚鈴木",
          jpName: "マンボーグ鈴木",
          enName: "Sunfish Jones",
          type: "天使",
        },
        id_122: {
          id: "id_122",
          imgSrc: require("../img/enemyImg/enemy_icon_120.png"),
          ctName: "",
          jpName: "お祝いケーキわんこ",
          enName: "Birthday Cake &amp; 2nd Anniversary Birthday Cake",
          type: "鋼鐵敵人",
        },
        id_123: {
          id: "id_123",
          imgSrc: require("../img/enemyImg/enemy_icon_121.png"),
          ctName: "",
          jpName: "ドラリー魔法使い",
          enName: "Drury Witch",
          type: "黑色敵人",
        },
        id_124: {
          id: "id_124",
          imgSrc: require("../img/enemyImg/enemy_icon_122.png"),
          ctName: "",
          jpName: "ドラリー剣士",
          enName: "Drury Swordsman",
          type: "黑色敵人",
        },
        id_125: {
          id: "id_125",
          imgSrc: require("../img/enemyImg/enemy_icon_123.png"),
          ctName: "背負．和平．鴿",
          jpName: "ド鳩・サブ・レー",
          enName: "Pigeon de Sable",
          type: "漂浮敵人",
        },
        id_126: {
          id: "id_126",
          imgSrc: require("../img/enemyImg/enemy_icon_124.png"),
          ctName: "黑色破壞一族",
          jpName: "ブラッコ",
          enName: "Dark Otter",
          type: "黑色敵人",
        },
        id_127: {
          id: "id_127",
          imgSrc: require("../img/enemyImg/enemy_icon_125.png"),
          ctName: "天使斯雷普尼爾",
          jpName: "天使スレイプニール",
          enName: "Angelic Sleipnir",
          type: "天使",
        },
        id_128: {
          id: "id_128",
          imgSrc: require("../img/enemyImg/enemy_icon_126.png"),
          ctName: "新年快樂汪",
          jpName: "日の出わんこ",
          enName: "Angry Sun",
          type: "鋼鐵敵人",
        },
        id_129: {
          id: "id_129",
          imgSrc: require("../img/enemyImg/enemy_icon_127.png"),
          ctName: "猛男貓",
          jpName: "ネコマッチョ",
          enName: "Beefcake Cat",
          type: "漂浮敵人",
        },
        id_130: {
          id: "id_130",
          imgSrc: require("../img/enemyImg/enemy_icon_128.png"),
          ctName: "舞者貓",
          jpName: "ネコダンサー",
          enName: "Dancer Cat",
          type: "白色敵人",
        },
        id_131: {
          id: "id_131",
          imgSrc: require("../img/enemyImg/enemy_icon_129.png"),
          ctName: "Hyper Mr.",
          jpName: "Hyper Mr.",
          enName: "Hyper Mr.",
          type: "白色敵人",
        },
        id_132: {
          id: "id_132",
          imgSrc: require("../img/enemyImg/enemy_icon_130.png"),
          ctName: "極上緊縛貓",
          jpName: "猫縛り極上",
          enName: "Ultimate Bondage Cat",
          type: "白色敵人",
        },
        id_133: {
          id: "id_133",
          imgSrc: require("../img/enemyImg/enemy_icon_131.png"),
          ctName: "暗黑姐",
          jpName: "暗黒嬢",
          enName: "Dark Lazer",
          type: "黑色敵人",
        },
        id_134: {
          id: "id_134",
          imgSrc: require("../img/enemyImg/enemy_icon_132.png"),
          ctName: "重機C・A・T",
          jpName: "重機C・A・T",
          enName: "Heavy Assault C.A.T",
          type: "白色敵人",
        },
        id_135: {
          id: "id_135",
          imgSrc: require("../img/enemyImg/enemy_icon_133.png"),
          ctName: "害羞貓",
          jpName: "ネコぺろきゃん",
          enName: "Lollycat",
          type: "白色敵人",
        },
        id_136: {
          id: "id_136",
          imgSrc: require("../img/enemyImg/enemy_icon_134.png"),
          ctName: "單輪車貓",
          jpName: "イチリンリン",
          enName: "Unicycle Cat",
          type: "白色敵人",
        },
        id_137: {
          id: "id_137",
          imgSrc: require("../img/enemyImg/enemy_icon_135.png"),
          ctName: "飛天忍者貓",
          jpName: "ムササビネコ忍者",
          enName: "Flying Ninja Cat",
          type: "漂浮敵人",
        },
        id_138: {
          id: "id_138",
          imgSrc: require("../img/enemyImg/enemy_icon_136.png"),
          ctName: "骷髏貓",
          jpName: "ネコボーン",
          enName: "Skelecat",
          type: "白色敵人",
        },
        id_139: {
          id: "id_139",
          imgSrc: require("../img/enemyImg/enemy_icon_137.png"),
          ctName: "西點師傅",
          jpName: "ネコパティシエ",
          enName: "Pastry Cat",
          type: "白色敵人",
        },
        id_140: {
          id: "id_140",
          imgSrc: require("../img/enemyImg/enemy_icon_138.png"),
          ctName: "貓飯糰",
          jpName: "ネコに ぎり",
          enName: "Riceball Cat",
          type: "白色敵人",
        },
        id_141: {
          id: "id_141",
          imgSrc: require("../img/enemyImg/enemy_icon_139.png"),
          ctName: "AMIGO貓",
          jpName: "ネコアミーゴ",
          enName: "Gato Amigo",
          type: "白色敵人",
        },
        id_142: {
          id: "id_142",
          imgSrc: require("../img/enemyImg/enemy_icon_140.png"),
          ctName: "兜襠布貓",
          jpName: "ねこななふん",
          enName: "Loincloth Cat",
          type: "白色敵人",
        },
        id_143: {
          id: "id_143",
          imgSrc: require("../img/enemyImg/enemy_icon_141.png"),
          ctName: "綾小路 翔",
          jpName: "綾小路 翔",
          enName: "Ayanokōji Shō",
          type: "紅色敵人",
        },
        id_144: {
          id: "id_144",
          imgSrc: require("../img/enemyImg/enemy_icon_142.png"),
          ctName: "早乙女 光",
          jpName: "早乙女 光",
          enName: "Saotome Hikaru",
          type: "白色敵人",
        },
        id_145: {
          id: "id_145",
          imgSrc: require("../img/enemyImg/enemy_icon_143.png"),
          ctName: "西園寺 瞳",
          jpName: "西園寺 瞳",
          enName: "Saionji Hitomi",
          type: "白色敵人",
        },
        id_146: {
          id: "id_146",
          imgSrc: require("../img/enemyImg/enemy_icon_144.png"),
          ctName: "星愚亂魔弍惠",
          jpName: "星グランマニエ",
          enName: "Hoshi Guranmanie",
          type: "白色敵人",
        },
        id_147: {
          id: "id_147",
          imgSrc: require("../img/enemyImg/enemy_icon_145.png"),
          ctName: "白鳥松竹梅",
          jpName: "白鳥松竹梅",
          enName: "Shiratori Shōchikubai",
          type: "白色敵人",
        },
        id_148: {
          id: "id_148",
          imgSrc: require("../img/enemyImg/enemy_icon_146.png"),
          ctName: "浪子漢",
          jpName: "はぐれたヤツ",
          enName: "Trolly Blogger",
          type: "白色敵人",
        },
        id_149: {
          id: "id_149",
          imgSrc: require("../img/enemyImg/enemy_icon_147.png"),
          ctName: "鋼鐵狗仔",
          jpName: "メタルわんこ",
          enName: "Metal Doge",
          type: "鋼鐵敵人",
        },
        id_150: {
          id: "id_150",
          imgSrc: require("../img/enemyImg/enemy_icon_148.png"),
          ctName: "小戰士貓彈",
          jpName: "コニャンダム",
          enName: "Li'l Nyandam",
          type: "紅色敵人",
        },
        id_151: {
          id: "id_151",
          imgSrc: require("../img/enemyImg/enemy_icon_149.png"),
          ctName: "松黑藏",
          jpName: "松 黒蔵",
          enName: "Le'noir",
          type: "黑色敵人",
        },
        id_152: {
          id: "id_152",
          imgSrc: require("../img/enemyImg/enemy_icon_150.png"),
          ctName: "廚房曼波魚",
          jpName: "厨房マンボウ",
          enName: "Baby Mola",
          type: "漂浮敵人",
        },
        id_153: {
          id: "id_153",
          imgSrc: require("../img/enemyImg/enemy_icon_151.png"),
          ctName: "曼波魚王",
          jpName: "マンボ王",
          enName: "Mola King",
          type: "漂浮敵人",
        },
        id_154: {
          id: "id_154",
          imgSrc: require("../img/enemyImg/enemy_icon_152.png"),
          ctName: "",
          jpName: "ハ マンボ崎あゆみ",
          enName: "Ayumi Manbosaki",
          type: "漂浮敵人",
        },
        id_155: {
          id: "id_155",
          imgSrc: require("../img/enemyImg/enemy_icon_153.png"),
          ctName: "螃蟹",
          jpName: "カニ",
          enName: "Crab",
          type: "紅色敵人",
        },
        id_156: {
          id: "id_156",
          imgSrc: require("../img/enemyImg/enemy_icon_154.png"),
          ctName: "沙丁魚",
          jpName: "いわし",
          enName: "Sardine",
          type: "漂浮敵人",
        },
        id_157: {
          id: "id_157",
          imgSrc: require("../img/enemyImg/enemy_icon_155.png"),
          ctName: "烏賊",
          jpName: "いか",
          enName: "Squid",
          type: "漂浮敵人",
        },
        id_158: {
          id: "id_158",
          imgSrc: require("../img/enemyImg/enemy_icon_156.png"),
          ctName: "快閃無尾熊",
          jpName: "マーチン",
          enName: "Martin",
          type: "白色敵人",
        },
        id_159: {
          id: "id_159",
          imgSrc: require("../img/enemyImg/enemy_icon_157.png"),
          ctName: "",
          jpName: "ハルドロイド",
          enName: "Sakura Android",
          type: "白色敵人",
        },
        id_160: {
          id: "id_160",
          imgSrc: require("../img/enemyImg/enemy_icon_158.png"),
          ctName: "拓也",
          jpName: "タクヤ",
          enName: "Takuya",
          type: "白色敵人",
        },
        id_161: {
          id: "id_161",
          imgSrc: require("../img/enemyImg/enemy_icon_159.png"),
          ctName: "小雪",
          jpName: "ユキ",
          enName: "Yuki",
          type: "漂浮敵人",
        },
        id_162: {
          id: "id_162",
          imgSrc: require("../img/enemyImg/enemy_icon_160.png"),
          ctName: "天使小雞",
          jpName: "天使ヒオコエル",
          enName: "Chickful A",
          type: "天使",
        },
        id_163: {
          id: "id_163",
          imgSrc: require("../img/enemyImg/enemy_icon_161.png"),
          ctName: "",
          jpName: "極道にゃんこ",
          enName: "Mob Cat",
          type: "白色敵人",
        },
        id_164: {
          id: "id_164",
          imgSrc: require("../img/enemyImg/enemy_icon_162.png"),
          ctName: "",
          jpName: "ヤクザヴァンパイア",
          enName: "Yakuza Vampire",
          type: "白色敵人",
        },
        id_165: {
          id: "id_165",
          imgSrc: require("../img/enemyImg/enemy_icon_163.png"),
          ctName: "哈爾修特",
          jpName: "ハルシュト",
          enName: "Hearscht",
          type: "白色敵人",
        },
        id_166: {
          id: "id_166",
          imgSrc: require("../img/enemyImg/enemy_icon_164.png"),
          ctName: "可納莉亞",
          jpName: "コーネリア",
          enName: "Cornelia",
          type: "漂浮敵人",
        },
        id_167: {
          id: "id_167",
          imgSrc: require("../img/enemyImg/enemy_icon_165.png"),
          ctName: "阿洛伊斯",
          jpName: "アロイス",
          enName: "Alois",
          type: "白色敵人",
        },
        id_168: {
          id: "id_168",
          imgSrc: require("../img/enemyImg/enemy_icon_166.png"),
          ctName: "喵化癒術士CC",
          jpName: "にゃんこ化癒術士CC",
          enName: "Nyanko More WarlockCC",
          type: "白色敵人",
        },
        id_169: {
          id: "id_169",
          imgSrc: require("../img/enemyImg/enemy_icon_167.png"),
          ctName: "汪仔星人",
          jpName: "エイリワン",
          enName: "Shibalien",
          type: "異星戰士",
        },
        id_170: {
          id: "id_170",
          imgSrc: require("../img/enemyImg/enemy_icon_168.png"),
          ctName: "鱷魚宅宅",
          jpName: "ワーニック",
          enName: "Kroxo",
          type: "異星戰士",
        },
        id_171: {
          id: "id_171",
          imgSrc: require("../img/enemyImg/enemy_icon_169.png"),
          ctName: "河馬星人",
          jpName: "カーバチャン",
          enName: "Hyppoh",
          type: "異星戰士",
        },
        id_172: {
          id: "id_172",
          imgSrc: require("../img/enemyImg/enemy_icon_170.png"),
          ctName: "斑海星人",
          jpName: "ゴマサーマン",
          enName: "Imperator Sael",
          type: "異星戰士",
        },
        id_173: {
          id: "id_173",
          imgSrc: require("../img/enemyImg/enemy_icon_171.png"),
          ctName: "蛾星女神",
          jpName: "レディ・ガ",
          enName: "Maawth",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_174: {
          id: "id_174",
          imgSrc: require("../img/enemyImg/enemy_icon_172.png"),
          ctName: "眼猴星人",
          jpName: "デカメガネル",
          enName: "LeMurr",
          type: "異星戰士",
        },
        id_175: {
          id: "id_175",
          imgSrc: require("../img/enemyImg/enemy_icon_173.png"),
          ctName: "寄居星 人",
          jpName: "ヤドカリー",
          enName: "Helmut Krabbe",
          type: "異星戰士",
        },
        id_176: {
          id: "id_176",
          imgSrc: require("../img/enemyImg/enemy_icon_174.png"),
          ctName: "臉星人",
          jpName: "カヲルさん",
          enName: "I.M. Phace",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_177: {
          id: "id_177",
          imgSrc: require("../img/enemyImg/enemy_icon_175.png"),
          ctName: "熊星人",
          jpName: "クマンチュー",
          enName: "Ursamajor",
          type: "異星戰士",
        },
        id_178: {
          id: "id_178",
          imgSrc: require("../img/enemyImg/enemy_icon_176.png"),
          ctName: "破壞生物異星海蝶",
          jpName: "破壊生物クオリネン",
          enName: "Cli-One",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_179: {
          id: "id_179",
          imgSrc: require("../img/enemyImg/enemy_icon_177.png"),
          ctName: "豬大哥",
          jpName: "イノヴァルカン",
          enName: "Nimoy Bore",
          type: "異星戰士",
        },
        id_180: {
          id: "id_180",
          imgSrc: require("../img/enemyImg/enemy_icon_178.png"),
          ctName: "伊麗莎白56世",
          jpName: "エリザベス56世",
          enName: "Elizabeth the LVIth",
          type: "異星戰士",
        },
        id_181: {
          id: "id_181",
          imgSrc: require("../img/enemyImg/enemy_icon_179.png"),
          ctName: "異星旋風",
          jpName: "スペースサイクロン",
          enName: "Cosmic Cyclone",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_182: {
          id: "id_182",
          imgSrc: require("../img/enemyImg/enemy_icon_180.png"),
          ctName: "銀河貓彈",
          jpName: "ギャラクシーニャンダム",
          enName: "Galactic Overseer Nyandam",
          type: "異星戰士",
        },
        id_183: {
          id: "id_183",
          imgSrc: require("../img/enemyImg/enemy_icon_181.png"),
          ctName: "反叛的瓦爾基麗貓",
          jpName: "反逆のヴァルキリー",
          enName: "Corrupted Valkyrie",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_184: {
          id: "id_184",
          imgSrc: require("../img/enemyImg/enemy_icon_182.png"),
          ctName: "異星袋拳",
          jpName: "ハサミーマン",
          enName: "Scissoroo",
          type: "異星戰士",
        },
        id_185: {
          id: "id_185",
          imgSrc: require("../img/enemyImg/enemy_icon_183.png"),
          ctName: "CyberX",
          jpName: "サイバーX",
          enName: "Cyberhorn",
          type: "異星戰士",
        },
        id_186: {
          id: "id_186",
          imgSrc: require("../img/enemyImg/enemy_icon_184.png"),
          ctName: "異星貴賓",
          jpName: "プドール夫人",
          enName: "Mistress Celeboodle",
          type: "異星戰士",
        },
        id_187: {
          id: "id_187",
          imgSrc: require("../img/enemyImg/enemy_icon_185.png"),
          ctName: "豪豬教授",
          jpName: "教授",
          enName: "Professor A.",
          type: "紅色敵人",
        },
        id_188: {
          id: "id_188",
          imgSrc: require("../img/enemyImg/enemy_icon_186.png"),
          ctName: "2千萬下載紀念蛋糕",
          jpName: "DL記念ケーキわんこ",
          enName: "20 Million DL Birthday Cake",
          type: "鋼鐵敵人",
        },
        id_189: {
          id: "id_189",
          imgSrc: require("../img/enemyImg/enemy_icon_187.png"),
          ctName: "",
          jpName: "リオレウス",
          enName: "Rathalos",
          type: "漂浮敵人",
        },
        id_190: {
          id: "id_190",
          imgSrc: require("../img/enemyImg/enemy_icon_188.png"),
          ctName: "",
          jpName: "リオレイア",
          enName: "Rathian",
          type: "漂浮敵人",
        },
        id_191: {
          id: "id_191",
          imgSrc: require("../img/enemyImg/enemy_icon_189.png"),
          ctName: "火星人",
          jpName: "マーズピープル",
          enName: "Mars People",
          type: "白色敵人",
        },
        id_192: {
          id: "id_192",
          imgSrc: require("../img/enemyImg/enemy_icon_190.png"),
          ctName: "惡魔化身．莫丁",
          jpName: "モーデン元帥",
          enName: "Donald Morden",
          type: "白色敵 人",
        },
        id_193: {
          id: "id_193",
          imgSrc: require("../img/enemyImg/enemy_icon_191.png"),
          ctName: "艾倫．歐尼爾",
          jpName: "アレン・オニール",
          enName: "Allen O'Neil",
          type: "白色敵人",
        },
        id_194: {
          id: "id_194",
          imgSrc: require("../img/enemyImg/enemy_icon_192.png"),
          ctName: "馬可",
          jpName: "マル コ",
          enName: "Marco",
          type: "白色敵人",
        },
        id_195: {
          id: "id_195",
          imgSrc: require("../img/enemyImg/enemy_icon_193.png"),
          ctName: "SV-001",
          jpName: "SV-001",
          enName: "SV-001",
          type: "白色敵人",
        },
        id_196: {
          id: "id_196",
          imgSrc: require("../img/enemyImg/enemy_icon_194.png"),
          ctName: "巨型寄居蟹",
          jpName: "ヒュージハーミット",
          enName: "Huge Hermit",
          type: "白色敵人",
        },
        id_197: {
          id: "id_197",
          imgSrc: require("../img/enemyImg/enemy_icon_195.png"),
          ctName: "木星王者",
          jpName: "ジュピターキング",
          enName: "Jupiter King",
          type: "白色敵人",
        },
        id_198: {
          id: "id_198",
          imgSrc: require("../img/enemyImg/enemy_icon_196.png"),
          ctName: "海德",
          jpName: "ハイドゥ",
          enName: "HI-DO",
          type: "漂浮敵人",
        },
        id_199: {
          id: "id_199",
          imgSrc: require("../img/enemyImg/enemy_icon_197.png"),
          ctName: "南瓜狗仔",
          jpName: "わんぷきん",
          enName: "Doge O'Lantern",
          type: "白色敵人",
        },
        id_200: {
          id: "id_200",
          imgSrc: require("../img/enemyImg/enemy_icon_198.png"),
          ctName: "眉毛伯爵",
          jpName: "まゆげ伯爵",
          enName: "Drac-owl-la",
          type: "漂浮敵人",
        },
        id_201: {
          id: "id_201",
          imgSrc: require("../img/enemyImg/enemy_icon_199.png"),
          ctName: "萬聖節蝙蝠",
          jpName: "ドバット",
          enName: "Sa-Bat",
          type: "漂浮敵人",
        },
        id_202: {
          id: "id_202",
          imgSrc: require("../img/enemyImg/enemy_icon_200.png"),
          ctName: "",
          jpName: "光の神徒ヴァルキリー",
          enName: "Junior God of Light - Valkyrie",
          type: "漂浮敵人",
        },
        id_203: {
          id: "id_203",
          imgSrc: require("../img/enemyImg/enemy_icon_201.png"),
          ctName: "",
          jpName: "神徒ブリュンヒルデ",
          enName: "Junior God Brynhildr",
          type: "漂浮敵人",
        },
        id_204: {
          id: "id_204",
          imgSrc: require("../img/enemyImg/enemy_icon_202.png"),
          ctName: "",
          jpName: "神徒 スルズ",
          enName: "Junior God Suruzu",
          type: "漂浮敵人",
        },
        id_205: {
          id: "id_205",
          imgSrc: require("../img/enemyImg/enemy_icon_203.png"),
          ctName: "",
          jpName: "豊穣の女神フレイヤ",
          enName: "Freya",
          type: "漂浮敵人",
        },
        id_206: {
          id: "id_206",
          imgSrc: require("../img/enemyImg/enemy_icon_204.png"),
          ctName: "",
          jpName: "軍神オーディン",
          enName: "Odin",
          type: "白色敵人",
        },
        id_207: {
          id: "id_207",
          imgSrc: require("../img/enemyImg/enemy_icon_205.png"),
          ctName: "披著水豚皮的水豚",
          jpName: "カルピンチョ",
          enName: "Capy",
          type: "紅色敵人",
        },
        id_208: {
          id: "id_208",
          imgSrc: require("../img/enemyImg/enemy_icon_206.png"),
          ctName: "戰鬥無尾熊球",
          jpName: "バトルコアラッキョ",
          enName: "Berserkory",
          type: "紅色敵人",
        },
        id_209: {
          id: "id_209",
          imgSrc: require("../img/enemyImg/enemy_icon_207.png"),
          ctName: "燕梓南",
          jpName: "ツバメンズ",
          enName: "Brollow",
          type: "漂浮敵人",
        },
        id_210: {
          id: "id_210",
          imgSrc: require("../img/enemyImg/enemy_icon_208.png"),
          ctName: "小魷",
          jpName: "よっちゃん",
          enName: "Calamary",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_211: {
          id: "id_211",
          imgSrc: require("../img/enemyImg/enemy_icon_209.png"),
          ctName: "羊駝背",
          jpName: "アルパッカ",
          enName: "Alpacky",
          type: "異星戰士",
        },
        id_212: {
          id: "id_212",
          imgSrc: require("../img/enemyImg/enemy_icon_210.png"),
          ctName: "善哉",
          jpName: "ヨキカナ",
          enName: "Elder Sloth",
          type: "異星戰士",
        },
        id_213: {
          id: "id_213",
          imgSrc: require("../img/enemyImg/enemy_icon_211.png"),
          ctName: "寄生噴噴",
          jpName: "パラサイトブンブン",
          enName: "Bun Bun Symbiote",
          type: '漂浮 敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_214: {
          id: "id_214",
          imgSrc: require("../img/enemyImg/enemy_icon_212.png"),
          ctName: "暴走姆特貓",
          jpName: "暴走のネコムート",
          enName: "Raging Bahamut Cat",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_215: {
          id: "id_215",
          imgSrc: require("../img/enemyImg/enemy_icon_213.png"),
          ctName: "聖誕紅粥董",
          jpName: "ナカイサンタ",
          enName: "Blitzen",
          type: "紅色敵人",
        },
        id_216: {
          id: "id_216",
          imgSrc: require("../img/enemyImg/enemy_icon_214.png"),
          ctName: "劍士",
          jpName: "剣士",
          enName: "Swordsman",
          type: "白色敵人",
        },
        id_217: {
          id: "id_217",
          imgSrc: require("../img/enemyImg/enemy_icon_215.png"),
          ctName: "騎兵",
          jpName: "騎馬兵",
          enName: "Cavalry Soldier",
          type: "白色敵人",
        },
        id_218: {
          id: "id_218",
          imgSrc: require("../img/enemyImg/enemy_icon_216.png"),
          ctName: "阿修羅",
          jpName: "アシュラ",
          enName: "Ashura",
          type: "白色敵人",
        },
        id_219: {
          id: "id_219",
          imgSrc: require("../img/enemyImg/enemy_icon_217.png"),
          ctName: "戰鬥熱氣球",
          jpName: "バトルバルーン",
          enName: "Battle Balloon",
          type: "漂浮敵人",
        },
        id_220: {
          id: "id_220",
          imgSrc: require("../img/enemyImg/enemy_icon_218.png"),
          ctName: "龍騎士",
          jpName: "ドラゴンライダー",
          enName: "Dragon Rider",
          type: "漂浮敵人",
        },
        id_221: {
          id: "id_221",
          imgSrc: require("../img/enemyImg/enemy_icon_219.png"),
          ctName: "萌貓女",
          jpName: "プリティキャット",
          enName: "Pretty Cat",
          type: "白色敵人",
        },
        id_222: {
          id: "id_222",
          imgSrc: require("../img/enemyImg/enemy_icon_220.png"),
          ctName: "獨眼藍胖",
          jpName: "サイクロプス",
          enName: "Cyclops",
          type: "白色敵人",
        },
        id_223: {
          id: "id_223",
          imgSrc: require("../img/enemyImg/enemy_icon_221.png"),
          ctName: "巨魔像",
          jpName: "ゴーレム",
          enName: "Golem",
          type: "白色敵人",
        },
        id_224: {
          id: "id_224",
          imgSrc: require("../img/enemyImg/enemy_icon_222.png"),
          ctName: "明王劍士",
          jpName: "明王の剣士",
          enName: "Swordsman of Myoo",
          type: "白色敵人",
        },
        id_225: {
          id: "id_225",
          imgSrc: require("../img/enemyImg/enemy_icon_223.png"),
          ctName: "勇猛黑騎兵",
          jpName: "迅雷の黒騎馬兵",
          enName: "Thunderclap Black Cavalry Soldier",
          type: "白色敵人",
        },
        id_226: {
          id: "id_226",
          imgSrc: require("../img/enemyImg/enemy_icon_224.png"),
          ctName: "羅睺阿修羅",
          jpName: "傾奇者のアシュラ",
          enName: "Kabukimono Ashura",
          type: "白色敵人",
        },
        id_227: {
          id: "id_227",
          imgSrc: require("../img/enemyImg/enemy_icon_225.png"),
          ctName: "UFO戰鬥熱氣球",
          jpName: "バトルバルーンUFO",
          enName: "Battle Balloon UFO",
          type: "漂浮敵人",
        },
        id_228: {
          id: "id_228",
          imgSrc: require("../img/enemyImg/enemy_icon_226.png"),
          ctName: "火龍騎士",
          jpName: "フレイムドラゴンライダー",
          enName: "Flaming Dragon Rider",
          type: "漂浮敵人",
        },
        id_229: {
          id: "id_229",
          imgSrc: require("../img/enemyImg/enemy_icon_227.png"),
          ctName: "虛擬萌貓女",
          jpName: "サイバープリティキャット",
          enName: "Cyber Pretty Cat",
          type: "白色敵人",
        },
        id_230: {
          id: "id_230",
          imgSrc: require("../img/enemyImg/enemy_icon_228.png"),
          ctName: "時空獨眼藍胖",
          jpName: "時空のサイクロプス",
          enName: "Space-time Cyclops",
          type: "白色敵人",
        },
        id_231: {
          id: "id_231",
          imgSrc: require("../img/enemyImg/enemy_icon_229.png"),
          ctName: "火山巨魔像",
          jpName: "ボルケーノゴーレム",
          enName: "Volcano Golem",
          type: "白色敵人",
        },
        id_232: {
          id: "id_232",
          imgSrc: require("../img/enemyImg/enemy_icon_230.png"),
          ctName: "囚犯貓",
          jpName: "にゃんこ囚人",
          enName: "Prisoner Cat",
          type: "白色敵人",
        },
        id_233: {
          id: "id_233",
          imgSrc: require("../img/enemyImg/enemy_icon_231.png"),
          ctName: "紳士貓同盟",
          jpName: "ネコ紳士同盟",
          enName: "Gentleman Bros.",
          type: "白色敵人",
        },
        id_234: {
          id: "id_234",
          imgSrc: require("../img/enemyImg/enemy_icon_232.png"),
          ctName: "斷罪天使海蝶",
          jpName: "断罪天使クオリネル",
          enName: "Cruel Angel Clionel",
          type: "天使",
        },
        id_235: {
          id: "id_235",
          imgSrc: require("../img/enemyImg/enemy_icon_233.png"),
          ctName: "神燈貓",
          jpName: "ニャラジン",
          enName: "Nyalladin",
          type: "漂浮敵人",
        },
        id_236: {
          id: "id_236",
          imgSrc: require("../img/enemyImg/enemy_icon_234.png"),
          ctName: "摔角女貓",
          jpName: "サホリ",
          enName: "Wrestling Cat",
          type: "白色敵人",
        },
        id_237: {
          id: "id_237",
          imgSrc: require("../img/enemyImg/enemy_icon_235.png"),
          ctName: "鼴小龍",
          jpName: "ドリュウ",
          enName: "Mr. Mole",
          type: "白色敵人",
        },
        id_238: {
          id: "id_238",
          imgSrc: require("../img/enemyImg/enemy_icon_236.png"),
          ctName: "颶風旋風",
          jpName: "ハリケーンサイクロン",
          enName: "The Perfect Cyclone",
          type: "漂浮敵人",
        },
        id_239: {
          id: "id_239",
          imgSrc: require("../img/enemyImg/enemy_icon_237.png"),
          ctName: "",
          jpName: "ニャームス",
          enName: "Nyamusu",
          type: "白色敵人",
        },
        id_240: {
          id: "id_240",
          imgSrc: require("../img/enemyImg/enemy_icon_238.png"),
          ctName: "",
          jpName: "ポチ",
          enName: "Pochi",
          type: "白色敵人",
        },
        id_241: {
          id: "id_241",
          imgSrc: require("../img/enemyImg/enemy_icon_239.png"),
          ctName: "",
          jpName: "クロミ",
          enName: "Kuromi",
          type: "白色敵人",
        },
        id_242: {
          id: "id_242",
          imgSrc: require("../img/enemyImg/enemy_icon_240.png"),
          ctName: "",
          jpName: "せつ子",
          enName: "Setsuko",
          type: "白色敵人",
        },
        id_243: {
          id: "id_243",
          imgSrc: require("../img/enemyImg/enemy_icon_241.png"),
          ctName: "",
          jpName: "ねば～る君",
          enName: "Nebaaru-kun",
          type: "白色敵人",
        },
        id_244: {
          id: "id_244",
          imgSrc: require("../img/enemyImg/enemy_icon_242.png"),
          ctName: "大狂亂摩西根貓",
          jpName: "大狂乱のネコモヒカン",
          enName: "Manic Mohawk Cat",
          type: "白色敵人",
        },
        id_245: {
          id: "id_245",
          imgSrc: require("../img/enemyImg/enemy_icon_243.png"),
          ctName: "大狂亂橡皮貓",
          jpName: "大狂乱のゴムネコ",
          enName: "Manic Eraser Cat",
          type: "白色敵人",
        },
        id_246: {
          id: "id_246",
          imgSrc: require("../img/enemyImg/enemy_icon_244.png"),
          ctName: "大狂亂暗黑貓",
          jpName: "大狂乱の暗黒ネコ",
          enName: "Manic Dark Cat",
          type: "白色敵人",
        },
        id_247: {
          id: "id_247",
          imgSrc: require("../img/enemyImg/enemy_icon_245.png"),
          ctName: "大狂亂筋肉美腿貓",
          jpName: "大狂乱のムキあしネコ",
          enName: "Manic Macho Legs Cat",
          type: "白色敵人",
        },
        id_248: {
          id: "id_248",
          imgSrc: require("../img/enemyImg/enemy_icon_246.png"),
          ctName: "大狂亂獅子貓",
          jpName: "大狂乱のネコライオン",
          enName: "Manic Lion Cat",
          type: "白色敵人",
        },
        id_249: {
          id: "id_249",
          imgSrc: require("../img/enemyImg/enemy_icon_247.png"),
          ctName: "大狂亂天空之貓",
          jpName: "大狂乱の天空のネコ",
          enName: "Manic Flying Cat",
          type: "漂浮敵人",
        },
        id_250: {
          id: "id_250",
          imgSrc: require("../img/enemyImg/enemy_icon_248.png"),
          ctName: "大狂亂島貓",
          jpName: "大狂乱のネコ島",
          enName: "Manic Island Cat",
          type: "白色敵人",
        },
        id_251: {
          id: "id_251",
          imgSrc: require("../img/enemyImg/enemy_icon_249.png"),
          ctName: "大狂亂龍王貓",
          jpName: "大狂乱のネコキングドラ ゴン",
          enName: "Manic King Dragon Cat",
          type: "白色敵人",
        },
        id_252: {
          id: "id_252",
          imgSrc: require("../img/enemyImg/enemy_icon_250.png"),
          ctName: "大狂亂賈拉米貓",
          jpName: "大狂乱のネコジャラミ",
          enName: "Manic Jamiera Cat",
          type: "白色敵人",
        },
        id_253: {
          id: "id_253",
          imgSrc: require("../img/enemyImg/enemy_icon_251.png"),
          ctName: "超越熱吻之戀",
          jpName: "キスヨリ・ス・ゴイ",
          enName: "Kiss and Koi",
          type: "漂浮敵人",
        },
        id_254: {
          id: "id_254",
          imgSrc: require("../img/enemyImg/enemy_icon_252.png"),
          ctName: "大草原太太",
          jpName: "マダム・ザ・サバンナ",
          enName: "Madam the Savannah",
          type: "白色敵人",
        },
        id_255: {
          id: "id_255",
          imgSrc: require("../img/enemyImg/enemy_icon_253.png"),
          ctName: "總機的OL",
          jpName: "コールセンターのOL",
          enName: "Call Center Cat",
          type: "白色敵人",
        },
        id_256: {
          id: "id_256",
          imgSrc: require("../img/enemyImg/enemy_icon_254.png"),
          ctName: "天使先 生",
          jpName: "ミスターエンジェル",
          enName: "Mr. Angel",
          type: "天使",
        },
        id_257: {
          id: "id_257",
          imgSrc: require("../img/enemyImg/enemy_icon_255.png"),
          ctName: "大嘴武哥",
          jpName: "キョセーヌ",
          enName: "Two Can",
          type: '紅色敵人, <a href="enemies.aspx?attribute_id=4"',
        },
        id_258: {
          id: "id_258",
          imgSrc: require("../img/enemyImg/enemy_icon_256.png"),
          ctName: "必殺達也",
          jpName: "タッちゃん",
          enName: "Tackey",
          type: "黑色敵人",
        },
        id_259: {
          id: "id_259",
          imgSrc: require("../img/enemyImg/enemy_icon_257.png"),
          ctName: "吉娃娃伯爵",
          jpName: "チワワン伯爵",
          enName: "King Wahwah",
          type: "白色敵人",
        },
        id_260: {
          id: "id_260",
          imgSrc: require("../img/enemyImg/enemy_icon_258.png"),
          ctName: "狗仔紅帽咪娜",
          jpName: "わんこずきんミーニャ",
          enName: 'Codename "Red Riding"',
          type: "白色 敵人",
        },
        id_261: {
          id: "id_261",
          imgSrc: require("../img/enemyImg/enemy_icon_259.png"),
          ctName: "拓也與美麗小雪",
          jpName: "タクヤとビューティユキ",
          enName: "Takuya and Beauty Yuki",
          type: "白色敵 人",
        },
        id_262: {
          id: "id_262",
          imgSrc: require("../img/enemyImg/enemy_icon_260.png"),
          ctName: "風箏貓",
          jpName: "凧にゃん",
          enName: "Kite Cat",
          type: "白色敵人",
        },
        id_263: {
          id: "id_263",
          imgSrc: require("../img/enemyImg/enemy_icon_261.png"),
          ctName: "天使野豬",
          jpName: "イノエンジェル",
          enName: "Boraphim",
          type: "天使",
        },
        id_264: {
          id: "id_264",
          imgSrc: require("../img/enemyImg/enemy_icon_262.png"),
          ctName: "",
          jpName: "やぐらわんこ",
          enName: "Drummer Doge",
          type: "白色敵人",
        },
        id_265: {
          id: "id_265",
          imgSrc: require("../img/enemyImg/enemy_icon_263.png"),
          ctName: "坑錢一族",
          jpName: "ぼったくラッコ",
          enName: "Carny Otta",
          type: "白色敵人",
        },
        id_266: {
          id: "id_266",
          imgSrc: require("../img/enemyImg/enemy_icon_264.png"),
          ctName: "菇菇",
          jpName: "なめこ",
          enName: "Funghi",
          type: "白色敵人",
        },
        id_267: {
          id: "id_267",
          imgSrc: require("../img/enemyImg/enemy_icon_265.png"),
          ctName: "鋼拳貓G",
          jpName: "剛拳にゃんこG",
          enName: "Iron Claw X",
          type: "白色敵人",
        },
        id_268: {
          id: "id_268",
          imgSrc: require("../img/enemyImg/enemy_icon_266.png"),
          ctName: "小光",
          jpName: "ヒカル",
          enName: "Henry",
          type: "白色敵人",
        },
        id_269: {
          id: "id_269",
          imgSrc: require("../img/enemyImg/enemy_icon_267.png"),
          ctName: "般若我王",
          jpName: "般若我王",
          enName: "Hannya",
          type: "紅色敵人",
        },
        id_270: {
          id: "id_270",
          imgSrc: require("../img/enemyImg/enemy_icon_268.png"),
          ctName: "箱狗",
          jpName: "ダンボールわんこ",
          enName: "Package Doge",
          type: "鋼鐵敵人",
        },
        id_271: {
          id: "id_271",
          imgSrc: require("../img/enemyImg/enemy_icon_269.png"),
          ctName: "",
          jpName: "ふてニャン",
          enName: "Futenyan",
          type: "白色敵人",
        },
        id_272: {
          id: "id_272",
          imgSrc: require("../img/enemyImg/enemy_icon_270.png"),
          ctName: "倒棒貓",
          jpName: "ネコ棒倒し",
          enName: "Rampage Cats",
          type: "白色敵人",
        },
        id_273: {
          id: "id_273",
          imgSrc: require("../img/enemyImg/enemy_icon_271.png"),
          ctName: "森蜜子",
          jpName: "森の蜜子",
          enName: "Queen B",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_274: {
          id: "id_274",
          imgSrc: require("../img/enemyImg/enemy_icon_272.png"),
          ctName: "小噴噴",
          jpName: "ちびぶんぶん",
          enName: "Li'l Bun Bun",
          type: "漂浮敵人",
        },
        id_275: {
          id: "id_275",
          imgSrc: require("../img/enemyImg/enemy_icon_273.png"),
          ctName: "玫瑰園的魔女",
          jpName: "ゲルルート",
          enName: "Gertrud",
          type: "魔女",
        },
        id_276: {
          id: "id_276",
          imgSrc: require("../img/enemyImg/enemy_icon_274.png"),
          ctName: "零食的魔女",
          jpName: "シャルロッテ",
          enName: "Charlotte",
          type: "魔女",
        },
        id_277: {
          id: "id_277",
          imgSrc: require("../img/enemyImg/enemy_icon_275.png"),
          ctName: "零食的魔女",
          jpName: "シャルロッテ",
          enName: "Charlotte",
          type: "魔女",
        },
        id_278: {
          id: "id_278",
          imgSrc: require("../img/enemyImg/enemy_icon_276.png"),
          ctName: "箱的魔女",
          jpName: "キルステン",
          enName: "Kirsten",
          type: "魔女",
        },
        id_279: {
          id: "id_279",
          imgSrc: require("../img/enemyImg/enemy_icon_277.png"),
          ctName: "舞台裝置的魔女",
          jpName: "ワルプルギスの夜",
          enName: "Walpurgisnacht",
          type: "魔女",
        },
        id_280: {
          id: "id_280",
          imgSrc: require("../img/enemyImg/enemy_icon_278.png"),
          ctName: "丘比",
          jpName: "きゅうべえ",
          enName: "Kyubey",
          type: "白色敵人",
        },
        id_281: {
          id: "id_281",
          imgSrc: require("../img/enemyImg/enemy_icon_279.png"),
          ctName: "火舞貓",
          jpName: "ネコ火祭り",
          enName: "Ritual Cat",
          type: "白色敵人",
        },
        id_282: {
          id: "id_282",
          imgSrc: require("../img/enemyImg/enemy_icon_280.png"),
          ctName: "黑暗野豬",
          jpName: "イノワール",
          enName: "Razorback",
          type: "黑色敵人",
        },
        id_283: {
          id: "id_283",
          imgSrc: require("../img/enemyImg/enemy_icon_281.png"),
          ctName: "文化祭看板小妹",
          jpName: "文化祭のカンバン娘",
          enName: "Festival Ms. Sign",
          type: "白色敵人",
        },
        id_284: {
          id: "id_284",
          imgSrc: require("../img/enemyImg/enemy_icon_282.png"),
          ctName: "促銷妹小雞",
          jpName: "売り子エル",
          enName: "Chicka Fry",
          type: "白色敵人",
        },
        id_285: {
          id: "id_285",
          imgSrc: require("../img/enemyImg/enemy_icon_283.png"),
          ctName: "木人城",
          jpName: "木人城",
          enName: "Scarecrow",
          type: "無屬性敵人",
        },
        id_286: {
          id: "id_286",
          imgSrc: require("../img/enemyImg/enemy_icon_284.png"),
          ctName: "不死狗仔",
          jpName: "ゾンビワン",
          enName: "Zoge",
          type: "不死生物",
        },
        id_287: {
          id: "id_287",
          imgSrc: require("../img/enemyImg/enemy_icon_285.png"),
          ctName: "不死扭扭蛇",
          jpName: "にょろろん",
          enName: "Znache",
          type: "不死生物",
        },
        id_288: {
          id: "id_288",
          imgSrc: require("../img/enemyImg/enemy_icon_286.png"),
          ctName: "不死河馬將",
          jpName: "カバ タリアン",
          enName: "Zomboe",
          type: "不死生物",
        },
        id_289: {
          id: "id_289",
          imgSrc: require("../img/enemyImg/enemy_icon_287.png"),
          ctName: "不死豬野郎",
          jpName: "トンシー",
          enName: "Zigge",
          type: "不死生物",
        },
        id_290: {
          id: "id_290",
          imgSrc: require("../img/enemyImg/enemy_icon_288.png"),
          ctName: "不死企鵝大哥Z",
          jpName: "ジャッキー・ペンZ",
          enName: "Zackie Peng",
          type: "不死生物",
        },
        id_291: {
          id: "id_291",
          imgSrc: require("../img/enemyImg/enemy_icon_289.png"),
          ctName: "不死大猩猩",
          jpName: "ゴリ・ンジュ",
          enName: "Zory",
          type: "不死生物",
        },
        id_292: {
          id: "id_292",
          imgSrc: require("../img/enemyImg/enemy_icon_290.png"),
          ctName: "不死斑海豹桑",
          jpName: "ブチゴマさま",
          enName: "Zir Zeal",
          type: "不死生物",
        },
        id_293: {
          id: "id_293",
          imgSrc: require("../img/enemyImg/enemy_icon_291.png"),
          ctName: "不死袋拳",
          jpName: "スカルボクサー",
          enName: "Zang Roo",
          type: "不死生物",
        },
        id_294: {
          id: "id_294",
          imgSrc: require("../img/enemyImg/enemy_icon_292.png"),
          ctName: "不死鱷魚",
          jpName: "ワニボン",
          enName: "Zroco",
          type: "不死生物",
        },
        id_295: {
          id: "id_295",
          imgSrc: require("../img/enemyImg/enemy_icon_293.png"),
          ctName: "墓手太郎",
          jpName: "墓手太郎",
          enName: "Lord Gravey",
          type: "不死生物",
        },
        id_296: {
          id: "id_296",
          imgSrc: require("../img/enemyImg/enemy_icon_294.png"),
          ctName: "不死旋風",
          jpName: "アンデッドサイクロン",
          enName: "Zyclone",
          type: "不 死生物",
        },
        id_297: {
          id: "id_297",
          imgSrc: require("../img/enemyImg/enemy_icon_295.png"),
          ctName: "聖誕樹幹蛋糕貓",
          jpName: "フィッシュ．ド．ノエル",
          enName: "Xmas Pudding Cat",
          type: "白色敵人",
        },
        id_298: {
          id: "id_298",
          imgSrc: require("../img/enemyImg/enemy_icon_296.png"),
          ctName: "歌后貓 EX",
          jpName: "メガにゃんこEX",
          enName: "Mega Cat EX",
          type: "鋼鐵敵人",
        },
        id_299: {
          id: "id_299",
          imgSrc: require("../img/enemyImg/enemy_icon_297.png"),
          ctName: "4週年紀念生日蛋糕",
          jpName: "4周年記念ケーキわんこ",
          enName: "4th Anniversary Birthday Cake",
          type: "鋼鐵敵人",
        },
        id_300: {
          id: "id_300",
          imgSrc: require("../img/enemyImg/enemy_icon_298.png"),
          ctName: "",
          jpName: "テレビちゃん城",
          enName: "Niconico TV",
          type: "無屬性敵人",
        },
        id_301: {
          id: "id_301",
          imgSrc: require("../img/enemyImg/enemy_icon_299.png"),
          ctName: "W",
          jpName: "W",
          enName: "W",
          type: "漂浮敵人",
        },
        id_302: {
          id: "id_302",
          imgSrc: require("../img/enemyImg/enemy_icon_300.png"),
          ctName: "W",
          jpName: "W",
          enName: "W",
          type: "漂浮敵人",
        },
        id_303: {
          id: "id_303",
          imgSrc: require("../img/enemyImg/enemy_icon_301.png"),
          ctName: "W",
          jpName: "W",
          enName: "W",
          type: "漂浮敵人",
        },
        id_304: {
          id: "id_304",
          imgSrc: require("../img/enemyImg/enemy_icon_302.png"),
          ctName: "",
          jpName: "ネコ博士",
          enName: "NekoHakase",
          type: "白色敵人",
        },
        id_305: {
          id: "id_305",
          imgSrc: require("../img/enemyImg/enemy_icon_303.png"),
          ctName: "墓手花子",
          jpName: "墓手花子",
          enName: "Miss Haka",
          type: "不死生物",
        },
        id_306: {
          id: "id_306",
          imgSrc: require("../img/enemyImg/enemy_icon_304.png"),
          ctName: "不死大鯢",
          jpName: "オオさん",
          enName: "Big Sal",
          type: "不死生物",
        },
        id_307: {
          id: "id_307",
          imgSrc: require("../img/enemyImg/enemy_icon_305.png"),
          ctName: "PIKO太郎",
          jpName: "ピコ太郎",
          enName: "Pikotaro",
          type: "鋼鐵敵人",
        },
        id_308: {
          id: "id_308",
          imgSrc: require("../img/enemyImg/enemy_icon_306.png"),
          ctName: "澎湃猛獁",
          jpName: "パオンモス",
          enName: "Mammothe",
          type: "白色敵人",
        },
        id_309: {
          id: "id_309",
          imgSrc: require("../img/enemyImg/enemy_icon_307.png"),
          ctName: "冰牆 狗仔",
          jpName: "アイスわんこ",
          enName: "Icy Doge",
          type: "白色敵人",
        },
        id_310: {
          id: "id_310",
          imgSrc: require("../img/enemyImg/enemy_icon_308.png"),
          ctName: "雪球",
          jpName: "雪玉",
          enName: "Snowball",
          type: "漂浮敵人",
        },
        id_311: {
          id: "id_311",
          imgSrc: require("../img/enemyImg/enemy_icon_309.png"),
          ctName: "棺材狗",
          jpName: "ヒツギイヌ",
          enName: "Coffin Zoge",
          type: "不死生物",
        },
        id_312: {
          id: "id_312",
          imgSrc: require("../img/enemyImg/enemy_icon_310.png"),
          ctName: "凹凸駝背",
          jpName: "キャベロン",
          enName: "Zamelle",
          type: "不死生物",
        },
        id_313: {
          id: "id_313",
          imgSrc: require("../img/enemyImg/enemy_icon_311.png"),
          ctName: "殺意貓",
          jpName: "殺意のネコ",
          enName: "Killer Cat",
          type: "黑色敵人",
        },
        id_314: {
          id: "id_314",
          imgSrc: require("../img/enemyImg/enemy_icon_312.png"),
          ctName: "",
          jpName: "黒ネコの城",
          enName: "Corrupted Cat Base",
          type: "無屬性敵人",
        },
        id_316: {
          id: "id_316",
          imgSrc: require("../img/enemyImg/enemy_icon_314.png"),
          ctName: "",
          jpName: "クロウサギ",
          enName: "Nazousagi",
          type: "黑色敵人",
        },
        id_317: {
          id: "id_317",
          imgSrc: require("../img/enemyImg/enemy_icon_315.png"),
          ctName: "",
          jpName: "わんこの城",
          enName: "Doge Base",
          type: "無屬性敵人",
        },
        id_318: {
          id: "id_318",
          imgSrc: require("../img/enemyImg/enemy_icon_316.png"),
          ctName: "犬武者 武藏",
          jpName: "犬武者 武蔵",
          enName: "Inumusha",
          type: "不死生物",
        },
        id_319: {
          id: "id_319",
          imgSrc: require("../img/enemyImg/enemy_icon_317.png"),
          ctName: "亡者肥普",
          jpName: "亡者デブウ",
          enName: "Daboo of the Dead",
          type: "不死生物",
        },
        id_320: {
          id: "id_320",
          imgSrc: require("../img/enemyImg/enemy_icon_318.png"),
          ctName: "海豚姑娘",
          jpName: "イルカ娘",
          enName: "Dolphina",
          type: "白色敵人",
        },
        id_321: {
          id: "id_321",
          imgSrc: require("../img/enemyImg/enemy_icon_319.png"),
          ctName: "莫比烏斯",
          jpName: "メビウス",
          enName: "Mobius",
          type: "漂浮敵人",
        },
        id_322: {
          id: "id_322",
          imgSrc: require("../img/enemyImg/enemy_icon_320.png"),
          ctName: "貝利亞",
          jpName: "ベリアル",
          enName: "Belial",
          type: "白色敵人",
        },
        id_323: {
          id: "id_323",
          imgSrc: require("../img/enemyImg/enemy_icon_321.png"),
          ctName: "哈皮100",
          jpName: "ハッピー100",
          enName: "Happy 100",
          type: "漂浮敵人",
        },
        id_324: {
          id: "id_324",
          imgSrc: require("../img/enemyImg/enemy_icon_322.png"),
          ctName: "小小摩西根貓",
          jpName: "ちびネコモヒカン",
          enName: "Li'l Mohawk Cat",
          type: "白色 敵人",
        },
        id_325: {
          id: "id_325",
          imgSrc: require("../img/enemyImg/enemy_icon_323.png"),
          ctName: "小小橡皮貓",
          jpName: "ちびゴムネコ",
          enName: "Li'l Eraser Cat",
          type: "白色敵人",
        },
        id_326: {
          id: "id_326",
          imgSrc: require("../img/enemyImg/enemy_icon_324.png"),
          ctName: "小小暗黑貓",
          jpName: "ちび暗黒ネコ",
          enName: "Li'l Dark Cat",
          type: "白色敵人",
        },
        id_327: {
          id: "id_327",
          imgSrc: require("../img/enemyImg/enemy_icon_325.png"),
          ctName: "小小筋肉美腿貓",
          jpName: "ちびムキあしネコ",
          enName: "Li'l Macho Legs Cat",
          type: "白色敵人",
        },
        id_328: {
          id: "id_328",
          imgSrc: require("../img/enemyImg/enemy_icon_326.png"),
          ctName: "小小獅子貓",
          jpName: "ちびネコライオン",
          enName: "Li'l Lion Cat",
          type: "白色敵人",
        },
        id_329: {
          id: "id_329",
          imgSrc: require("../img/enemyImg/enemy_icon_327.png"),
          ctName: "小小天空之貓",
          jpName: "天空のちびネコ",
          enName: "Li'l Flying Cat",
          type: "漂 浮敵人",
        },
        id_330: {
          id: "id_330",
          imgSrc: require("../img/enemyImg/enemy_icon_328.png"),
          ctName: "小小島貓",
          jpName: "ちびネコ島",
          enName: "Li'l Island Cat",
          type: "白色敵人",
        },
        id_331: {
          id: "id_331",
          imgSrc: require("../img/enemyImg/enemy_icon_329.png"),
          ctName: "小小龍王貓",
          jpName: "ちびネコキングドラゴン",
          enName: "Li'l King Dragon Cat",
          type: "白色敵人",
        },
        id_332: {
          id: "id_332",
          imgSrc: require("../img/enemyImg/enemy_icon_330.png"),
          ctName: "小小賈拉米貓",
          jpName: "ちびネコ ジャラミ",
          enName: "Li'l Jamiera Cat",
          type: "白色敵人",
        },
        id_333: {
          id: "id_333",
          imgSrc: require("../img/enemyImg/enemy_icon_331.png"),
          ctName: "復活節大鴨",
          jpName: "イースタールンルン",
          enName: "Easter Duche",
          type: "白色敵人",
        },
        id_334: {
          id: "id_334",
          imgSrc: require("../img/enemyImg/enemy_icon_332.png"),
          ctName: "復活節兔子",
          jpName: "イースターウサ銀",
          enName: "Easter Bunny",
          type: "白色敵人",
        },
        id_335: {
          id: "id_335",
          imgSrc: require("../img/enemyImg/enemy_icon_333.png"),
          ctName: "摩艾像",
          jpName: "イースターモアイ城",
          enName: "Moai Statue",
          type: "無屬性敵人",
        },
        id_336: {
          id: "id_336",
          imgSrc: require("../img/enemyImg/enemy_icon_334.png"),
          ctName: "婚紗飛踢公主",
          jpName: "ウェディングケリ姫",
          enName: "Wedding Kerihime",
          type: "白色敵人",
        },
        id_337: {
          id: "id_337",
          imgSrc: require("../img/enemyImg/enemy_icon_335.png"),
          ctName: "熟睡的飛踢睡美人",
          jpName: "ひたすら眠れるケリの美女",
          enName: "Soundly Sleeping Beauty",
          type: "白色敵人",
        },
        id_338: {
          id: "id_338",
          imgSrc: require("../img/enemyImg/enemy_icon_336.png"),
          ctName: "黃金狗仔",
          jpName: "ゴー ルデンわんこ",
          enName: "Goldoge",
          type: "白色敵人",
        },
        id_339: {
          id: "id_339",
          imgSrc: require("../img/enemyImg/enemy_icon_337.png"),
          ctName: "金河馬將",
          jpName: "金カバちゃん",
          enName: "Sir Hippoe",
          type: "白色敵人",
        },
        id_340: {
          id: "id_340",
          imgSrc: require("../img/enemyImg/enemy_icon_338.png"),
          ctName: "黃金鴕鳥",
          jpName: "純金倶楽部",
          enName: "Golden R. Ost",
          type: "鋼鐵敵人",
        },
        id_341: {
          id: "id_341",
          imgSrc: require("../img/enemyImg/enemy_icon_339.png"),
          ctName: "",
          jpName: "失われし世界のユキ",
          enName: "Lost World Yuki",
          type: "漂浮敵人",
        },
        id_342: {
          id: "id_342",
          imgSrc: require("../img/enemyImg/enemy_icon_340.png"),
          ctName: "炸烏賊天使",
          jpName: "イカ天",
          enName: "Cala Maria",
          type: "天使",
        },
        id_343: {
          id: "id_343",
          imgSrc: require("../img/enemyImg/enemy_icon_341.png"),
          ctName: "鼻涕蟲",
          jpName: "なめ",
          enName: "Sluggy",
          type: "紅色敵人",
        },
        id_344: {
          id: "id_344",
          imgSrc: require("../img/enemyImg/enemy_icon_342.png"),
          ctName: "鼻涕蟲",
          jpName: "なめ",
          enName: "Sluggy",
          type: "黑色敵人",
        },
        id_345: {
          id: "id_345",
          imgSrc: require("../img/enemyImg/enemy_icon_343.png"),
          ctName: "鼻涕蟲",
          jpName: "なめ",
          enName: "Sluggy",
          type: "天使",
        },
        id_346: {
          id: "id_346",
          imgSrc: require("../img/enemyImg/enemy_icon_344.png"),
          ctName: "",
          jpName: "にゃんこカートP",
          enName: "Cat Kart P",
          type: "白色敵人",
        },
        id_348: {
          id: "id_348",
          imgSrc: require("../img/enemyImg/enemy_icon_346.png"),
          ctName: "貓咪與梅露可CC",
          jpName: "にゃんことメルクCC",
          enName: "Nyanko MercCC",
          type: "白色敵人",
        },
        id_349: {
          id: "id_349",
          imgSrc: require("../img/enemyImg/enemy_icon_347.png"),
          ctName: "貓咪推推CC",
          jpName: "ネコティティCC",
          enName: "Titi CatCC",
          type: "白色敵人",
        },
        id_350: {
          id: "id_350",
          imgSrc: require("../img/enemyImg/enemy_icon_348.png"),
          ctName: "奧爾托斯",
          jpName: "オルトス",
          enName: "Orthos",
          type: "漂浮敵人",
        },
        id_351: {
          id: "id_351",
          imgSrc: require("../img/enemyImg/enemy_icon_349.png"),
          ctName: "米希利亞",
          jpName: "ミシェリア",
          enName: "Michelia",
          type: "漂浮敵人",
        },
        id_352: {
          id: "id_352",
          imgSrc: require("../img/enemyImg/enemy_icon_350.png"),
          ctName: "留姬",
          jpName: "とどめき",
          enName: "Todomeki",
          type: "漂浮敵人",
        },
        id_353: {
          id: "id_353",
          imgSrc: require("../img/enemyImg/enemy_icon_351.png"),
          ctName: "來盤蛋黃哥",
          jpName: "グレたまプレート",
          enName: "Gudetama Plate",
          type: "白色敵人",
        },
        id_354: {
          id: "id_354",
          imgSrc: require("../img/enemyImg/enemy_icon_352.png"),
          ctName: "焦糖布丁蛋黃 哥",
          jpName: "ぐでぐでアラモード",
          enName: "Gudegude À la mode",
          type: "白色敵人",
        },
        id_355: {
          id: "id_355",
          imgSrc: require("../img/enemyImg/enemy_icon_353.png"),
          ctName: "蛋黃人軍團",
          jpName: "ニセたま軍団",
          enName: "Nisetama Army",
          type: "白色敵人",
        },
        id_356: {
          id: "id_356",
          imgSrc: require("../img/enemyImg/enemy_icon_354.png"),
          ctName: "貓咪仙人",
          jpName: "ネコ仙人",
          enName: "Hermit Cat",
          type: "白色敵人",
        },
        id_357: {
          id: "id_357",
          imgSrc: require("../img/enemyImg/enemy_icon_355.png"),
          ctName: "蛙助",
          jpName: "ケロ助",
          enName: "Croakley",
          type: "白色敵人",
        },
        id_358: {
          id: "id_358",
          imgSrc: require("../img/enemyImg/enemy_icon_356.png"),
          ctName: "",
          jpName: "ガリゴリくん",
          enName: "Gory Junior",
          type: "白色敵人",
        },
        id_359: {
          id: "id_359",
          imgSrc: require("../img/enemyImg/enemy_icon_357.png"),
          ctName: "",
          jpName: "",
          enName: "Value Meal Cat",
          type: "白色敵人",
        },
        id_360: {
          id: "id_360",
          imgSrc: require("../img/enemyImg/enemy_icon_358.png"),
          ctName: "鋼鐵扭扭蛇",
          jpName: "メタルにょろ",
          enName: "Steel Snake",
          type: "鋼鐵敵人",
        },
        id_361: {
          id: "id_361",
          imgSrc: require("../img/enemyImg/enemy_icon_359.png"),
          ctName: "離群樹懶賴",
          jpName: "はぐれケモルル",
          enName: "Mercury Sloth",
          type: "鋼鐵敵人",
        },
        id_362: {
          id: "id_362",
          imgSrc: require("../img/enemyImg/enemy_icon_360.png"),
          ctName: "精英汪仔星人",
          jpName: "エリートエイリワン",
          enName: "Shibalien Elite",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_363: {
          id: "id_363",
          imgSrc: require("../img/enemyImg/enemy_icon_361.png"),
          ctName: "宙星．企鵝大哥",
          jpName: "ス ター・ペン",
          enName: "Star Peng",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_364: {
          id: "id_364",
          imgSrc: require("../img/enemyImg/enemy_icon_362.png"),
          ctName: "宙猩將軍",
          jpName: "グレゴリー将軍",
          enName: "General GreGory",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_365: {
          id: "id_365",
          imgSrc: require("../img/enemyImg/enemy_icon_363.png"),
          ctName: "澎湃媽",
          jpName: "ハハパオン",
          enName: "Le'Solar",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_366: {
          id: "id_366",
          imgSrc: require("../img/enemyImg/enemy_icon_364.png"),
          ctName: "巨匠",
          jpName: "巨匠",
          enName: "Project A",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_367: {
          id: "id_367",
          imgSrc: require("../img/enemyImg/enemy_icon_365.png"),
          ctName: "鼴鼠 隊長",
          jpName: "キャプテン・モグー",
          enName: "Corporal Weyland",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_368: {
          id: "id_368",
          imgSrc: require("../img/enemyImg/enemy_icon_366.png"),
          ctName: "宙星生化魚",
          jpName: "スペースマンボルグ",
          enName: "Spacefish Jones",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_369: {
          id: "id_369",
          imgSrc: require("../img/enemyImg/enemy_icon_367.png"),
          ctName: "神",
          jpName: "神さま",
          enName: "The Cat God",
          type: "漂浮敵人",
        },
        id_370: {
          id: "id_370",
          imgSrc: require("../img/enemyImg/enemy_icon_368.png"),
          ctName: "Saber",
          jpName: "セイバー",
          enName: "Saber",
          type: "白色敵人",
        },
        id_371: {
          id: "id_371",
          imgSrc: require("../img/enemyImg/enemy_icon_369.png"),
          ctName: "Lancer",
          jpName: "ランサー",
          enName: "Lancer",
          type: "白色敵人",
        },
        id_372: {
          id: "id_372",
          imgSrc: require("../img/enemyImg/enemy_icon_370.png"),
          ctName: "Archer",
          jpName: "アーチャー",
          enName: "Archer",
          type: "白色敵人",
        },
        id_373: {
          id: "id_373",
          imgSrc: require("../img/enemyImg/enemy_icon_371.png"),
          ctName: "Rider",
          jpName: "ライダー",
          enName: "Rider",
          type: "白色敵人",
        },
        id_374: {
          id: "id_374",
          imgSrc: require("../img/enemyImg/enemy_icon_372.png"),
          ctName: "Gilgamesh",
          jpName: "ギルガメッシュ",
          enName: "Gilgamesh",
          type: "白色敵人",
        },
        id_375: {
          id: "id_375",
          imgSrc: require("../img/enemyImg/enemy_icon_373.png"),
          ctName: "遠坂凛",
          jpName: "遠坂 凛",
          enName: "Rin Tohsaka",
          type: "白色敵人",
        },
        id_376: {
          id: "id_376",
          imgSrc: require("../img/enemyImg/enemy_icon_374.png"),
          ctName: "伊利雅蘇菲爾",
          jpName: "イリヤスフィール",
          enName: "Illyasviel",
          type: "白色敵人",
        },
        id_377: {
          id: "id_377",
          imgSrc: require("../img/enemyImg/enemy_icon_375.png"),
          ctName: "大夢君",
          jpName: "大夢くん",
          enName: "Youcan",
          type: '天使, <a href="enemies.aspx?attribute_id=8"',
        },
        id_378: {
          id: "id_378",
          imgSrc: require("../img/enemyImg/enemy_icon_376.png"),
          ctName: "5週年紀念生日蛋糕",
          jpName: "5周年記念ケーキわんこ",
          enName: "5th Anniversary Birthday Cake",
          type: "鋼鐵敵人",
        },
        id_379: {
          id: "id_379",
          imgSrc: require("../img/enemyImg/enemy_icon_377.png"),
          ctName: "超級異星旋風",
          jpName: "スーパースペースサイク ロン",
          enName: "Super Cosmic Cyclone",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_380: {
          id: "id_380",
          imgSrc: require("../img/enemyImg/enemy_icon_378.png"),
          ctName: "5週年紀念木 人城",
          jpName: "5周年記念木人城",
          enName: "5th Anniversary Scarecrow",
          type: "無屬性敵人",
        },
        id_381: {
          id: "id_381",
          imgSrc: require("../img/enemyImg/enemy_icon_379.png"),
          ctName: "飛天小豬",
          jpName: "天使ブッタ",
          enName: "Winged Pigge",
          type: "天使",
        },
        id_382: {
          id: "id_382",
          imgSrc: require("../img/enemyImg/enemy_icon_380.png"),
          ctName: "神秘假面烏拉拉",
          jpName: "謎仮面のウララー",
          enName: "Mystic Mask Yulala",
          type: "白色敵人",
        },
        id_383: {
          id: "id_383",
          imgSrc: require("../img/enemyImg/enemy_icon_381.png"),
          ctName: "貓塚花凜",
          jpName: "猫塚かりん",
          enName: "Karin Nekozuka",
          type: "白色敵人",
        },
        id_384: {
          id: "id_384",
          imgSrc: require("../img/enemyImg/enemy_icon_382.png"),
          ctName: "紺野美崎",
          jpName: "紺野美崎",
          enName: "Misaki Konno",
          type: "白色敵人",
        },
        id_385: {
          id: "id_385",
          imgSrc: require("../img/enemyImg/enemy_icon_383.png"),
          ctName: "虹谷彩理",
          jpName: "虹谷彩理",
          enName: "Sairi Nijitani",
          type: "白色敵人",
        },
        id_386: {
          id: "id_386",
          imgSrc: require("../img/enemyImg/enemy_icon_384.png"),
          ctName: "片桐戀",
          jpName: "片桐恋",
          enName: "Ren Katagiri",
          type: "白色敵人",
        },
        id_387: {
          id: "id_387",
          imgSrc: require("../img/enemyImg/enemy_icon_385.png"),
          ctName: "",
          jpName: "ゲドーくん",
          enName: "Hater",
          type: "白色敵人",
        },
        id_388: {
          id: "id_388",
          imgSrc: require("../img/enemyImg/enemy_icon_386.png"),
          ctName: "",
          jpName: "ダイジョーブ博 士城",
          enName: "Prof. Wild Base",
          type: "無屬性敵人",
        },
        id_389: {
          id: "id_389",
          imgSrc: require("../img/enemyImg/enemy_icon_387.png"),
          ctName: "火馬",
          jpName: "ヒウマ",
          enName: "Hackey",
          type: "紅色敵人",
        },
        id_390: {
          id: "id_390",
          imgSrc: require("../img/enemyImg/enemy_icon_388.png"),
          ctName: "激動咩咩",
          jpName: "ウルトラメェメェ",
          enName: "UltraBaaBaa",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_391: {
          id: "id_391",
          imgSrc: require("../img/enemyImg/enemy_icon_389.png"),
          ctName: "及格野郎",
          jpName: "合格野郎",
          enName: "Pigge Victorious",
          type: "紅色敵人",
        },
        id_392: {
          id: "id_392",
          imgSrc: require("../img/enemyImg/enemy_icon_390.png"),
          ctName: "臘腸狗與機關槍",
          jpName: "だっふんと機関銃",
          enName: "Bang-Bang",
          type: "白色敵人",
        },
        id_393: {
          id: "id_393",
          imgSrc: require("../img/enemyImg/enemy_icon_391.png"),
          ctName: "懶得鳥",
          jpName: "めんトリ",
          enName: "Mentori",
          type: "白色敵人",
        },
        id_394: {
          id: "id_394",
          imgSrc: require("../img/enemyImg/enemy_icon_392.png"),
          ctName: "薩基爾",
          jpName: "サキエル",
          enName: "Sachiel",
          type: "使徒",
        },
        id_395: {
          id: "id_395",
          imgSrc: require("../img/enemyImg/enemy_icon_393.png"),
          ctName: "雷米爾",
          jpName: "ラミエル",
          enName: "Ramiel",
          type: "使徒",
        },
        id_396: {
          id: "id_396",
          imgSrc: require("../img/enemyImg/enemy_icon_394.png"),
          ctName: "巴迪爾",
          jpName: "バルディエル",
          enName: "Bardiel",
          type: "使徒",
        },
        id_397: {
          id: "id_397",
          imgSrc: require("../img/enemyImg/enemy_icon_395.png"),
          ctName: "塞路爾",
          jpName: "ゼルエル",
          enName: "Zeruel",
          type: "使徒",
        },
        id_398: {
          id: "id_398",
          imgSrc: require("../img/enemyImg/enemy_icon_396.png"),
          ctName: "狂亂萌貓",
          jpName: "狂乱のもねこ",
          enName: "Crazed Moneko",
          type: "白色敵人",
        },
        id_399: {
          id: "id_399",
          imgSrc: require("../img/enemyImg/enemy_icon_397.png"),
          ctName: "狂亂偶像萌貓",
          jpName: "狂乱のスターもねこ",
          enName: "Corrupted Moneko",
          type: "白色敵人",
        },
        id_400: {
          id: "id_400",
          imgSrc: require("../img/enemyImg/enemy_icon_398.png"),
          ctName: "？",
          jpName: "？",
          enName: "？",
          type: "白色敵人",
        },
        id_401: {
          id: "id_401",
          imgSrc: require("../img/enemyImg/enemy_icon_399.png"),
          ctName: "POKOTA",
          jpName: "ポコタ",
          enName: "POKOTA",
          type: "白色敵人",
        },
        id_402: {
          id: "id_402",
          imgSrc: require("../img/enemyImg/enemy_icon_400.png"),
          ctName: "OVIS",
          jpName: "オビス",
          enName: "OVIS",
          type: "白色敵人",
        },
        id_403: {
          id: "id_403",
          imgSrc: require("../img/enemyImg/enemy_icon_401.png"),
          ctName: "COCO",
          jpName: "ココ",
          enName: "COCO",
          type: "白色敵人",
        },
        id_404: {
          id: "id_404",
          imgSrc: require("../img/enemyImg/enemy_icon_402.png"),
          ctName: "",
          jpName: "太秦萌＆わんこ",
          enName: "Moe Uzumasa&amp; Doge",
          type: "白色敵人",
        },
        id_405: {
          id: "id_405",
          imgSrc: require("../img/enemyImg/enemy_icon_403.png"),
          ctName: "",
          jpName: "松賀咲＆わんこ",
          enName: "Saki Matsuga&amp; Doge",
          type: "白色敵人",
        },
        id_406: {
          id: "id_406",
          imgSrc: require("../img/enemyImg/enemy_icon_404.png"),
          ctName: "",
          jpName: "小野ミサ＆わんこ",
          enName: "Misa Ono &amp; Doge",
          type: "白色敵人",
        },
        id_407: {
          id: "id_407",
          imgSrc: require("../img/enemyImg/enemy_icon_405.png"),
          ctName: "傳奇噴噴Ω",
          jpName: "レジェンド ブンブンΩ",
          enName: "Mecha-Bun",
          type: "漂浮敵人",
        },
        id_408: {
          id: "id_408",
          imgSrc: require("../img/enemyImg/enemy_icon_406.png"),
          ctName: "真傳奇噴噴",
          jpName: "真レジェンドブンブン",
          enName: "Relic Bun-Bun",
          type: "古代種",
        },
        id_409: {
          id: "id_409",
          imgSrc: require("../img/enemyImg/enemy_icon_407.png"),
          ctName: "古代狗仔",
          jpName: "古代わんこ",
          enName: "Relic Doge",
          type: "古代種",
        },
        id_410: {
          id: "id_410",
          imgSrc: require("../img/enemyImg/enemy_icon_408.png"),
          ctName: "狂亂小雪",
          jpName: "狂乱のユキ",
          enName: "Crazed Yuki",
          type: "漂浮敵人",
        },
        id_411: {
          id: "id_411",
          imgSrc: require("../img/enemyImg/enemy_icon_409.png"),
          ctName: "蛋黃機器貓",
          jpName: "ぐでわんこマシン",
          enName: "Gude-Doge Machine",
          type: "白色敵人",
        },
        id_412: {
          id: "id_412",
          imgSrc: require("../img/enemyImg/enemy_icon_410.png"),
          ctName: "班尼迪克蛋黃貓",
          jpName: "ぐでベネにゃんこ",
          enName: "Gudebene Cat",
          type: "白色敵人",
        },
        id_413: {
          id: "id_413",
          imgSrc: require("../img/enemyImg/enemy_icon_411.png"),
          ctName: "猩好男人",
          jpName: "ゴリ男氏",
          enName: "Gorilliam",
          type: "異星戰士",
        },
        id_414: {
          id: "id_414",
          imgSrc: require("../img/enemyImg/enemy_icon_412.png"),
          ctName: "古代松鼠",
          jpName: "イングリッス",
          enName: "Sir Rel",
          type: "古代種",
        },
        id_415: {
          id: "id_415",
          imgSrc: require("../img/enemyImg/enemy_icon_413.png"),
          ctName: "古代犀聖",
          jpName: "コライノくん",
          enName: "Oldhorn",
          type: "古代種",
        },
        id_416: {
          id: "id_416",
          imgSrc: require("../img/enemyImg/enemy_icon_414.png"),
          ctName: "古代蠶舌蛾",
          jpName: "超町長",
          enName: "Othom",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=11"',
        },
        id_418: {
          id: "id_418",
          imgSrc: require("../img/enemyImg/enemy_icon_416.png"),
          ctName: "奈美黑",
          jpName: "ナミエちゃん",
          enName: "Selena",
          type: "黑色敵人",
        },
        id_419: {
          id: "id_419",
          imgSrc: require("../img/enemyImg/enemy_icon_417.png"),
          ctName: "快豚星人",
          jpName: "マナブくん",
          enName: "Kid Tappa",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_420: {
          id: "id_420",
          imgSrc: require("../img/enemyImg/enemy_icon_418.png"),
          ctName: "食蛙 星人",
          jpName: "ゲコック",
          enName: "Ribbo",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_421: {
          id: "id_421",
          imgSrc: require("../img/enemyImg/enemy_icon_419.png"),
          ctName: "神（ 認真）",
          jpName: "神さま（本気）",
          enName: "Cat God (Cool Dude)",
          type: "白色敵人",
        },
        id_422: {
          id: "id_422",
          imgSrc: require("../img/enemyImg/enemy_icon_420.png"),
          ctName: "古代眼鏡猴人",
          jpName: "ダテメガネル",
          enName: "Loris",
          type: "古代種",
        },
        id_423: {
          id: "id_423",
          imgSrc: require("../img/enemyImg/enemy_icon_421.png"),
          ctName: "大天使俄勒方特",
          jpName: "大天使エルファント",
          enName: "Le'saint",
          type: "天使",
        },
        id_424: {
          id: "id_424",
          imgSrc: require("../img/enemyImg/enemy_icon_422.png"),
          ctName: "紅獄肌熊",
          jpName: "レッドヘルクマッチョ",
          enName: "The Red Malice",
          type: "紅色敵人",
        },
        id_425: {
          id: "id_425",
          imgSrc: require("../img/enemyImg/enemy_icon_423.png"),
          ctName: "古頭王",
          jpName: "古我王",
          enName: "Lowkey",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=11"',
        },
        id_426: {
          id: "id_426",
          imgSrc: require("../img/enemyImg/enemy_icon_424.png"),
          ctName: "鴕鳥老黛麗",
          jpName: "オールドリー",
          enName: "M. Ost",
          type: "古代種",
        },
        id_427: {
          id: "id_427",
          imgSrc: require("../img/enemyImg/enemy_icon_425.png"),
          ctName: "跑到死太郎",
          jpName: "ダッシュ 死太郎",
          enName: "Dead Donny Dash",
          type: "不死生物",
        },
        id_428: {
          id: "id_428",
          imgSrc: require("../img/enemyImg/enemy_icon_426.png"),
          ctName: "職權騷擾一族部長",
          jpName: "パワハラッコ部長",
          enName: "CTO Seal",
          type: "紅色敵人",
        },
        id_429: {
          id: "id_429",
          imgSrc: require("../img/enemyImg/enemy_icon_427.png"),
          ctName: "科熊怪人",
          jpName: "クマンケン",
          enName: "Cadaver Bear",
          type: "不死 生物",
        },
        id_430: {
          id: "id_430",
          imgSrc: require("../img/enemyImg/enemy_icon_428.png"),
          ctName: "玉米鬚豬",
          jpName: "シノシシ",
          enName: "Dread Bore",
          type: "不死生物",
        },
        id_431: {
          id: "id_431",
          imgSrc: require("../img/enemyImg/enemy_icon_429.png"),
          ctName: "胡桃鉗魔女",
          jpName: "ホムリリィ",
          enName: "Homulilly",
          type: "魔女",
        },
        id_432: {
          id: "id_432",
          imgSrc: require("../img/enemyImg/enemy_icon_430.png"),
          ctName: "撒旦老人",
          jpName: "サタンクロース",
          enName: "Satan Claus",
          type: "異星戰士",
        },
        id_433: {
          id: "id_433",
          imgSrc: require("../img/enemyImg/enemy_icon_431.png"),
          ctName: "愛作夢的貘",
          jpName: "ユメミちゃん",
          enName: "Bakoo",
          type: "黑色敵人",
        },
        id_434: {
          id: "id_434",
          imgSrc: require("../img/enemyImg/enemy_icon_432.png"),
          ctName: "",
          jpName: "ヒカキン",
          enName: "Hikakin",
          type: "白色敵人",
        },
        id_435: {
          id: "id_435",
          imgSrc: require("../img/enemyImg/enemy_icon_433.png"),
          ctName: "",
          jpName: "ムキャキン",
          enName: "Mukyakin",
          type: "白色敵人",
        },
        id_436: {
          id: "id_436",
          imgSrc: require("../img/enemyImg/enemy_icon_434.png"),
          ctName: "獅子姐妹",
          jpName: "獅子姉妹",
          enName: "Sister Lione",
          type: "漂浮敵人",
        },
        id_437: {
          id: "id_437",
          imgSrc: require("../img/enemyImg/enemy_icon_435.png"),
          ctName: "6週年紀念生日蛋糕",
          jpName: "6周年記念ケー キわんこ",
          enName: "6th Anniversary Birthday Cake",
          type: "鋼鐵敵人",
        },
        id_438: {
          id: "id_438",
          imgSrc: require("../img/enemyImg/enemy_icon_436.png"),
          ctName: "6週年紀念木人城",
          jpName: "6周年記念木人城",
          enName: "6th Anniversary Scarecrow",
          type: "無屬性敵人",
        },
        id_439: {
          id: "id_439",
          imgSrc: require("../img/enemyImg/enemy_icon_437.png"),
          ctName: "招福卷狗",
          jpName: "幸福の犬",
          enName: "Lucky Dags",
          type: "黑色敵人",
        },
        id_440: {
          id: "id_440",
          imgSrc: require("../img/enemyImg/enemy_icon_438.png"),
          ctName: "古代旋風",
          jpName: "エンシェントサイクロン",
          enName: "Primeval Cyclone",
          type: "古代種",
        },
        id_441: {
          id: "id_441",
          imgSrc: require("../img/enemyImg/enemy_icon_439.png"),
          ctName: "小獅豬",
          jpName: "ちびイノシャシ",
          enName: "Li'l Bore",
          type: "紅色敵人",
        },
        id_442: {
          id: "id_442",
          imgSrc: require("../img/enemyImg/enemy_icon_440.png"),
          ctName: "彩虹熊熊敢死隊",
          jpName: "レインボークマトーク",
          enName: "Variety Bears",
          type: '紅色敵人, <a href="enemies.aspx?attribute_id=4"',
        },
        id_443: {
          id: "id_443",
          imgSrc: require("../img/enemyImg/enemy_icon_441.png"),
          ctName: "進化Saber",
          jpName: "セイバーオルタ",
          enName: "Saber Alter",
          type: "白色敵人",
        },
        id_444: {
          id: "id_444",
          imgSrc: require("../img/enemyImg/enemy_icon_442.png"),
          ctName: "清純女老師",
          jpName: "マドンナ先生",
          enName: "Ms. Madonna",
          type: "白色敵人",
        },
        id_445: {
          id: "id_445",
          imgSrc: require("../img/enemyImg/enemy_icon_443.png"),
          ctName: "邪星小旋風",
          jpName: "ミニスターサイクロン",
          enName: "Mesocosmocyclone",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_446: {
          id: "id_446",
          imgSrc: require("../img/enemyImg/enemy_icon_444.png"),
          ctName: "花園鰻5兄弟",
          jpName: "チンアナ5兄弟",
          enName: "Gardeneel Bros.",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_447: {
          id: "id_447",
          imgSrc: require("../img/enemyImg/enemy_icon_445.png"),
          ctName: "六角龍邪",
          jpName: "ルーパールーパー",
          enName: "Axoloty",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_448: {
          id: "id_448",
          imgSrc: require("../img/enemyImg/enemy_icon_446.png"),
          ctName: "終極千兆宏偉神",
          jpName: "ファイナルギガグランド神さま",
          enName: "Final Boss Giga-God (Cool Dude)",
          type: "白色敵人",
        },
        id_449: {
          id: "id_449",
          imgSrc: require("../img/enemyImg/enemy_icon_447.png"),
          ctName: "議事阻撓邪星貓",
          jpName: "スターフィリバスター",
          enName: "Filibuster Obstructa",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_451: {
          id: "id_451",
          imgSrc: require("../img/enemyImg/enemy_icon_449.png"),
          ctName: "柏餅2.0",
          jpName: "柏餅2.0",
          enName: "HaterBaa 2.0",
          type: "鋼鐵敵人",
        },
        id_452: {
          id: "id_452",
          imgSrc: require("../img/enemyImg/enemy_icon_450.png"),
          ctName: "土偶喵丸",
          jpName: "土偶戦士ドグ丸",
          enName: "Dogumaru",
          type: "古代種",
        },
        id_454: {
          id: "id_454",
          imgSrc: require("../img/enemyImg/enemy_icon_452.png"),
          ctName: "超級惡魔",
          jpName: "スーパーデビル",
          enName: "Super Devil",
          type: "白色敵人",
        },
        id_455: {
          id: "id_455",
          imgSrc: require("../img/enemyImg/enemy_icon_453.png"),
          ctName: "撒旦瑪利亞",
          jpName: "サタンマリア",
          enName: "Satan Maria",
          type: "白色敵人",
        },
        id_456: {
          id: "id_456",
          imgSrc: require("../img/enemyImg/enemy_icon_454.png"),
          ctName: "神奇瑪利亞",
          jpName: "ワンダーマリア",
          enName: "Wonder Maria",
          type: "漂浮敵人",
        },
        id_457: {
          id: "id_457",
          imgSrc: require("../img/enemyImg/enemy_icon_455.png"),
          ctName: "魔肖猊玀",
          jpName: "魔肖ネロ",
          enName: "Magical Nero",
          type: "白色敵人",
        },
        id_458: {
          id: "id_458",
          imgSrc: require("../img/enemyImg/enemy_icon_456.png"),
          ctName: "首領洛可可",
          jpName: "ヘッドロ ココ",
          enName: "Head Rokoko",
          type: "天使",
        },
        id_459: {
          id: "id_459",
          imgSrc: require("../img/enemyImg/enemy_icon_457.png"),
          ctName: "軟糖貓",
          jpName: "グミネコ",
          enName: "Gummy Cat",
          type: "白色敵人",
        },
        id_460: {
          id: "id_460",
          imgSrc: require("../img/enemyImg/enemy_icon_458.png"),
          ctName: "",
          jpName: "きたろう",
          enName: "Kitarou",
          type: "白色敵人",
        },
        id_461: {
          id: "id_461",
          imgSrc: require("../img/enemyImg/enemy_icon_459.png"),
          ctName: "",
          jpName: "目玉おやじ",
          enName: "Eyeball Father",
          type: "白色敵人",
        },
        id_462: {
          id: "id_462",
          imgSrc: require("../img/enemyImg/enemy_icon_460.png"),
          ctName: "",
          jpName: "ねこ娘",
          enName: "Neko-Musume",
          type: "白色敵人",
        },
        id_463: {
          id: "id_463",
          imgSrc: require("../img/enemyImg/enemy_icon_461.png"),
          ctName: "",
          jpName: "カノとソウマ",
          enName: "Kano and Soma",
          type: "白色敵人",
        },
        id_464: {
          id: "id_464",
          imgSrc: require("../img/enemyImg/enemy_icon_462.png"),
          ctName: "",
          jpName: "ゲキリンチー",
          enName: "Gekirinchii",
          type: "漂浮敵人",
        },
        id_465: {
          id: "id_465",
          imgSrc: require("../img/enemyImg/enemy_icon_463.png"),
          ctName: "",
          jpName: "ジャッジメント",
          enName: "Judgement",
          type: "白色敵人",
        },
        id_466: {
          id: "id_466",
          imgSrc: require("../img/enemyImg/enemy_icon_464.png"),
          ctName: "第13號機疑似神化第3＋形態（暫稱）",
          jpName: "第13号機 疑似シン化第3+形態（推定）",
          enName: "Awakened Eva Unit-13",
          type: "使徒",
        },
        id_467: {
          id: "id_467",
          imgSrc: require("../img/enemyImg/enemy_icon_465.png"),
          ctName: "貓化巧克力",
          jpName: "",
          enName: "Chocolate Tank Cat",
          type: "白色敵人",
        },
        id_470: {
          id: "id_470",
          imgSrc: require("../img/enemyImg/enemy_icon_468.png"),
          ctName: "不死小雞",
          jpName: "チキランラン",
          enName: "Zuche",
          type: "不死生物",
        },
        id_471: {
          id: "id_471",
          imgSrc: require("../img/enemyImg/enemy_icon_469.png"),
          ctName: "驚悚幫",
          jpName: "スリラーズ",
          enName: "The Thrillerz",
          type: "不死生物",
        },
        id_472: {
          id: "id_472",
          imgSrc: require("../img/enemyImg/enemy_icon_470.png"),
          ctName: "戽斗貓",
          jpName: "",
          enName: "Shakurel Cat",
          type: "白色敵人",
        },
        id_473: {
          id: "id_473",
          imgSrc: require("../img/enemyImg/enemy_icon_471.png"),
          ctName: "戽斗猩猩",
          jpName: "",
          enName: "Shakurel Gory",
          type: "白色敵人",
        },
        id_474: {
          id: "id_474",
          imgSrc: require("../img/enemyImg/enemy_icon_472.png"),
          ctName: "戽斗臉君",
          jpName: "",
          enName: "Shakurel Face",
          type: "白色敵人",
        },
        id_475: {
          id: "id_475",
          imgSrc: require("../img/enemyImg/enemy_icon_473.png"),
          ctName: "戽斗獅子",
          jpName: "",
          enName: "Shakurel Lion",
          type: "白色敵人",
        },
        id_476: {
          id: "id_476",
          imgSrc: require("../img/enemyImg/enemy_icon_474.png"),
          ctName: "戽斗老虎",
          jpName: "",
          enName: "Shakurel Tiger",
          type: "白色敵人",
        },
        id_477: {
          id: "id_477",
          imgSrc: require("../img/enemyImg/enemy_icon_475.png"),
          ctName: "戽斗貓熊",
          jpName: "",
          enName: "Shakurel Panda",
          type: "白色敵人",
        },
        id_478: {
          id: "id_478",
          imgSrc: require("../img/enemyImg/enemy_icon_476.png"),
          ctName: "點陣英雄",
          jpName: "ドット ヒーロー",
          enName: "Dot Hero",
          type: "紅色敵人",
        },
        id_479: {
          id: "id_479",
          imgSrc: require("../img/enemyImg/enemy_icon_477.png"),
          ctName: "河潤豚",
          jpName: "フグ太くん",
          enName: "Mr. Puffington",
          type: "古代種",
        },
        id_480: {
          id: "id_480",
          imgSrc: require("../img/enemyImg/enemy_icon_478.png"),
          ctName: "喵喵紀念日蛋糕",
          jpName: "ケーキわんこ",
          enName: "Cat Day Cake",
          type: "鋼鐵敵人",
        },
        id_481: {
          id: "id_481",
          imgSrc: require("../img/enemyImg/enemy_icon_479.png"),
          ctName: "超新星鐵砲",
          jpName: "超新星テッサー",
          enName: "Puffsley's Comet",
          type: "異星戰士",
        },
        id_482: {
          id: "id_482",
          imgSrc: require("../img/enemyImg/enemy_icon_480.png"),
          ctName: "隆",
          jpName: "リュウ",
          enName: "Ryu",
          type: "白色敵人",
        },
        id_483: {
          id: "id_483",
          imgSrc: require("../img/enemyImg/enemy_icon_481.png"),
          ctName: "春麗",
          jpName: "春麗",
          enName: "Chun-Li",
          type: "白色敵人",
        },
        id_484: {
          id: "id_484",
          imgSrc: require("../img/enemyImg/enemy_icon_482.png"),
          ctName: "蓋爾",
          jpName: "ガイル",
          enName: "Guile",
          type: "白色敵人",
        },
        id_485: {
          id: "id_485",
          imgSrc: require("../img/enemyImg/enemy_icon_483.png"),
          ctName: "桑吉爾夫",
          jpName: "ザンギエフ",
          enName: "Zangief",
          type: "紅 色敵人",
        },
        id_486: {
          id: "id_486",
          imgSrc: require("../img/enemyImg/enemy_icon_484.png"),
          ctName: "布蘭卡",
          jpName: "ブランカ",
          enName: "Blanka",
          type: "白色敵人",
        },
        id_487: {
          id: "id_487",
          imgSrc: require("../img/enemyImg/enemy_icon_485.png"),
          ctName: "塔爾錫",
          jpName: "ダルシム",
          enName: "Dhalsim",
          type: "白色敵人",
        },
        id_488: {
          id: "id_488",
          imgSrc: require("../img/enemyImg/enemy_icon_486.png"),
          ctName: "肯",
          jpName: "ケン",
          enName: "Ken",
          type: "紅色敵人",
        },
        id_489: {
          id: "id_489",
          imgSrc: require("../img/enemyImg/enemy_icon_487.png"),
          ctName: "車塔",
          jpName: "？",
          enName: "？",
          type: "無屬性敵人",
        },
        id_490: {
          id: "id_490",
          imgSrc: require("../img/enemyImg/enemy_icon_488.png"),
          ctName: "豪鬼",
          jpName: "豪鬼",
          enName: "Akuma",
          type: "黑色敵人",
        },
        id_491: {
          id: "id_491",
          imgSrc: require("../img/enemyImg/enemy_icon_489.png"),
          ctName: "7週年紀念生日蛋糕",
          jpName: "7周年記念ケーキわんこ",
          enName: "7th Anniversary Birthday Cake",
          type: "鋼鐵敵人",
        },
        id_492: {
          id: "id_492",
          imgSrc: require("../img/enemyImg/enemy_icon_490.png"),
          ctName: "7週年紀念木人 城",
          jpName: "7周年記念木人城",
          enName: "7th Anniversary Scarecrow",
          type: "無屬性敵人",
        },
        id_493: {
          id: "id_493",
          imgSrc: require("../img/enemyImg/enemy_icon_491.png"),
          ctName: "阿龜我王",
          jpName: "阿亀我王",
          enName: "Black Okame",
          type: '紅色敵人, <a href="enemies.aspx?attribute_id=4"',
        },
        id_494: {
          id: "id_494",
          imgSrc: require("../img/enemyImg/enemy_icon_492.png"),
          ctName: "聖者波普",
          jpName: "聖者ポプウ",
          enName: "Heavenly Herald Papuu",
          type: "天使",
        },
        id_495: {
          id: "id_495",
          imgSrc: require("../img/enemyImg/enemy_icon_493.png"),
          ctName: "太古蜜江",
          jpName: "太古の蜜江",
          enName: "Queen Mother V",
          type: '漂浮敵人, <a href="enemies.aspx?attribute_id=11"',
        },
        id_496: {
          id: "id_496",
          imgSrc: require("../img/enemyImg/enemy_icon_494.png"),
          ctName: "老鼠狗",
          jpName: "？",
          enName: "Rat Doge",
          type: "白色敵人",
        },
        id_497: {
          id: "id_497",
          imgSrc: require("../img/enemyImg/enemy_icon_495.png"),
          ctName: "妖怪河童Jr.",
          jpName: "かわわっぱJr.",
          enName: "Kappy Jr.",
          type: "白色敵人",
        },
        id_498: {
          id: "id_498",
          imgSrc: require("../img/enemyImg/enemy_icon_496.png"),
          ctName: "巨狼與烏爾斯",
          jpName: "フェンリルとウルス",
          enName: "Urs &amp; Fenrir",
          type: "古代種",
        },
        id_499: {
          id: "id_499",
          imgSrc: require("../img/enemyImg/enemy_icon_497.png"),
          ctName: "鋼鐵終結鱷",
          jpName: "ワーニネーター",
          enName: "Croconator",
          type: "鋼鐵敵人",
        },
        id_500: {
          id: "id_500",
          imgSrc: require("../img/enemyImg/enemy_icon_498.png"),
          ctName: "毒火雞",
          jpName: "タッキー",
          enName: "Gobble",
          type: "漂浮敵人",
        },
        id_501: {
          id: "id_501",
          imgSrc: require("../img/enemyImg/enemy_icon_499.png"),
          ctName: "",
          jpName: "ヒュージゴマ",
          enName: "Baron Seal",
          type: "紅色敵人",
        },
        id_502: {
          id: "id_502",
          imgSrc: require("../img/enemyImg/enemy_icon_500.png"),
          ctName: "初音未來",
          jpName: "初音ミク",
          enName: "Hatsune Miku",
          type: "漂浮敵人",
        },
        id_503: {
          id: "id_503",
          imgSrc: require("../img/enemyImg/enemy_icon_501.png"),
          ctName: "櫻初音",
          jpName: "桜ミク",
          enName: "Sakura Miku",
          type: "漂浮敵人",
        },
        id_504: {
          id: "id_504",
          imgSrc: require("../img/enemyImg/enemy_icon_502.png"),
          ctName: "鏡音鈴·連",
          jpName: "鏡音リン＆レン",
          enName: "Kagamine Rin &amp; Len",
          type: "漂浮敵人",
        },
        id_505: {
          id: "id_505",
          imgSrc: require("../img/enemyImg/enemy_icon_503.png"),
          ctName: "?",
          jpName: "?",
          enName: "?",
          type: "白色敵人",
        },
        id_506: {
          id: "id_506",
          imgSrc: require("../img/enemyImg/enemy_icon_504.png"),
          ctName: "?",
          jpName: "?",
          enName: "?",
          type: "白色敵人",
        },
        id_507: {
          id: "id_507",
          imgSrc: require("../img/enemyImg/enemy_icon_505.png"),
          ctName: "?",
          jpName: "?",
          enName: "?",
          type: "白色敵人",
        },
        id_508: {
          id: "id_508",
          imgSrc: require("../img/enemyImg/enemy_icon_506.png"),
          ctName: "綺羅星汪汪",
          jpName: "綺羅星ペロ",
          enName: "Everlord Wanwan",
          type: '異星戰士, <a href="enemies.aspx?attribute_id=9"',
        },
        id_509: {
          id: "id_509",
          imgSrc: require("../img/enemyImg/enemy_icon_507.png"),
          ctName: "",
          jpName: "メシエ",
          enName: "Messier",
          type: "漂浮敵人",
        },
        id_510: {
          id: "id_510",
          imgSrc: require("../img/enemyImg/enemy_icon_508.png"),
          ctName: "",
          jpName: "ネコ焼そばU.F.O.",
          enName: "Yakisoba U.F.O. Cat",
          type: "漂浮敵人",
        },
        id_511: {
          id: "id_511",
          imgSrc: require("../img/enemyImg/enemy_icon_509.png"),
          ctName: "?",
          jpName: "？",
          enName: "?",
          type: "漂浮敵人",
        },
        id_512: {
          id: "id_512",
          imgSrc: require("../img/enemyImg/enemy_icon_510.png"),
          ctName: "巨象黑藏",
          jpName: "ジャイアント黒蔵",
          enName: "Le'Grim",
          type: "黑色敵 人",
        },
        id_513: {
          id: "id_513",
          imgSrc: require("../img/enemyImg/enemy_icon_511.png"),
          ctName: "死靈妖精海蝶",
          jpName: "死霊妖精クオリネム",
          enName: "Death Angel Z-Onel",
          type: "不死生物",
        },
        id_514: {
          id: "id_514",
          imgSrc: require("../img/enemyImg/enemy_icon_512.png"),
          ctName: "迷你不死旋風",
          jpName: "ミニアンデッドサイクロン",
          enName: "Li'l Zyclone",
          type: "不死生物",
        },
        id_515: {
          id: "id_515",
          imgSrc: require("../img/enemyImg/enemy_icon_513.png"),
          ctName: "",
          jpName: "天使ドーヴエル",
          enName: "St. Dober",
          type: "天使",
        },
        id_516: {
          id: "id_516",
          imgSrc: require("../img/enemyImg/enemy_icon_514.png"),
          ctName: "愛假哭的貘",
          jpName: "ドレミちゃん",
          enName: "Doremi",
          type: "白色敵人",
        },
        id_517: {
          id: "id_517",
          imgSrc: require("../img/enemyImg/enemy_icon_515.png"),
          ctName: "",
          jpName: "ギガガガ",
          enName: "Mega",
          type: "漂浮敵人",
        },
        id_518: {
          id: "id_518",
          imgSrc: require("../img/enemyImg/enemy_icon_516.png"),
          ctName: "達人烏嚕哩",
          jpName: "達人ウリル",
          enName: "Master Uril",
          type: "白色敵人",
        },
        id_519: {
          id: "id_519",
          imgSrc: require("../img/enemyImg/enemy_icon_517.png"),
          ctName: "鋼鐵無尾熊球",
          jpName: "メタルコアラッキョ",
          enName: "Koronium",
          type: "鋼鐵敵人",
        },
        id_520: {
          id: "id_520",
          imgSrc: require("../img/enemyImg/enemy_icon_518.png"),
          ctName: "超級宙斯",
          jpName: "スーパーゼウス",
          enName: "Super Zeus",
          type: "天使",
        },
        id_521: {
          id: "id_521",
          imgSrc: require("../img/enemyImg/enemy_icon_519.png"),
          ctName: "巫師汗",
          jpName: "シャーマンカーン",
          enName: "Shaman Khan",
          type: "天使",
        },
        id_522: {
          id: "id_522",
          imgSrc: require("../img/enemyImg/enemy_icon_520.png"),
          ctName: "耶穌大力士",
          jpName: "ヘラクライスト",
          enName: "Herchrist",
          type: "天使",
        },
        id_523: {
          id: "id_523",
          imgSrc: require("../img/enemyImg/enemy_icon_521.png"),
          ctName: "約翰藍龍",
          jpName: "ジョン・レオン",
          enName: "Johnnyleon",
          type: '紅色敵人, <a href="enemies.aspx?attribute_id=8"',
        },
        id_524: {
          id: "id_524",
          imgSrc: require("../img/enemyImg/enemy_icon_522.png"),
          ctName: "?",
          jpName: "?",
          enName: "?",
          type: "無屬性敵人",
        },
        id_525: {
          id: "id_525",
          imgSrc: require("../img/enemyImg/enemy_icon_523.png"),
          ctName: "",
          jpName: "記念ケーキわんこ",
          enName: "Happy Birthday Cake",
          type: "鋼鐵敵人",
        },
        id_526: {
          id: "id_526",
          imgSrc: require("../img/enemyImg/enemy_icon_524.png"),
          ctName: "?",
          jpName: "?",
          enName: "Surge Base",
          type: "無屬性 敵人",
        },
        id_527: {
          id: "id_527",
          imgSrc: require("../img/enemyImg/enemy_icon_525.png"),
          ctName: "",
          jpName: "デッカーバチャン",
          enName: "Horror",
          type: "異星戰士",
        },
        id_528: {
          id: "id_528",
          imgSrc: require("../img/enemyImg/enemy_icon_526.png"),
          ctName: "異弟:Re",
          jpName: "イディ:Re",
          enName: "Idi:Re",
          type: "古代種",
        },
        id_529: {
          id: "id_529",
          imgSrc: require("../img/enemyImg/enemy_icon_527.png"),
          ctName: "紫骨不死燕",
          jpName: "テバムラサキホネツバメ",
          enName: "Zollow",
          type: "不死生物",
        },
        id_530: {
          id: "id_530",
          imgSrc: require("../img/enemyImg/enemy_icon_528.png"),
          ctName: "",
          jpName: "エドモンド本田",
          enName: "E. Honda",
          type: "白色敵人",
        },
        id_531: {
          id: "id_531",
          imgSrc: require("../img/enemyImg/enemy_icon_529.png"),
          ctName: "",
          jpName: "バイソン",
          enName: "Balrog",
          type: "白色敵人",
        },
        id_532: {
          id: "id_532",
          imgSrc: require("../img/enemyImg/enemy_icon_530.png"),
          ctName: "",
          jpName: "バルログ",
          enName: "Vega",
          type: "白色敵人",
        },
        id_533: {
          id: "id_533",
          imgSrc: require("../img/enemyImg/enemy_icon_531.png"),
          ctName: "",
          jpName: "サガット",
          enName: "Sagat",
          type: "白色敵人",
        },
        id_534: {
          id: "id_534",
          imgSrc: require("../img/enemyImg/enemy_icon_532.png"),
          ctName: "",
          jpName: "ベガ",
          enName: "M. Bison",
          type: "漂浮敵人",
        },
        id_535: {
          id: "id_535",
          imgSrc: require("../img/enemyImg/enemy_icon_533.png"),
          ctName: "",
          jpName: "8周年 記念ケーキわんこ",
          enName: "8th Anniversary Birthday Cake\t",
          type: "鋼鐵敵人",
        },
        id_536: {
          id: "id_536",
          imgSrc: require("../img/enemyImg/enemy_icon_534.png"),
          ctName: "",
          jpName: "8周年記念木人 城",
          enName: "8th Anniversary Scarecrow",
          type: "無屬性敵人",
        },
        id_537: {
          id: "id_537",
          imgSrc: require("../img/enemyImg/enemy_icon_535.png"),
          ctName: "惡之貓帝王",
          jpName: "悪のネコ帝王",
          enName: "",
          type: "古代種",
        },
        id_538: {
          id: "id_538",
          imgSrc: require("../img/enemyImg/enemy_icon_536.png"),
          ctName: "巡音流歌",
          jpName: "巡音ルカ",
          enName: "Megurine Luka",
          type: "漂浮敵人",
        },
        id_539: {
          id: "id_539",
          imgSrc: require("../img/enemyImg/enemy_icon_537.png"),
          ctName: "",
          jpName: "ウシわんこ",
          enName: "Cow Doge",
          type: "白色敵人",
        },
        id_540: {
          id: "id_540",
          imgSrc: require("../img/enemyImg/enemy_icon_538.png"),
          ctName: "飛機頭豬",
          jpName: "ウリボーイ",
          enName: "Bore Jr.",
          type: "白色敵人",
        },
        id_541: {
          id: "id_541",
          imgSrc: require("../img/enemyImg/enemy_icon_539.png"),
          ctName: "？",
          jpName: "？",
          enName: "Chocolate Wall Doge",
          type: "黑色敵人",
        },
        id_542: {
          id: "id_542",
          imgSrc: require("../img/enemyImg/enemy_icon_540.png"),
          ctName: "雪初音",
          jpName: "雪ミ ク",
          enName: "Snow Miku",
          type: "漂浮敵人",
        },
        id_543: {
          id: "id_543",
          imgSrc: require("../img/enemyImg/enemy_icon_541.png"),
          ctName: "狐兵衛",
          jpName: "ごん兵衛",
          enName: "Raynard",
          type: "紅 色敵人",
        },
        id_544: {
          id: "id_544",
          imgSrc: require("../img/enemyImg/enemy_icon_542.png"),
          ctName: "早乙女亂馬（男）",
          jpName: "早乙女乱馬（男）",
          enName: "Ranma Saotome (M)",
          type: "白色敵人",
        },
        id_545: {
          id: "id_545",
          imgSrc: require("../img/enemyImg/enemy_icon_543.png"),
          ctName: "天道茜",
          jpName: "天道あかね",
          enName: "Akane Tendo",
          type: "白色敵人",
        },
        id_546: {
          id: "id_546",
          imgSrc: require("../img/enemyImg/enemy_icon_544.png"),
          ctName: "響良牙",
          jpName: "響良牙",
          enName: "Hibiki Ryoga",
          type: "白色敵人",
        },
        id_547: {
          id: "id_547",
          imgSrc: require("../img/enemyImg/enemy_icon_545.png"),
          ctName: "珊璞",
          jpName: "シャンプー",
          enName: "Shampoo",
          type: "白色敵人",
        },
        id_548: {
          id: "id_548",
          imgSrc: require("../img/enemyImg/enemy_icon_546.png"),
          ctName: "沐絲",
          jpName: "ムース",
          enName: "Mousse",
          type: "白色敵人",
        },
        id_549: {
          id: "id_549",
          imgSrc: require("../img/enemyImg/enemy_icon_547.png"),
          ctName: "人魚尾獅",
          jpName: "マーさん",
          enName: "Mr. Mer",
          type: "白色敵人",
        },
        id_550: {
          id: "id_550",
          imgSrc: require("../img/enemyImg/enemy_icon_548.png"),
          ctName: "",
          jpName: "ネコウエハースBIG",
          enName: "King Ingot Cat",
          type: "白色敵人",
        },
        id_551: {
          id: "id_551",
          imgSrc: require("../img/enemyImg/enemy_icon_549.png"),
          ctName: "憤怒的黑猩猩",
          jpName: "怒りのブラッゴリ",
          enName: "Ragin' Gory",
          type: "黑色敵人",
        },
        id_552: {
          id: "id_552",
          imgSrc: require("../img/enemyImg/enemy_icon_550.png"),
          ctName: "哥吉拉",
          jpName: "ゴジラ",
          enName: "Shin Godzilla",
          type: "白色敵人",
        },
        id_553: {
          id: "id_553",
          imgSrc: require("../img/enemyImg/enemy_icon_551.png"),
          ctName: "古神炎多龍",
          jpName: "古神炎ドロン",
          enName: "Elder Flame Doron",
          type: "古 代種",
        },
        id_554: {
          id: "id_554",
          imgSrc: require("../img/enemyImg/enemy_icon_552.png"),
          ctName: "惡魔狗仔哥",
          jpName: "デビルワン",
          enName: "Aku Doge",
          type: "惡魔",
        },
        id_555: {
          id: "id_555",
          imgSrc: require("../img/enemyImg/enemy_icon_553.png"),
          ctName: "惡魔扭扭蛇",
          jpName: "インフェルに ょろ",
          enName: "",
          type: "惡魔",
        },
        id_556: {
          id: "id_556",
          imgSrc: require("../img/enemyImg/enemy_icon_554.png"),
          ctName: "惡魔三兄弟",
          jpName: "ケルベローズ",
          enName: "Cerberus Kids",
          type: "惡魔",
        },
        id_557: {
          id: "id_557",
          imgSrc: require("../img/enemyImg/enemy_icon_555.png"),
          ctName: "惡魔企鵝大哥",
          jpName: "ギルティ・ペン",
          enName: "",
          type: "惡魔",
        },
        id_558: {
          id: "id_558",
          imgSrc: require("../img/enemyImg/enemy_icon_556.png"),
          ctName: "惡魔大猩猩",
          jpName: "ヘルゴリラー",
          enName: "Aku Gory",
          type: "惡魔",
        },
        id_559: {
          id: "id_559",
          imgSrc: require("../img/enemyImg/enemy_icon_557.png"),
          ctName: "",
          jpName: "悪魔ベヒモッス",
          enName: "",
          type: "惡魔",
        },
        id_560: {
          id: "id_560",
          imgSrc: require("../img/enemyImg/enemy_icon_558.png"),
          ctName: "",
          jpName: "アックマ閣下",
          enName: "",
          type: "惡魔",
        },
        id_561: {
          id: "id_561",
          imgSrc: require("../img/enemyImg/enemy_icon_559.png"),
          ctName: "",
          jpName: "魔我王",
          enName: "",
          type: "惡魔",
        },
        id_562: {
          id: "id_562",
          imgSrc: require("../img/enemyImg/enemy_icon_560.png"),
          ctName: "惡魔大旋風",
          jpName: "デ ビルサイクロン",
          enName: "Aku Cyclone",
          type: "惡魔",
        },
        id_563: {
          id: "id_563",
          imgSrc: require("../img/enemyImg/enemy_icon_561.png"),
          ctName: "",
          jpName: "?",
          enName: "Wicked Cat",
          type: "惡 魔",
        },
        id_564: {
          id: "id_564",
          imgSrc: require("../img/enemyImg/enemy_icon_562.png"),
          ctName: "",
          jpName: "?",
          enName: "Wicked Tank Cat",
          type: "惡魔",
        },
        id_565: {
          id: "id_565",
          imgSrc: require("../img/enemyImg/enemy_icon_563.png"),
          ctName: "",
          jpName: "?",
          enName: "Wicked Axe Cat",
          type: "惡魔",
        },
        id_572: {
          id: "id_572",
          imgSrc: require("../img/enemyImg/enemy_icon_570.png"),
          ctName: "",
          jpName: "神官マモーン",
          enName: "",
          type: "惡魔",
        },
        id_573: {
          id: "id_573",
          imgSrc: require("../img/enemyImg/enemy_icon_571.png"),
          ctName: "",
          jpName: "大神官マモーン",
          enName: "",
          type: "惡魔",
        },
        id_574: {
          id: "id_574",
          imgSrc: require("../img/enemyImg/enemy_icon_572.png"),
          ctName: "",
          jpName: "破壊神ジャガンドー",
          enName: "",
          type: "惡魔",
        },
        id_575: {
          id: "id_575",
          imgSrc: require("../img/enemyImg/enemy_icon_573.png"),
          ctName: "",
          jpName: "操られしネコ女王",
          enName: "",
          type: "惡魔",
        },
        id_576: {
          id: "id_576",
          imgSrc: require("../img/enemyImg/enemy_icon_574.png"),
          ctName: "",
          jpName: "?",
          enName: "Aku Base",
          type: "無屬性敵人",
        },
        id_577: {
          id: "id_577",
          imgSrc: require("../img/enemyImg/enemy_icon_575.png"),
          ctName: "",
          jpName: "?",
          enName: "Inactive Aku Base",
          type: "無屬性敵人",
        },
        id_578: {
          id: "id_578",
          imgSrc: require("../img/enemyImg/enemy_icon_576.png"),
          ctName: "",
          jpName: "?",
          enName: "",
          type: "白色敵人",
        },
        id_579: {
          id: "id_579",
          imgSrc: require("../img/enemyImg/enemy_icon_577.png"),
          ctName: "",
          jpName: "?",
          enName: "",
          type: "紅色敵人",
        },
        id_580: {
          id: "id_580",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "?",
          enName: "",
          type: "鋼鐵敵人",
        },
        id_581: {
          id: "id_581",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "キュゥべえ",
          enName: "Kyubey",
          type: "白色敵人",
        },
        id_582: {
          id: "id_582",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "?",
          enName: "",
          type: "",
        },
        id_583: {
          id: "id_583",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "?",
          enName: "",
          type: "",
        },
        id_584: {
          id: "id_584",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "?",
          enName: "",
          type: "",
        },
        id_585: {
          id: "id_585",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "マデューさん",
          enName: "",
          type: "",
        },
        id_586: {
          id: "id_586",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "シスターデビル",
          enName: "",
          type: "",
        },
        id_587: {
          id: "id_587",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "サタンカーメン8号",
          enName: "",
          type: "",
        },
        id_588: {
          id: "id_588",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "ミッドナイトナカイ",
          enName: "",
          type: "",
        },
        id_589: {
          id: "id_589",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "デビルカツヤ",
          enName: "",
          type: "",
        },
        id_590: {
          id: "id_590",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "デスコアラッキョ",
          enName: "",
          type: "",
        },
        id_591: {
          id: "id_591",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "仮面のネコ仙人",
          enName: "",
          type: "",
        },
        id_592: {
          id: "id_592",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "Q周年記念ケーキわんこ",
          enName: "",
          type: "",
        },
        id_593: {
          id: "id_593",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "Q周年記念木人城",
          enName: "",
          type: "",
        },
        id_9002: {
          id: "id_9002",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "HAPPI",
          jpName: "",
          enName: "HAPPI",
          type: "白色敵人",
        },
        id_9003: {
          id: "id_9003",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "HAPPI&amp;麻吉 貓&amp;貓咪",
          jpName: "",
          enName: "HAPPI &amp; Maji Cat &amp; Cat",
          type: "白色敵人",
        },
        id_9004: {
          id: "id_9004",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "麻吉貓&amp;貓咪旅行團",
          jpName: "",
          enName: "Maji Cat &amp; Cat Tour Group",
          type: "白色敵人",
        },
        id_9005: {
          id: "id_9005",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "三原慧悟",
          jpName: "",
          enName: "Hiroshi Mihara",
          type: "鋼鐵敵人",
        },
        id_9006: {
          id: "id_9006",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "偶像三原 &amp; 貓咪",
          jpName: "",
          enName: "Idol Mihara &amp; Cat",
          type: "白色敵人",
        },
        id_9007: {
          id: "id_9007",
          imgSrc: require("../img/noImages.jpg"),
          ctName: "",
          jpName: "",
          enName: "Nekondo SP",
          type: "白色敵人",
        },
      },
      stageDetailList: {
        stageJP01: {
          "01_\u9577\u5d0e\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "02_\u4f50\u8cc0\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "03_\u9e7f\u5150\u5cf6\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "04_\u718a\u672c\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "05_\u5bae\u5d0e\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "06_\u5927\u5206\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "07_\u798f\u5ca1\u770c": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "08_\u9ad8\u77e5\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "09_\u611b\u5a9b\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "10_\u5fb3\u5cf6\u770c": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "11_\u9999\u5ddd\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "12_\u5c71\u53e3\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "13_\u5e83\u5cf6\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "14_\u5cf6\u6839\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "15_\u5ca1\u5c71\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "16_\u9ce5\u53d6\u770c": {
            info: [
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "17_\u5175\u5eab\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "18_\u548c\u6b4c\u5c71\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "19_\u5927\u962a\u5e9c": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "20_\u4eac\u90fd\u5e9c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "21_\u5948\u826f\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "22_\u4e09\u91cd\u770c": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "23_\u6ecb\u8cc0\u770c": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "24_\u798f\u4e95\u770c": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "25_\u77f3\u5ddd\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "26_\u611b\u77e5\u770c": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "27_\u5c90\u961c\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "28_\u5bcc\u5c71\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "29_\u9759\u5ca1\u770c": {
            info: [
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "30_\u5c71\u68a8\u770c": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "31_\u9577\u91ce\u770c": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "32_\u65b0\u6f5f\u770c": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "33_\u795e\u5948\u5ddd\u770c": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "34_\u5343\u8449\u770c": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "35_\u6771\u4eac\u90fd": {
            info: [
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "36_\u57fc\u7389\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "37_\u7fa4\u99ac\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "38_\u6803\u6728\u770c": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "39_\u8328\u57ce\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "40_\u798f\u5cf6\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "41_\u5bae\u57ce\u770c": {
            info: [
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "42_\u5c71\u5f62\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "43_\u5ca9\u624b\u770c": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "44_\u79cb\u7530\u770c": {
            info: [
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "45_\u9752\u68ee\u770c": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "46_\u5317\u6d77\u9053": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "47_\u6c96\u7e04\u770c": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "48_\u897f\u8868\u5cf6": {
            info: [
              { id: "020", jpName: "\u30ab\u30aa\u30eb\u541b" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
        },
        stageJP02: {
          "01_長崎県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "02_佐賀県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "03_鹿児島県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "04_熊本県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "05_宮崎県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "06_大分県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "07_福岡県": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "08_高知県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "09_愛媛県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "10_徳島県": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "11_香川県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "12_山口県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "13_広島県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "14_島根県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "15_岡山県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "16_鳥取県": {
            info: [
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "17_兵庫県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "18_和歌山県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "19_大阪府": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "20_京都府": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "21_奈良県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "22_三重県": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "23_滋賀県": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "24_福井県": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "25_石川県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "26_愛知県": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "27_岐阜県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "28_富山県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "29_静岡県": {
            info: [
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "30_山梨県": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "31_長野県": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "32_新潟県": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "33_神奈川県": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "34_千葉県": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "35_東京都": {
            info: [
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "36_埼玉県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "37_群馬県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "38_栃木県": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "39_茨城県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "40_福島県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "41_宮城県": {
            info: [
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "42_山形県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "43_岩手県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "44_秋田県": {
            info: [
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "45_青森県": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "46_北海道": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "47_沖縄県": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "48_西表島": {
            info: [
              {
                id: "025",
                jpName:
                  "\u60aa\u306e\u5e1d\u738b\u30cb\u30e3\u30f3\u30c0\u30e0",
              },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
        },
        stageJP03: {
          "01_長崎県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "02_佐賀県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "03_鹿児島県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "04_熊本県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "05_宮崎県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "06_大分県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "07_福岡県": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "08_高知県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "09_愛媛県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "10_徳島県": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "11_香川県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "12_山口県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "13_広島県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "14_島根県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "15_岡山県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "16_鳥取県": {
            info: [
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "17_兵庫県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "18_和歌山県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "19_大阪府": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "20_京都府": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "21_奈良県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "22_三重県": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "23_滋賀県": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "24_福井県": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "25_石川県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "26_愛知県": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "27_岐阜県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "28_富山県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "29_静岡県": {
            info: [
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "30_山梨県": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "31_長野県": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "32_新潟県": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "33_神奈川県": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "34_千葉県": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "35_東京都": {
            info: [
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "36_埼玉県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "37_群馬県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "38_栃木県": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "39_茨城県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "40_福島県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "41_宮城県": {
            info: [
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "42_山形県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "43_岩手県": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "44_秋田県": {
            info: [
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "45_青森県": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "46_北海道": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "47_沖縄県": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "48_西表島": {
            info: [
              { id: "026", jpName: "\u3076\u3093\u3076\u3093\u5148\u751f" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
        },
        stageFuture01: {
          "01_日本": {
            info: [
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "02_韓国": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "03_中国": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "04_モンゴル": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "05_ロシア": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "06_ノルウェー": {
            info: [
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "07_イギリス": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "08_デンマーク": {
            info: [
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "09_ドイツ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "10_フランス": {
            info: [
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "11_スペイン": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "12_モナコ": {
            info: [
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "13_イタリア": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "14_ギリシャ": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "15_トルコ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "16_ドバイ": {
            info: [
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "17_インド": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "18_ネパール": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "19_タイ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "20_カンボジア": {
            info: [
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "21_フィリピン": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "22_シンガポール": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "23_オーストラリア": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "24_深淵の大渦": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "25_マダガスカル": {
            info: [
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "26_ケニア": {
            info: [
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "27_サウジアラビア": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "28_エジプト": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "29_サハラ": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "30_ガーナ": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "31_南アフリカ": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "32_アルゼンチン": {
            info: [
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "33_イースター島": {
            info: [
              { id: "020", jpName: "\u30ab\u30aa\u30eb\u541b" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "34_マチュピチュ": {
            info: [
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "35_コロンビア": {
            info: [
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "36_ジャマイカ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "37_メキシコ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "38_ハリウッド": {
            info: [
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "39_ラスベガス": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "40_アラスカ": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "41_カナダ": {
            info: [
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "42_グリーンランド": {
            info: [
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "43_ニューヨーク": {
            info: [
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "44_NASA": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "45_バミューダ": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "46_ブラジル": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "47_浮遊大陸": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "48_月": {
            info: [
              {
                id: "178",
                jpName:
                  "\u7834\u58ca\u751f\u7269\u30af\u30aa\u30ea\u30cd\u30f3",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
        },
        stageFuture02: {
          "01_日本": {
            info: [
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "02_韓国": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "03_中国": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "04_モンゴル": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "05_ロシア": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "06_ノルウェー": {
            info: [
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "07_イギリス": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "08_デンマーク": {
            info: [
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "09_ドイツ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "10_フランス": {
            info: [
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "11_スペイン": {
            info: [
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "12_モナコ": {
            info: [
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "13_イタリア": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "14_ギリシャ": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "15_トルコ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "16_ドバイ": {
            info: [
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "17_インド": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "18_ネパール": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "19_タイ": {
            info: [
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "20_カンボジア": {
            info: [
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "21_フィリピン": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "22_シンガポール": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "23_オーストラリア": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "24_深淵の大渦": {
            info: [
              {
                id: "182",
                jpName:
                  "\u30ae\u30e3\u30e9\u30af\u30b7\u30fc\u30cb\u30e3\u30f3\u30c0\u30e0",
              },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "25_マダガスカル": {
            info: [
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "26_ケニア": {
            info: [
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "27_サウジアラビア": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "28_エジプト": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "29_サハラ": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "30_ガーナ": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "31_南アフリカ": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "32_アルゼンチン": {
            info: [
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "33_イースター島": {
            info: [
              { id: "020", jpName: "\u30ab\u30aa\u30eb\u541b" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "148", jpName: "\u306f\u3050\u308c\u305f\u30e4\u30c4" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "34_マチュピチュ": {
            info: [
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "35_コロンビア": {
            info: [
              { id: "126", jpName: "\u30d6\u30e9\u30c3\u30b3" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "36_ジャマイカ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "37_メキシコ": {
            info: [
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "148", jpName: "\u306f\u3050\u308c\u305f\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "38_ハリウッド": {
            info: [
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "39_ラスベガス": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "40_アラスカ": {
            info: [
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "41_カナダ": {
            info: [
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "42_グリーンランド": {
            info: [
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "43_ニューヨーク": {
            info: [
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "44_NASA": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "126", jpName: "\u30d6\u30e9\u30c3\u30b3" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "45_バミューダ": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "46_ブラジル": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "47_浮遊大陸": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "48_月": {
            info: [
              {
                id: "183",
                jpName:
                  "\u53cd\u9006\u306e\u30f4\u30a1\u30eb\u30ad\u30ea\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
        },
        stageFuture03: {
          "01_日本": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "02_韓国": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "03_中国": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "04_モンゴル": {
            info: [
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "05_ロシア": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "06_ノルウェー": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "07_イギリス": {
            info: [
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "08_デンマーク": {
            info: [
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "09_ドイツ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "10_フランス": {
            info: [
              { id: "044", jpName: "\u30bb\u30ec\u30d6" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "044", jpName: "\u30bb\u30ec\u30d6" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "11_スペイン": {
            info: [
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "12_モナコ": {
            info: [
              { id: "210", jpName: "\u3088\u3063\u3061\u3083\u3093" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "13_イタリア": {
            info: [
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "14_ギリシャ": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "148", jpName: "\u306f\u3050\u308c\u305f\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "15_トルコ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "16_ドバイ": {
            info: [
              { id: "211", jpName: "\u30a2\u30eb\u30d1\u30c3\u30ab" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "17_インド": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "151", jpName: "\u677e \u9ed2\u8535" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "18_ネパール": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "19_タイ": {
            info: [
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "149", jpName: "\u30e1\u30bf\u30eb\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "20_カンボジア": {
            info: [
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "21_フィリピン": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "011", jpName: "\u30d1\u30aa\u30f3" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "22_シンガポール": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "23_オーストラリア": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "24_深淵の大渦": {
            info: [
              {
                id: "213",
                jpName:
                  "\u30d1\u30e9\u30b5\u30a4\u30c8\u30d6\u30f3\u30d6\u30f3",
              },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "25_マダガスカル": {
            info: [
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "149", jpName: "\u30e1\u30bf\u30eb\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "26_ケニア": {
            info: [
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "27_サウジアラビア": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "28_エジプト": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "148", jpName: "\u306f\u3050\u308c\u305f\u30e4\u30c4" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "29_サハラ": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "211", jpName: "\u30a2\u30eb\u30d1\u30c3\u30ab" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "30_ガーナ": {
            info: [
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "31_南アフリカ": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "210", jpName: "\u3088\u3063\u3061\u3083\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "32_アルゼンチン": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "33_イースター島": {
            info: [
              { id: "020", jpName: "\u30ab\u30aa\u30eb\u541b" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "148", jpName: "\u306f\u3050\u308c\u305f\u30e4\u30c4" },
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "34_マチュピチュ": {
            info: [
              { id: "212", jpName: "\u30e8\u30ad\u30ab\u30ca" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "035", jpName: "\u30d5\u30eb\u307c\u3063\u3053" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              { id: "148", jpName: "\u306f\u3050\u308c\u305f\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "35_コロンビア": {
            info: [
              { id: "126", jpName: "\u30d6\u30e9\u30c3\u30b3" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "36_ジャマイカ": {
            info: [
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "37_メキシコ": {
            info: [
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "148", jpName: "\u306f\u3050\u308c\u305f\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "38_ハリウッド": {
            info: [
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "39_ラスベガス": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "151", jpName: "\u677e \u9ed2\u8535" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "40_アラスカ": {
            info: [
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "41_カナダ": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "42_グリーンランド": {
            info: [
              { id: "014", jpName: "\u30af\u30de\u5148\u751f" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "43_ニューヨーク": {
            info: [
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "149", jpName: "\u30e1\u30bf\u30eb\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "44_NASA": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "126", jpName: "\u30d6\u30e9\u30c3\u30b3" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "45_バミューダ": {
            info: [
              { id: "210", jpName: "\u3088\u3063\u3061\u3083\u3093" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "005", jpName: "\u30ab\u30d0\u3061\u3083\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "035", jpName: "\u30d5\u30eb\u307c\u3063\u3053" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "46_ブラジル": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "212", jpName: "\u30e8\u30ad\u30ab\u30ca" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "47_浮遊大陸": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "48_月": {
            info: [
              {
                id: "214",
                jpName: "\u66b4\u8d70\u306e\u30cd\u30b3\u30e0\u30fc\u30c8",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "211", jpName: "\u30a2\u30eb\u30d1\u30c3\u30ab" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
        },
        stageUniverse01: {
          "01_地球": {
            info: [
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "043", jpName: "\u3060\u3063\u3075\u3093\u3069" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "02_火星": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "03_木星": {
            info: [
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "04_土星": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "05_金星": {
            info: [
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "06_水星": {
            info: [
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "07_太陽": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "08_ウラヌス": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "09_ネプチューン": {
            info: [
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "10_トリトン": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "11_プルートゥ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "12_赤い長方形星雲": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "13_エスキモー星雲": {
            info: [
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "14_キャッツアイ星雲": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "15_卵星雲": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "16_ひょうたん星雲": {
            info: [
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "17_アルタイル": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "18_シリウス": {
            info: [
              { id: "366", jpName: "\u5de8\u5320" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "19_カノープス": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "20_ベガ": {
            info: [
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "21_アルデバラン": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "22_ベテルギウス": {
            info: [
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "23_デネブ": {
            info: [
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "24_惑星スナック": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "25_サイータ星": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "26_魁皇星": {
            info: [
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "27_大マゼラン星雲": {
            info: [
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "28_ブータラ星": {
            info: [
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "29_モスカンダグ": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "30_コロン星": {
            info: [
              {
                id: "368",
                jpName:
                  "\u30b9\u30da\u30fc\u30b9\u30de\u30f3\u30dc\u30eb\u30b0",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "31_ヤキソパーン": {
            info: [
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "32_ウメ星": {
            info: [
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "33_ダラララ": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "366", jpName: "\u5de8\u5320" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "34_マイドムリ": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "35_メルトズ": {
            info: [
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              { id: "366", jpName: "\u5de8\u5320" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "36_ウラルー": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "37_アグハムム": {
            info: [
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "149", jpName: "\u30e1\u30bf\u30eb\u308f\u3093\u3053" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "38_ソモロン": {
            info: [
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "39_アバ・ブア": {
            info: [
              {
                id: "368",
                jpName:
                  "\u30b9\u30da\u30fc\u30b9\u30de\u30f3\u30dc\u30eb\u30b0",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "40_ティターン": {
            info: [
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "41_デススタン": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "42_ゴリラの惑星": {
            info: [
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "43_チョイバトロン星": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "44_クリムゾン星": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "45_N77星雲": {
            info: [
              { id: "366", jpName: "\u5de8\u5320" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "058",
                jpName: "\u30e1\u30bf\u30eb\u30b5\u30a4\u30dc\u30fc\u30b0",
              },
              { id: "149", jpName: "\u30e1\u30bf\u30eb\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "46_アンドロメダ": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "038", jpName: "\u30a2\u30d2\u30eb\u30f3\u30eb\u30f3" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "47_ブラックホール": {
            info: [
              {
                id: "368",
                jpName:
                  "\u30b9\u30da\u30fc\u30b9\u30de\u30f3\u30dc\u30eb\u30b0",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "149", jpName: "\u30e1\u30bf\u30eb\u308f\u3093\u3053" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "48_ビッグバン": {
            info: [
              { id: "369", jpName: "\u795e\u3055\u307e" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              { id: "366", jpName: "\u5de8\u5320" },
              {
                id: "368",
                jpName:
                  "\u30b9\u30da\u30fc\u30b9\u30de\u30f3\u30dc\u30eb\u30b0",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
        },
        stageUniverse02: {
          "01_地球": {
            info: [
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "043", jpName: "\u3060\u3063\u3075\u3093\u3069" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "02_火星": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "03_木星": {
            info: [
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "04_土星": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "05_金星": {
            info: [
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "06_水星": {
            info: [
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "07_太陽": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "08_ウラヌス": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "09_ネプチューン": {
            info: [
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "10_トリトン": {
            info: [
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "11_プルートゥ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "12_赤い長方形星雲": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "13_エスキモー星雲": {
            info: [
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "007",
                jpName: "\u30b8\u30e3\u30c3\u30ad\u30fc\u30fb\u30da\u30f3",
              },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "14_キャッツアイ星雲": {
            info: [
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "15_卵星雲": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "16_ひょうたん星雲": {
            info: [
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "17_アルタイル": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "18_シリウス": {
            info: [
              { id: "366", jpName: "\u5de8\u5320" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "19_カノープス": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "20_ベガ": {
            info: [
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "21_アルデバラン": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "22_ベテルギウス": {
            info: [
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "23_デネブ": {
            info: [
              {
                id: "182",
                jpName:
                  "\u30ae\u30e3\u30e9\u30af\u30b7\u30fc\u30cb\u30e3\u30f3\u30c0\u30e0",
              },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              {
                id: "213",
                jpName:
                  "\u30d1\u30e9\u30b5\u30a4\u30c8\u30d6\u30f3\u30d6\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "24_惑星スナック": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "25_サイータ星": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "26_魁皇星": {
            info: [
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "27_大マゼラン星雲": {
            info: [
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "28_ブータラ星": {
            info: [
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "29_モスカンダグ": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "30_コロン星": {
            info: [
              {
                id: "368",
                jpName:
                  "\u30b9\u30da\u30fc\u30b9\u30de\u30f3\u30dc\u30eb\u30b0",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "31_ヤキソパーン": {
            info: [
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "32_ウメ星": {
            info: [
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "33_ダラララ": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "366", jpName: "\u5de8\u5320" },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "34_マイドムリ": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "35_メルトズ": {
            info: [
              {
                id: "178",
                jpName:
                  "\u7834\u58ca\u751f\u7269\u30af\u30aa\u30ea\u30cd\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "366", jpName: "\u5de8\u5320" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "36_ウラルー": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "37_アグハムム": {
            info: [
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "38_ソモロン": {
            info: [
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },

          "39_アバ・ブア": {
            info: [
              {
                id: "368",
                jpName:
                  "\u30b9\u30da\u30fc\u30b9\u30de\u30f3\u30dc\u30eb\u30b0",
              },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "40_ティターン": {
            info: [
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "41_デススタン": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "42_ゴリラの惑星": {
            info: [
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },

          "43_チョイバトロン星": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "44_クリムゾン星": {
            info: [
              { id: "050", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b92\u4e16" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "45_N77星雲": {
            info: [
              { id: "366", jpName: "\u5de8\u5320" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "058",
                jpName: "\u30e1\u30bf\u30eb\u30b5\u30a4\u30dc\u30fc\u30b0",
              },
              { id: "149", jpName: "\u30e1\u30bf\u30eb\u308f\u3093\u3053" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "46_アンドロメダ": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "47_ブラックホール": {
            info: [
              {
                id: "368",
                jpName:
                  "\u30b9\u30da\u30fc\u30b9\u30de\u30f3\u30dc\u30eb\u30b0",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "48_ビッグバン": {
            info: [
              {
                id: "421",
                jpName: "\u795e\u3055\u307e\uff08\u672c\u6c17\uff09",
              },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
        },
        stageUniverse03: {
          "01_地球": {
            info: [
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "02_火星": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "03_木星": {
            info: [
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "009", jpName: "\u30e1\u30a7\u30e1\u30a7" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "04_土星": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "05_金星": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "06_水星": {
            info: [
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "07_太陽": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "08_ウラヌス": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "09_ネプチューン": {
            info: [
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "10_トリトン": {
            info: [
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "11_プルートゥ": {
            info: [
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "002", jpName: "\u308f\u3093\u3053" },
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "12_赤い長方形星雲": {
            info: [
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "13_エスキモー星雲": {
            info: [
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              { id: "446", jpName: "\u30c1\u30f3\u30a2\u30ca5\u5144\u5f1f" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "14_キャッツアイ星雲": {
            info: [
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "175", jpName: "\u30e4\u30c9\u30ab\u30ea\u30fc" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "15_卵星雲": {
            info: [
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "16_ひょうたん星雲": {
            info: [
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "17_アルタイル": {
            info: [
              { id: "148", jpName: "\u306f\u3050\u308c\u305f\u30e4\u30c4" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "18_シリウス": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "015", jpName: "\u30ef\u30cb\u30c3\u30af" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "446", jpName: "\u30c1\u30f3\u30a2\u30ca5\u5144\u5f1f" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "19_カノープス": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "20_ベガ": {
            info: [
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "21_アルデバラン": {
            info: [
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "019", jpName: "\u8d64\u7f85\u6211\u738b" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              {
                id: "368",
                jpName:
                  "\u30b9\u30da\u30fc\u30b9\u30de\u30f3\u30dc\u30eb\u30b0",
              },
              { id: "446", jpName: "\u30c1\u30f3\u30a2\u30ca5\u5144\u5f1f" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "22_ベテルギウス": {
            info: [
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "23_デネブ": {
            info: [
              {
                id: "447",
                jpName: "\u30eb\u30fc\u30d1\u30fc\u30eb\u30fc\u30d1\u30fc",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "24_惑星スナック": {
            info: [
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "25_サイータ星": {
            info: [
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "26_魁皇星": {
            info: [
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              { id: "366", jpName: "\u5de8\u5320" },
              {
                id: "447",
                jpName: "\u30eb\u30fc\u30d1\u30fc\u30eb\u30fc\u30d1\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "27_大マゼラン星雲": {
            info: [
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "185", jpName: "\u30b5\u30a4\u30d0\u30fcX" },
              { id: "446", jpName: "\u30c1\u30f3\u30a2\u30ca5\u5144\u5f1f" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "28_ブータラ星": {
            info: [
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "29_モスカンダグ": {
            info: [
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "30_コロン星": {
            info: [
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "31_ヤキソパーン": {
            info: [
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              { id: "174", jpName: "\u30c7\u30ab\u30e1\u30ac\u30cd\u30eb" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "446", jpName: "\u30c1\u30f3\u30a2\u30ca5\u5144\u5f1f" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "32_ウメ星": {
            info: [
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "013", jpName: "\u4e00\u89d2\u304f\u3093" },
              { id: "016", jpName: "\u30a6\u30b5\u9280" },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "33_ダラララ": {
            info: [
              { id: "024", jpName: "\u30ac\u30ac\u30ac\u30ac" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "211", jpName: "\u30a2\u30eb\u30d1\u30c3\u30ab" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "447",
                jpName: "\u30eb\u30fc\u30d1\u30fc\u30eb\u30fc\u30d1\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "34_マイドムリ": {
            info: [
              { id: "177", jpName: "\u30af\u30de\u30f3\u30c1\u30e5\u30fc" },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "35_メルトズ": {
            info: [
              {
                id: "178",
                jpName:
                  "\u7834\u58ca\u751f\u7269\u30af\u30aa\u30ea\u30cd\u30f3",
              },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "36_ウラルー": {
            info: [
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "37_アグハムム": {
            info: [
              { id: "365", jpName: "\u30cf\u30cf\u30d1\u30aa\u30f3" },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "149", jpName: "\u30e1\u30bf\u30eb\u308f\u3093\u3053" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "38_ソモロン": {
            info: [
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "012", jpName: "\u30ab\u30fb\u30f3\u30ac\u30ea\u30e5" },
              {
                id: "054",
                jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
              },
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "39_アバ・ブア": {
            info: [
              { id: "184", jpName: "\u30cf\u30b5\u30df\u30fc\u30de\u30f3" },
              { id: "186", jpName: "\u30d7\u30c9\u30fc\u30eb\u592b\u4eba" },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              {
                id: "447",
                jpName: "\u30eb\u30fc\u30d1\u30fc\u30eb\u30fc\u30d1\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "40_ティターン": {
            info: [
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "010", jpName: "\u30b4\u30de\u3055\u307e" },
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "171", jpName: "\u30ab\u30fc\u30d0\u30c1\u30e3\u30f3" },
              { id: "172", jpName: "\u30b4\u30de\u30b5\u30fc\u30de\u30f3" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "41_デススタン": {
            info: [
              { id: "176", jpName: "\u30ab\u30f2\u30eb\u3055\u3093" },
              { id: "169", jpName: "\u30a8\u30a4\u30ea\u30ef\u30f3" },
              { id: "173", jpName: "\u30ec\u30c7\u30a3\u30fb\u30ac" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "367",
                jpName:
                  "\u30ad\u30e3\u30d7\u30c6\u30f3\u30fb\u30e2\u30b0\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "42_ゴリラの惑星": {
            info: [
              { id: "008", jpName: "\u30b4\u30ea\u3055\u3093" },
              { id: "053", jpName: "\u30d6\u30e9\u30c3\u30b4\u30ea" },
              {
                id: "117",
                jpName: "\u5929\u4f7f\u30b4\u30f3\u30b6\u30ec\u30b9",
              },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "43_チョイバトロン星": {
            info: [
              { id: "003", jpName: "\u306b\u3087\u308d" },
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              { id: "170", jpName: "\u30ef\u30fc\u30cb\u30c3\u30af" },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "44_クリムゾン星": {
            info: [
              { id: "006", jpName: "\u30d6\u30bf\u30e4\u30ed\u30a6" },
              { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
              { id: "180", jpName: "\u30a8\u30ea\u30b6\u30d9\u30b956\u4e16" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "45_N77星雲": {
            info: [
              { id: "004", jpName: "\u4f8b\u306e\u30e4\u30c4" },
              {
                id: "017",
                jpName: "\u30ea\u30c3\u30b9\u30f3\u30c8\u30a5\u30df\u30fc",
              },
              {
                id: "049",
                jpName: "\u30e1\u30bf\u30eb\u30ab\u30d0\u3061\u3083\u3093",
              },
              { id: "149", jpName: "\u30e1\u30bf\u30eb\u308f\u3093\u3053" },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              { id: "366", jpName: "\u5de8\u5320" },
              {
                id: "390",
                jpName: "\u30a6\u30eb\u30c8\u30e9\u30e1\u30a7\u30e1\u30a7",
              },
              { id: "420", jpName: "\u30b2\u30b3\u30c3\u30af" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "46_アンドロメダ": {
            info: [
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "048", jpName: "\u6bba\u610f\u306e\u308f\u3093\u3053" },
              {
                id: "115",
                jpName: "\u5929\u4f7f\u30ab\u30d0\u3061\u3083\u3093",
              },
              {
                id: "116",
                jpName: "\u5929\u4f7f\u30ac\u30d6\u30ea\u30a8\u30eb",
              },
              { id: "120", jpName: "\u8d64\u6bdb\u306e\u306b\u3087\u308d" },
              {
                id: "179",
                jpName: "\u30a4\u30ce\u30f4\u30a1\u30eb\u30ab\u30f3",
              },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "368",
                jpName:
                  "\u30b9\u30da\u30fc\u30b9\u30de\u30f3\u30dc\u30eb\u30b0",
              },
              { id: "446", jpName: "\u30c1\u30f3\u30a2\u30ca5\u5144\u5f1f" },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "47_ブラックホール": {
            info: [
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
              {
                id: "447",
                jpName: "\u30eb\u30fc\u30d1\u30fc\u30eb\u30fc\u30d1\u30fc",
              },
              { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
            ],
          },
          "48_ビッグバン": {
            info: [
              {
                id: "448",
                jpName:
                  "\u30d5\u30a1\u30a4\u30ca\u30eb\u30ae\u30ac\u30b0\u30e9\u30f3\u30c9\u795e\u3055\u307e",
              },
              {
                id: "362",
                jpName:
                  "\u30a8\u30ea\u30fc\u30c8\u30a8\u30a4\u30ea\u30ef\u30f3",
              },
              { id: "363", jpName: "\u30b9\u30bf\u30fc\u30fb\u30da\u30f3" },
              {
                id: "364",
                jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
              },
              { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
              {
                id: "445",
                jpName:
                  "\u30df\u30cb\u30b9\u30bf\u30fc\u30b5\u30a4\u30af\u30ed\u30f3",
              },
            ],
          },
          // フィリバスター襲来ステージ: {
          //   info: [
          //     { id: "040", jpName: "\u30a4\u30ce\u30b7\u30e3\u30b7" },
          //     {
          //       id: "054",
          //       jpName: "\u30b7\u30e3\u30c9\u30a6\u30dc\u30af\u30b5\u30fc",
          //     },
          //     {
          //       id: "213",
          //       jpName:
          //         "\u30d1\u30e9\u30b5\u30a4\u30c8\u30d6\u30f3\u30d6\u30f3",
          //     },
          //     {
          //       id: "364",
          //       jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
          //     },
          //     {
          //       id: "449",
          //       jpName:
          //         "\u30b9\u30bf\u30fc\u30d5\u30a3\u30ea\u30d0\u30b9\u30bf\u30fc",
          //     },
          //     {
          //       id: "364",
          //       jpName: "\u30b0\u30ec\u30b4\u30ea\u30fc\u5c06\u8ecd",
          //     },
          //     { id: "419", jpName: "\u30de\u30ca\u30d6\u304f\u3093" },
          //     { id: "023", jpName: "\u30ab\u30f3\u30d0\u30f3\u5a18" },
          //   ],
          // },
        },
        stageLegend: {
          "01_伝説のはじまり → 01_大地を揺るがす": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "01_伝説のはじまり → 02_あの恐怖、再び": {
            info: [
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "01_伝説のはじまり → 03_おつかれサンセット": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "01_伝説のはじまり → 04_メランコリー湿地": {
            info: [
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "004",
                jpName: " 例のヤツ",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "01_伝説のはじまり → 05_ぷるるん広場": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょ ろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "01_伝説のはじまり → 06_愛情のまなざし": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "01_伝説のはじまり → 07_牧場の守護者": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "023",
                jpName: "カンバン 娘",
              },
            ],
          },
          "01_伝説のはじまり → 08_眠れる獅子": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "02_情熱の国 → 01_ニャンダルシア": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "02_情熱の国 → 02_パエリア草原": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "02_情熱の国 → 03_フラメン坑": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "02_情熱の国 → 04_サングリア川": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "02_情熱の国 → 05_ガスパチョ高原": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "02_情熱の国 → 06_チュロス・ナイト": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "02_情熱の国 → 07_乾いた庭園": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "02_情熱の国 → 08_タパス砂漠": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "03_グルコサミン砂漠 → 01_コンドロイチン砂丘": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "03_グルコサミン砂漠 → 02_セサ民遺跡": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "03_グルコサミン砂漠 → 03_イソフラボン洞窟": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "03_グルコサミン砂漠 → 04_カテキン丘陵": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "03_グルコサミン砂漠 → 05_リコピンの夕焼け": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "03_グルコサミン砂漠 → 06_プロポリスオアシス": {
            info: [
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "03_グルコサミン砂漠 → 07_ペプチド雪原": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "03_グルコサミン砂漠 → 08_ヒアルロン山": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバ ン娘",
              },
            ],
          },
          "04_ネコども海を渡る → 01_無茶ぶり進水式": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "04_ネコども海を渡る → 02_ユーザン海原": {
            info: [
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "04_ネコども海を渡る → 03_人魚の入り江": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "04_ネコども海を渡る → 04_カオスラグーン": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "04_ネコども海を渡る → 05_なんちゃって海賊": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "04_ネコども海を渡る → 06_ホコタテ漁場": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "04_ネコども海を渡る → 07_テングサ島": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "014",
                jpName: "クマ先生",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "014",
                jpName: "クマ先生",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "04_ネコども海を渡る → 08_海の水は塩辛い": {
            info: [
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "05_見つめてキャッツアイ → 01_ぽろり鉱石": {
            info: [
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "05_見つめてキャッツアイ → 02_セクシー鍾乳洞": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "05_見つめてキャッツアイ → 03_ドキドキ穴": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "05_見つめてキャッツアイ → 04_ぷりぷりくぼみ": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "023",
                jpName: "カンバン 娘",
              },
            ],
          },
          "05_見つめてキャッツアイ → 05_フタこぶ岩": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "05_見つめてキャッツアイ → 06_スリルの代償": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "06_ウエスタン街道 → 01_ガンマンの黄昏": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "06_ウエスタン街道 → 02_カウボーイ天国": {
            info: [
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "06_ウエスタン街道 → 03_お尋ね者の夜": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "019",
                jpName: "赤羅 我王",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "06_ウエスタン街道 → 04_マカロニタウン": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "に ょろ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "06_ウエスタン街道 → 05_さすらいの口笛": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "06_ウエスタン街道 → 06_がっかり用心棒": {
            info: [
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "06_ウエスタン街道 → 07_テンガロン山": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "044",
                jpName: "セレ ブ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "06_ウエスタン街道 → 08_ロデオナイト": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "07_マグロ海域 → 01_ベニマグロ海岸": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "07_マグロ海域 → 02_ピチピチ漁場": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "07_マグロ海域 → 03_ぷらっとオーシャン": {
            info: [
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "07_マグロ海域 → 04_カルパッチョ沖": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "07_マグロ海域 → 05_排他的経済水域": {
            info: [
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "07_マグロ海域 → 06_最終兵器トロ": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "07_マグロ海域 → 07_冷凍マグロ戦線": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "038",
                jpName: " アヒルンルン",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "050",
                jpName: "エリザベ ス2世",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "07_マグロ海域 → 08_解体ショー洞窟": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "08_バンブー島 → 01_チクチク高原": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "08_バンブー島 → 02_タケノコ海岸": {
            info: [
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "08_バンブー島 → 03_殺人鬼ジャングル": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "08_バンブー島 → 04_げろげろ沼": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "08_バンブー島 → 05_もっさり坑道": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "08_バンブー島 → 06_星くず街道": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "08_バンブー島 → 07_キノコ崖": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "08_バンブー島 → 08_暁フロンティア": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "09_ぷにぷに鍾乳洞 → 01_ミルキートンネル": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "09_ぷにぷに鍾乳洞 → 02_ふわふわ暗黒兵器": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "09_ぷにぷに鍾乳洞 → 03_悪魔の壁画": {
            info: [
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "09_ぷにぷに鍾乳洞 → 04_隙間風のささやき": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "09_ぷにぷに鍾乳洞 → 05_甘えんぼ暗殺者": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "09_ぷにぷに鍾乳洞 → 06_うろたえる岩": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "09_ぷにぷに鍾乳洞 → 07_雨漏り洞窟": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "053",
                jpName: "ブラ ッゴリ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "09_ぷにぷに鍾乳洞 → 08_ぽっちゃり性善説": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "017",
                jpName: "リッスントゥ ミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "10_ボルケーノ火山 → 01_半身浴岩": {
            info: [
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "006",
                jpName: " ブタヤロウ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "10_ボルケーノ火山 → 02_ほっこり間欠泉": {
            info: [
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "10_ボルケーノ火山 → 03_とろーりマグマ": {
            info: [
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "10_ボルケーノ火山 → 04_炎の檻": {
            info: [
              {
                id: "007",
                jpName: " ジャッキー・ペン",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "10_ボルケーノ火山 → 05_火口を守る者": {
            info: [
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "10_ボルケーノ火山 → 06_メラメラカルデラ": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "11_千里の道 → 01_ポテンシャルロード": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "11_千里の道 → 02_憂愁の木": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリ さん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "11_千里の道 → 03_そよかぜの歌声": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "11_千里の道 → 04_哲学の道": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "11_千里の道 → 05_境界線の晩鐘": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "11_千里の道 → 06_流した涙の川": {
            info: [
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤ ツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "012",
                jpName: "カ・ンガ リュ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "11_千里の道 → 07_輝く道": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわ んこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "11_千里の道 → 08_試練の谷底": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "12_アオ・ザ・カナ → 01_磯のささやき": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "12_アオ・ザ・カナ → 02_サザナミ・アイランド": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "12_アオ・ザ・カナ → 03_ダークオクトパスの海": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "12_アオ・ザ・カナ → 04_ポセイドンのこしかけ": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "12_アオ・ザ・カナ → 05_月明かりのビーチ": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "12_アオ・ザ・カナ → 06_コーラルサンゴ礁": {
            info: [
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "12_アオ・ザ・カナ → 07_月の箱舟": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "12_アオ・ザ・カナ → 08_殺戮兵器 シラ・ス": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "13_軍艦島 → 01_ネギトロ平野": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "13_軍艦島 → 02_カニミソ草原": {
            info: [
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "13_軍艦島 → 03_イクラ岩窟": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "13_軍艦島 → 04_ウニ街道": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: " アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カン バン娘",
              },
            ],
          },
          "13_軍艦島 → 05_トビコ原生林": {
            info: [
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "13_軍艦島 → 06_納豆海岸": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "13_軍艦島 → 07_エンガワの森": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "014",
                jpName: "クマ先生",
              },
              {
                id: "016",
                jpName: "ウサ 銀",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "014",
                jpName: "クマ先生",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "13_軍艦島 → 08_アマエビフロンティア": {
            info: [
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわん こ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "14_つめとぎの廊下 → 01_ダンボール回廊": {
            info: [
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "14_つめとぎの廊下 → 02_マタタビの夢": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "14_つめとぎの廊下 → 03_ガリガリウォール": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "050",
                jpName: "エリザベス2 世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "14_つめとぎの廊下 → 04_木くずを掻き分けて": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "14_つめとぎの廊下 → 05_バリバリ柱": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "14_つめとぎの廊下 → 06_乱暴者の番人": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フル ぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "15_パルテノン神殿 → 01_ゼウスの祭壇": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "15_パルテノン神殿 → 02_アキレスの剣": {
            info: [
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "15_パルテノン神殿 → 03_エロスの街道": {
            info: [
              {
                id: "004",
                jpName: " 例のヤツ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "15_パルテノン神殿 → 04_ガイアの夜明け": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "058",
                jpName: "メタルサイボーグ",
              },
              {
                id: "008",
                jpName: "ゴリ さん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "15_パルテノン神殿 → 05_アフロディテの門": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "15_パルテノン神殿 → 06_ハデスの迷宮": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "16_ずんどこ海水浴場 → 01_潮干狩りの浜": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "16_ずんどこ海水浴場 → 02_ムツゴロウパーク": {
            info: [
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "004",
                jpName: "例の ヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "16_ずんどこ海水浴場 → 03_水着美女の面影": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "16_ずんどこ海水浴場 → 04_イモ洗いプール": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "16_ずんどこ海水浴場 → 05_ビーチパラソル畑": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "014",
                jpName: "クマ先生",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "16_ずんどこ海水浴場 → 06_いにしえのビキニ": {
            info: [
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "16_ずんどこ海水浴場 → 07_カラフルカクテル": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "16_ずんどこ海水浴場 → 08_星降る大海": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "17_アルカトラズ島 → 01_カモメ海岸": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "17_アルカトラズ島 → 02_ペリカン島": {
            info: [
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "17_アルカトラズ島 → 03_地下制御室": {
            info: [
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "023",
                jpName: "カ ンバン娘",
              },
            ],
          },
          "17_アルカトラズ島 → 04_悪党の密林": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "17_アルカトラズ島 → 05_バラバラチキンレース": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "042",
                jpName: "ナ カイくん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "17_アルカトラズ島 → 06_ねこ裁判": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "17_アルカトラズ島 → 07_監獄草原": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "17_アルカトラズ島 → 08_看守と墓守": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "035",
                jpName: "フルぼ っこ",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "18_脱獄トンネル → 01_茶罪～ギル・ティ～": {
            info: [
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "18_脱獄トンネル → 02_実刑判決": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "18_脱獄トンネル → 03_ハリートンネル": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "18_脱獄トンネル → 04_夜のしじま": {
            info: [
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "061",
                jpName: "メタル ゴマさま",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "18_脱獄トンネル → 05_落とし穴地帯": {
            info: [
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラック マ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "18_脱獄トンネル → 06_大脱走": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "054",
                jpName: " シャドウボクサー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "047",
                jpName: "ウルフとウルルン",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "19_カポネの監獄 → 01_脱獄日誌": {
            info: [
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "053",
                jpName: " ブラッゴリ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "054",
                jpName: " シャドウボクサー",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "19_カポネの監獄 → 02_ラスト・ギャング": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
            ],
          },
          "19_カポネの監獄 → 03_プリズン・破": {
            info: [
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "058",
                jpName: "メ タルサイボーグ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "19_カポネの監獄 → 04_シャバの王者": {
            info: [
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "19_カポネの監獄 → 05_嘘つきの末路": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "19_カポネの監獄 → 06_豚小屋のタブー": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: " にょろ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "20_シルクロード → 01_ガンダーラ休憩所": {
            info: [
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "20_シルクロード → 02_ユートピアはあちら": {
            info: [
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "049",
                jpName: "メタル カバちゃん",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "056",
                jpName: "超メタルカバちゃん",
              },
              {
                id: "061",
                jpName: "メタルゴマさま",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "20_シルクロード → 03_ゴダイゴ峠": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "054",
                jpName: " シャドウボクサー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "20_シルクロード → 04_モンキーマジック": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "053",
                jpName: "ブラッゴ リ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: " カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "20_シルクロード → 05_異国の門": {
            info: [
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげ どり",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "20_シルクロード → 06_マルコ・ポーロード": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "048",
                jpName: " 殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "20_シルクロード → 07_豚の残飯": {
            info: [
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "20_シルクロード → 08_河童の冷や汗": {
            info: [
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "21_闇へと続く地下道 → 01_転ばぬ先の杖": {
            info: [
              {
                id: "017",
                jpName: "リ ッスントゥミー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩 ・サブ・レー",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "21_闇へと続く地下道 → 02_暗い・狭い・怖い道": {
            info: [
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "21_闇へと続く地下道 → 03_レッド・アラート": {
            info: [
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "120",
                jpName: "赤毛のにょ ろ",
              },
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "21_闇へと続く地下道 → 04_人生の落とし穴": {
            info: [
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "21_闇へと続く地下道 → 05_かすかな晩鐘": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "043",
                jpName: "�� �っふんど",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "049",
                jpName: "メタルカバ ちゃん",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "127",
                jpName: "天使スレイプニール",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "21_闇へと続く地下道 → 06_アンダーワールド": {
            info: [
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "017",
                jpName: " リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "22_魔王の豪邸 → 01_セレブな玄関": {
            info: [
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "014",
                jpName: "クマ先生",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "023",
                jpName: "カン バン娘",
              },
            ],
          },
          "22_魔王の豪邸 → 02_バスルーム": {
            info: [
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "22_魔王の豪邸 → 03_オシャレVIPルーム": {
            info: [
              {
                id: "149",
                jpName: " メタルわんこ",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "002",
                jpName: " わんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "22_魔王の豪邸 → 04_拷問部屋": {
            info: [
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "22_魔王の豪邸 → 05_独裁者の庭": {
            info: [
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "127",
                jpName: "天使スレイプニール",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "014",
                jpName: "クマ先生",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "037",
                jpName: "こぶへ い",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "22_魔王の豪邸 → 06_魔王の寝室": {
            info: [
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "126",
                jpName: "ブ ラッコ",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "23_終わりを告げる夜 → 01_裏切りの宴": {
            info: [
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "23_終わりを告げる夜 → 02_終焉のカタルシス": {
            info: [
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: " はぐれたヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "025",
                jpName: "悪 の帝王ニャンダム",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "23_終わりを告げる夜 → 03_黒い予感": {
            info: [
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "053",
                jpName: " ブラッゴリ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "23_終わりを告げる夜 → 04_砕けた仮面": {
            info: [
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "116",
                jpName: "天使ガブリエ ル",
              },
              {
                id: "127",
                jpName: "天使スレイプニール",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "115",
                jpName: "天 使カバちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "23_終わりを告げる夜 → 05_アガペーの檻": {
            info: [
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "23_終わりを告げる夜 → 06_赤いきつねの聖者": {
            info: [
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわ んこ",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "は ぐれたヤツ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "150",
                jpName: "コニャンダム",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "24_バトルロワイアル → 01_ロイヤル・ミル・クティ": {
            info: [
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "162",
                jpName: "天使 ヒオコエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "116",
                jpName: "天使 ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "162",
                jpName: " 天使ヒオコエル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "24_バトルロワイアル → 02_怒りと闘争心": {
            info: [
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "010",
                jpName: "ゴマ さま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "24_バトルロワイアル → 03_忍び寄る戦慄の詩": {
            info: [
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "049",
                jpName: "メタルカ バちゃん",
              },
              {
                id: "127",
                jpName: "天使スレイプニール",
              },
              {
                id: "127",
                jpName: "天使スレイプニール",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "058",
                jpName: "メタルサイボーグ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "24_バトルロワイアル → 04_卑怯者の罠": {
            info: [
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "038",
                jpName: "アヒ ルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "24_バトルロワイアル → 05_闇より生まれし宿敵": {
            info: [
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "051",
                jpName: "赤井ブン 太郎",
              },
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "24_バトルロワイアル → 06_魚介類と血のにおい": {
            info: [
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "007",
                jpName: "ジャッキー・ペン",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "117",
                jpName: "天使ゴン ザレス",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "25_戦争のつめあと → 01_ワルキューレ平原": {
            info: [
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "25_戦争のつめあと → 02_ぶっとび地雷原": {
            info: [
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "171",
                jpName: "カーバチャン",
              },
              {
                id: "175",
                jpName: "ヤドカリー",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "25_戦争のつめあと → 03_クーゲルシュライバー": {
            info: [
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "023",
                jpName: "カン バン娘",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
            ],
          },
          "25_戦争のつめあと → 04_ぬかるみ塹壕": {
            info: [
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "172",
                jpName: "ゴマサーマン",
              },
              {
                id: "172",
                jpName: "ゴマサーマン",
              },
              {
                id: "172",
                jpName: "ゴマサーマン",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "25_戦争のつめあと → 05_スナイパージャングル": {
            info: [
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "173",
                jpName: "レディ・ガ",
              },
              {
                id: "173",
                jpName: "レディ・ガ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "023",
                jpName: "カ ンバン娘",
              },
            ],
          },
          "25_戦争のつめあと → 06_斜陽のソルジャー": {
            info: [
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "177",
                jpName: "クマンチュー",
              },
              {
                id: "177",
                jpName: "クマンチュー",
              },
              {
                id: "177",
                jpName: "クマンチュー",
              },
              {
                id: "177",
                jpName: "クマンチュー",
              },
              {
                id: "177",
                jpName: "クマンチュー",
              },
              {
                id: "148",
                jpName: "はぐれたヤ ツ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "25_戦争のつめあと → 07_父の背中": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "180",
                jpName: "エリザベス56世",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "120",
                jpName: "赤毛の にょろ",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "25_戦争のつめあと → 08_境界線奪還作戦": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: " 例のヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "179",
                jpName: "イノヴァルカン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "26_海を汚す悪しき者 → 01_石油プラットホーム": {
            info: [
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "207",
                jpName: "カルピ ンチョ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "26_海を汚す悪しき者 → 02_汗とアルデヒド": {
            info: [
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "185",
                jpName: " サイバーX",
              },
              {
                id: "058",
                jpName: "メタルサイボーグ",
              },
              {
                id: "058",
                jpName: "メタルサイボーグ",
              },
              {
                id: "185",
                jpName: "サイバーX",
              },
              {
                id: "185",
                jpName: "サイバーX",
              },
              {
                id: "185",
                jpName: "サイバーX",
              },
              {
                id: "185",
                jpName: "サイバーX",
              },
              {
                id: "185",
                jpName: "サイバーX",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "26_海を汚す悪しき者 → 03_いにしえの裁判": {
            info: [
              {
                id: "182",
                jpName: "ギャラ クシーニャンダム",
              },
              {
                id: "186",
                jpName: "プドール夫人",
              },
              {
                id: "186",
                jpName: "プドール夫人",
              },
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "179",
                jpName: "イノヴァルカン",
              },
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "179",
                jpName: "イノヴァルカン",
              },
              {
                id: "179",
                jpName: "イノヴァルカン",
              },
              {
                id: "186",
                jpName: "プドール夫人",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "26_海を汚す悪しき者 → 04_あやしい自治体": {
            info: [
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "26_海を汚す悪しき者 → 05_ポイステ海岸": {
            info: [
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "26_海を汚す悪しき者 → 06_ベンゼン畑": {
            info: [
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "26_海を汚す悪しき者 → 07_政府の犬": {
            info: [
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "186",
                jpName: "プドール夫人",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "186",
                jpName: "プドール夫人",
              },
              {
                id: "186",
                jpName: "プドール夫人",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "186",
                jpName: "プドール夫人",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "023",
                jpName: "カ ンバン娘",
              },
            ],
          },
          "26_海を汚す悪しき者 → 08_あまくだり海流": {
            info: [
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "27_心と体、繋ぐもの → 01_夕焼けの咆哮": {
            info: [
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "27_心と体、繋ぐもの → 02_ゲシュタルト、崩壊": {
            info: [
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "27_心と体、繋ぐもの → 03_戦士の黎明": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "27_心と体、繋ぐもの → 04_呪われた永久凍土": {
            info: [
              {
                id: "212",
                jpName: "ヨキカナ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "212",
                jpName: "ヨキカナ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "27_心と体、繋ぐもの → 05_ねこの証": {
            info: [
              {
                id: "210",
                jpName: "よっちゃん",
              },
              {
                id: "211",
                jpName: "アルパッカ",
              },
              {
                id: "210",
                jpName: "よっちゃん",
              },
              {
                id: "210",
                jpName: "よっちゃん",
              },
              {
                id: "210",
                jpName: "よっちゃん",
              },
              {
                id: "172",
                jpName: "ゴマサーマン",
              },
              {
                id: "172",
                jpName: "ゴ マサーマン",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "185",
                jpName: "サイバーX",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "27_心と体、繋ぐもの → 06_愚者の絶望": {
            info: [
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "27_心と体、繋ぐもの → 07_メタボリック症候群": {
            info: [
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "176",
                jpName: "カヲルさん",
              },
              {
                id: "213",
                jpName: "パラサイトブンブン",
              },
              {
                id: "182",
                jpName: "ギャラクシーニャンダム",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "27_心と体、繋ぐもの → 08_愛と死": {
            info: [
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "28_脆弱性と弱酸性 → 01_せめて、ネコらしく": {
            info: [
              {
                id: "058",
                jpName: "メタルサイボーグ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "180",
                jpName: "エリザベス56世",
              },
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "28_脆弱性と弱酸性 → 02_円卓の騎士": {
            info: [
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "176",
                jpName: "カヲルさん",
              },
              {
                id: "060",
                jpName: "メタルカオル君",
              },
              {
                id: "060",
                jpName: "メタルカオル君",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "28_脆弱性と弱酸性 → 03_おにゃんこカタルシス": {
            info: [
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "182",
                jpName: "ギャラクシーニャンダム",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "208",
                jpName: "バトルコアラ ッキョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "28_脆弱性と弱酸性 → 04_美しい終わり": {
            info: [
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "174",
                jpName: "デカメガネル",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "28_脆弱性と弱酸性 → 05_悪夢からの覚醒": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "213",
                jpName: "パラサイトブンブン",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "004",
                jpName: " 例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "28_脆弱性と弱酸性 → 06_おぼえたての愛": {
            info: [
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "260",
                jpName: "わんこずきんミーニャ",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤ ツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
            ],
          },
          "29_導かれしネコ達 → 01_新たなる戦い": {
            info: [
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "176",
                jpName: "カヲルさん",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "29_導かれしネコ達 → 02_ミステリーサークル": {
            info: [
              {
                id: "186",
                jpName: "プドール夫人",
              },
              {
                id: "173",
                jpName: "レディ・ガ",
              },
              {
                id: "210",
                jpName: "よっちゃん",
              },
              {
                id: "149",
                jpName: "メタルわ んこ",
              },
              {
                id: "185",
                jpName: "サイバーX",
              },
              {
                id: "177",
                jpName: "クマンチュー",
              },
              {
                id: "210",
                jpName: "よっちゃん",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "29_導かれしネコ達 → 03_野鳥観察": {
            info: [
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "29_導かれしネコ達 → 04_言葉の端のトゲ": {
            info: [
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "211",
                jpName: "アルパッカ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "211",
                jpName: "アルパッカ",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "172",
                jpName: "ゴマサ ーマン",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "172",
                jpName: "ゴマサーマン",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "29_導かれしネコ達 → 05_ブラックウェーブ": {
            info: [
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "208",
                jpName: "バトルコア ラッキョ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "30_暗黒コスモポリス → 01_ハングリーフォレスト": {
            info: [
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "212",
                jpName: "ヨキカナ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "008",
                jpName: "ゴリ さん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "30_暗黒コスモポリス → 02_身の程知らずの巣": {
            info: [
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "039",
                jpName: " まゆげどり",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "176",
                jpName: "カヲルさん",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "117",
                jpName: "天使ゴンザ レス",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "30_暗黒コスモポリス → 03_通勤ラッシュ": {
            info: [
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "207",
                jpName: "カルピンチ ョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "30_暗黒コスモポリス → 04_ドッキングジェノサイダー": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "213",
                jpName: "パラサイトブンブン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "30_暗黒コスモポリス → 05_地下帝国からの刺客": {
            info: [
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "237",
                jpName: "ドリ ュウ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "30_暗黒コスモポリス → 06_暗黒街の支配者": {
            info: [
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "002",
                jpName: "わ んこ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "115",
                jpName: "天使カバち ゃん",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "127",
                jpName: "天使スレイプニール",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "115",
                jpName: "天使カバちゃん",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "263",
                jpName: "イノエンジェル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "31_ガラ・パ・ゴス → 01_DNAとDHA": {
            info: [
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "31_ガラ・パ・ゴス → 02_夕焼けの密猟者": {
            info: [
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "018",
                jpName: "ブラック マ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "31_ガラ・パ・ゴス → 03_遭難者の群れ": {
            info: [
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょ ろ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "31_ガラ・パ・ゴス → 04_異星生態調査団": {
            info: [
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "171",
                jpName: "カーバチャン",
              },
              {
                id: "182",
                jpName: "ギャラクシーニャンダム",
              },
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "177",
                jpName: "クマンチュー",
              },
              {
                id: "056",
                jpName: "超メタルカバちゃん",
              },
              {
                id: "056",
                jpName: " 超メタルカバちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "31_ガラ・パ・ゴス → 05_楽園のいきもの達": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "263",
                jpName: "イノエンジェル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺 意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天 使ガブリエル",
              },
              {
                id: "263",
                jpName: "イノエンジェル",
              },
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使 ガブリエル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "31_ガラ・パ・ゴス → 06_環境保護団体": {
            info: [
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "053",
                jpName: "ブラッゴ リ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "268",
                jpName: "ヒカル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "32_岩海苔半島 → 01_りんりん防風林": {
            info: [
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "32_岩海苔半島 → 02_イベリコ平野": {
            info: [
              {
                id: "180",
                jpName: "エリザベス56世",
              },
              {
                id: "180",
                jpName: "エリザベス56世",
              },
              {
                id: "210",
                jpName: "よっちゃ ん",
              },
              {
                id: "180",
                jpName: "エリザベス56世",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "32_岩海苔半島 → 03_泣き砂海岸": {
            info: [
              {
                id: "268",
                jpName: "ヒカル",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "32_岩海苔半島 → 04_ゴールデン街": {
            info: [
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "32_岩海苔半島 → 05_鈍足ドライブウェイ": {
            info: [
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "32_岩海苔半島 → 06_武家屋敷お家騒動": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "212",
                jpName: "ヨキカナ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "33_恐ろし連邦 → 01_クリムゾン広場": {
            info: [
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "187",
                jpName: "教授",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "33_恐ろし連邦 → 02_インテリゲンチャ": {
            info: [
              {
                id: "176",
                jpName: "カヲルさん",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "184",
                jpName: "ハサミーマン",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "127",
                jpName: "天使スレイプニール",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "33_恐ろし連邦 → 03_ポッポー領土": {
            info: [
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "018",
                jpName: "ブラッ クマ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "33_恐ろし連邦 → 04_バトル海の決戦": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリ エル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "011",
                jpName: "パオン",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "33_恐ろし連邦 → 05_宇宙開発局": {
            info: [
              {
                id: "178",
                jpName: "破壊生物クオリネン",
              },
              {
                id: "268",
                jpName: "ヒカル",
              },
              {
                id: "179",
                jpName: "イノヴァルカン",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "33_恐ろし連邦 → 06_スパイより愛を込めて": {
            info: [
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "282",
                jpName: "イノワール",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "048",
                jpName: "殺意 のわんこ",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "34_亡者の住まう地 → 01_死霊の館": {
            info: [
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "286",
                jpName: "ゾンビワ ン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "286",
                jpName: "ゾンビ ワン",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "34_亡者の住まう地 → 02_いけにえ沼": {
            info: [
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "287",
                jpName: "に ょろろん",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "290",
                jpName: "ジャッキー・ペンZ",
              },
              {
                id: "290",
                jpName: "ジャッキー・ペンZ",
              },
              {
                id: "290",
                jpName: "ジャッキー・ペンZ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "34_亡者の住まう地 → 03_ムール街の悪夢": {
            info: [
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "116",
                jpName: "天使ガ ブリエル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "34_亡者の住まう地 → 04_ポルターガイストリート": {
            info: [
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "289",
                jpName: "トンシー",
              },
              {
                id: "288",
                jpName: "カバタリアン",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "288",
                jpName: "カバタリアン",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "023",
                jpName: "カンバン 娘",
              },
            ],
          },
          "34_亡者の住まう地 → 05_ホワイト・ライト・ナイト": {
            info: [
              {
                id: "009",
                jpName: "メェメェ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "045",
                jpName: "ハイ・エナ ジー",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "209",
                jpName: "ツバメ ンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "008",
                jpName: "ゴリさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "34_亡者の住まう地 → 06_猫たちの沈黙": {
            info: [
              {
                id: "054",
                jpName: "シャドウボクサー",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "291",
                jpName: "ゴリ・ンジュ",
              },
              {
                id: "291",
                jpName: "ゴ リ・ンジュ",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "295",
                jpName: "墓手太郎",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "35_絶島パンデミック → 01_感染者密航": {
            info: [
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "290",
                jpName: "ジャッキー・ペンZ",
              },
              {
                id: "290",
                jpName: "ジャッキー・ペンZ",
              },
              {
                id: "290",
                jpName: "ジャッキー・ペンZ",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "274",
                jpName: "ちびぶん ぶん",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "35_絶島パンデミック → 02_ハイテク昆布漁": {
            info: [
              {
                id: "058",
                jpName: "メタルサイボーグ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "056",
                jpName: "超メタル カバちゃん",
              },
              {
                id: "056",
                jpName: "超メタルカバちゃん",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "061",
                jpName: "メタルゴマさま",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "35_絶島パンデミック → 03_先祖の行進": {
            info: [
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "288",
                jpName: "カバタリアン",
              },
              {
                id: "289",
                jpName: "トンシー",
              },
              {
                id: "291",
                jpName: "ゴリ・ンジュ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "35_絶島パンデミック → 04_脱出を阻む者": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "282",
                jpName: "イノワール",
              },
              {
                id: "182",
                jpName: "ギャラクシー ニャンダム",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "35_絶島パンデミック → 05_怒りのマグロ戦線": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "044",
                jpName: "セレブ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "050",
                jpName: "エリザベス2世",
              },
              {
                id: "187",
                jpName: "教授",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "35_絶島パンデミック → 06_感染、島の主": {
            info: [
              {
                id: "306",
                jpName: "オオさん",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "36_ふくろのねずみランド → 01_お出迎え入場門": {
            info: [
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "311",
                jpName: "ヒツギイヌ",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "291",
                jpName: "ゴリ・ンジュ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "36_ふくろのねずみランド → 02_無気力コースター": {
            info: [
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・ サブ・レー",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "180",
                jpName: "エリザベス56世",
              },
              {
                id: "125",
                jpName: "ド鳩 ・サブ・レー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "36_ふくろのねずみランド → 03_リアルVR地獄": {
            info: [
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "289",
                jpName: "トンシー",
              },
              {
                id: "268",
                jpName: "ヒカル",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "289",
                jpName: "トンシー",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "053",
                jpName: "ブラ ッゴリ",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "36_ふくろのねずみランド → 04_プラス50度の世界": {
            info: [
              {
                id: "312",
                jpName: "キャベロン",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "36_ふくろのねずみランド → 05_誘惑のチキンルーム": {
            info: [
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "210",
                jpName: "よっちゃん",
              },
              {
                id: "263",
                jpName: "イノエンジェル",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "36_ふくろのねずみランド → 06_ボーンデッドアパートメント": {
            info: [
              {
                id: "105",
                jpName: "ゴーストわんこ",
              },
              {
                id: "106",
                jpName: "ゴーストにょろ",
              },
              {
                id: "107",
                jpName: "ゴーストメェメェ",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "291",
                jpName: "ゴリ・ンジュ",
              },
              {
                id: "291",
                jpName: "ゴリ・ンジュ",
              },
              {
                id: "291",
                jpName: "ゴリ・ンジュ",
              },
              {
                id: "295",
                jpName: "墓手太郎",
              },
              {
                id: "305",
                jpName: "墓手花子",
              },
              {
                id: "023",
                jpName: "カ ンバン娘",
              },
            ],
          },
          "37_ハリーウッド帝国 → 01_パパラッチフィーバー": {
            info: [
              {
                id: "311",
                jpName: "ヒツギイヌ",
              },
              {
                id: "311",
                jpName: "ヒツギイヌ",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "37_ハリーウッド帝国 → 02_因縁ゴシップスター": {
            info: [
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "290",
                jpName: "ジャッキー・ペンZ",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "37_ハリーウッド帝国 → 03_バブリーヒルズ白書": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "37_ハリーウッド帝国 → 04_子役上がり": {
            info: [
              {
                id: "312",
                jpName: "キャベロン",
              },
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "37_ハリーウッド帝国 → 05_セクシースキャンダル": {
            info: [
              {
                id: "187",
                jpName: "教授",
              },
              {
                id: "256",
                jpName: "ミス ターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "056",
                jpName: "超メタルカバち ゃん",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "295",
                jpName: "墓手太郎",
              },
              {
                id: "056",
                jpName: "超メタルカバちゃん",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "37_ハリーウッド帝国 → 06_ウニバーサンスタジオ": {
            info: [
              {
                id: "317",
                jpName: "わんこの城",
              },
              {
                id: "318",
                jpName: "犬武者 武蔵",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "291",
                jpName: "ゴリ・ンジュ",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "291",
                jpName: "ゴリ・ンジュ",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "38_こしぎんちゃくの浜辺 → 01_よたもの遊泳大会": {
            info: [
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "175",
                jpName: "ヤドカリー",
              },
              {
                id: "175",
                jpName: "ヤドカリー",
              },
              {
                id: "175",
                jpName: "ヤドカリー",
              },
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "175",
                jpName: "ヤドカリー",
              },
              {
                id: "174",
                jpName: "デカメガネル",
              },
              {
                id: "174",
                jpName: "デカメガネル",
              },
              {
                id: "177",
                jpName: "クマンチュー",
              },
              {
                id: "210",
                jpName: "よっ ちゃん",
              },
              {
                id: "170",
                jpName: "ワーニック",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "38_こしぎんちゃくの浜辺 → 02_ヘアーサロン潮風": {
            info: [
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "179",
                jpName: "イノヴァルカン",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "179",
                jpName: "イノヴァルカン",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "179",
                jpName: "イノヴァルカン",
              },
              {
                id: "263",
                jpName: "イノエンジェル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "38_こしぎんちゃくの浜辺 → 03_ディープシー決死隊": {
            info: [
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "306",
                jpName: "オオさん",
              },
              {
                id: "306",
                jpName: "オオさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "38_こしぎんちゃくの浜辺 → 04_ぺこぺこパレード": {
            info: [
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "38_こしぎんちゃくの浜辺 → 05_大御所大博覧会": {
            info: [
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キ ョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "38_こしぎんちゃくの浜辺 → 06_もう陸には帰れない": {
            info: [
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "035",
                jpName: "フルぼっこ",
              },
              {
                id: "015",
                jpName: "ワニッ ク",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "39_雲泥温泉郷 → 01_自家製電気風呂": {
            info: [
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "049",
                jpName: "メタルカバちゃん",
              },
              {
                id: "058",
                jpName: "メタルサイボーグ",
              },
              {
                id: "268",
                jpName: "ヒカル",
              },
              {
                id: "056",
                jpName: "超メタルカバちゃん",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "061",
                jpName: "メタ ルゴマさま",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "023",
                jpName: "カンバ ン娘",
              },
            ],
          },
          "39_雲泥温泉郷 → 02_熱湯風呂我慢大会": {
            info: [
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "187",
                jpName: "教授",
              },
              {
                id: "051",
                jpName: "赤井ブン太 郎",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "39_雲泥温泉郷 → 03_ケミカル長寿の湯": {
            info: [
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "212",
                jpName: "ヨキカナ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "39_雲泥温泉郷 → 04_垢い敵、黒い汗": {
            info: [
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "282",
                jpName: "イノワール",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "39_雲泥温泉郷 → 05_源泉に潜む者達": {
            info: [
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "39_雲泥温泉郷 → 06_湯けむり極楽地獄": {
            info: [
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "208",
                jpName: "バトルコ アラッキョ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "342",
                jpName: "イカ 天",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "40_風待ちアイランド → 01_むっちり隠れ港": {
            info: [
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "172",
                jpName: "ゴマサーマン",
              },
              {
                id: "172",
                jpName: "ゴマサーマン",
              },
              {
                id: "172",
                jpName: "ゴマサーマン",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "010",
                jpName: "ゴマさま",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "172",
                jpName: "ゴマサーマン",
              },
              {
                id: "292",
                jpName: "ブチゴマさま",
              },
              {
                id: "178",
                jpName: "破壊生物クオリネン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "40_風待ちアイランド → 02_ロマンスグレーハイウェイ": {
            info: [
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "40_風待ちアイランド → 03_泥酔マッサージャー": {
            info: [
              {
                id: "342",
                jpName: "イカ天",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "342",
                jpName: "イカ天",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "342",
                jpName: "イカ天",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "40_風待ちアイランド → 04_豚箱恋愛沼": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "293",
                jpName: "スカルボクサー",
              },
              {
                id: "012",
                jpName: "カ・ンガリュ",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "40_風待ちアイランド → 05_フェロモン門": {
            info: [
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "40_風待ちアイランド → 06_天空秘宝の館": {
            info: [
              {
                id: "317",
                jpName: "わんこの城",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ ・レー",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: " ミスターエンジェル",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "41_ITカタコンベ → 01_キリバンの番人": {
            info: [
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "268",
                jpName: "ヒカル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "41_ITカタコンベ → 02_ダイヤルアップ回廊": {
            info: [
              {
                id: "342",
                jpName: "イカ天",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "291",
                jpName: "ゴリ・ンジュ",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "41_ITカタコンベ → 03_テレホー台座": {
            info: [
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "41_ITカタコンベ → 04_Mrs.ドスの墓": {
            info: [
              {
                id: "187",
                jpName: "教授",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "052",
                jpName: "ブラックブンブン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "41_ITカタコンベ → 05_聖人ブラクラの遺骨": {
            info: [
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "282",
                jpName: "イノワール",
              },
              {
                id: "263",
                jpName: "イノエンジェル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "41_ITカタコンベ → 06_怨叫カプラ": {
            info: [
              {
                id: "357",
                jpName: "ケロ助",
              },
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "42_変覧会の絵 → 01_ヘタうまキュビズム": {
            info: [
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "016",
                jpName: "ウサ銀",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバ メンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "42_変覧会の絵 → 02_癒し系地獄絵図": {
            info: [
              {
                id: "317",
                jpName: "わんこの城",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "42_変覧会の絵 → 03_和尚のスケベな水墨画": {
            info: [
              {
                id: "118",
                jpName: "天使愛好家",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "127",
                jpName: "天使スレイプ ニール",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "42_変覧会の絵 → 04_一筆三億五千万円": {
            info: [
              {
                id: "357",
                jpName: "ケロ助",
              },
              {
                id: "357",
                jpName: "ケロ 助",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "42_変覧会の絵 → 05_ヤンキー宗教画": {
            info: [
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "060",
                jpName: "メタルカオル君",
              },
              {
                id: "060",
                jpName: "メタルカオル君",
              },
              {
                id: "060",
                jpName: "メタルカオル君",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "42_変覧会の絵 → 06_館長の自画像": {
            info: [
              {
                id: "127",
                jpName: "天使スレイプニー ル",
              },
              {
                id: "263",
                jpName: "イノエンジェル",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "213",
                jpName: "パラサイトブンブン",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "282",
                jpName: "イノワール",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "017",
                jpName: "リッスントゥミー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "43_エリア22 → 01_ローズウェイ事件": {
            info: [
              {
                id: "362",
                jpName: "エリートエイリワン",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "362",
                jpName: "エリートエイリワン",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "362",
                jpName: " エリートエイリワン",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "43_エリア22 → 02_キャットミューティレーション": {
            info: [
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "363",
                jpName: "スター・ペン",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "363",
                jpName: "スター・ペン",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "363",
                jpName: "スター・ペン",
              },
              {
                id: "023",
                jpName: "カンバ ン娘",
              },
            ],
          },
          "43_エリア22 → 03_マダムスキー型UFO": {
            info: [
              {
                id: "312",
                jpName: "キャベロン",
              },
              {
                id: "365",
                jpName: "ハハパオン",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "43_エリア22 → 04_チュパチュパカブラ遭遇": {
            info: [
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "362",
                jpName: "エリートエイリワン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "43_エリア22 → 05_グースカツンツン大爆発": {
            info: [
              {
                id: "368",
                jpName: "スペースマンボルグ",
              },
              {
                id: "363",
                jpName: "スター・ペン",
              },
              {
                id: "363",
                jpName: "スター・ペン",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "43_エリア22 → 06_あなた疲れてるのよ": {
            info: [
              {
                id: "377",
                jpName: "大夢くん",
              },
              {
                id: "364",
                jpName: "グレゴリー将軍",
              },
              {
                id: "362",
                jpName: "エリートエイリワン",
              },
              {
                id: "364",
                jpName: "グレゴリー将軍",
              },
              {
                id: "364",
                jpName: "グレゴリー将軍",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "44_超越サバンナ → 01_弱肉朝食": {
            info: [
              {
                id: "256",
                jpName: "ミスターエンジ ェル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "367",
                jpName: "キャプテン・モグー",
              },
              {
                id: "045",
                jpName: "ハイ・エナジー",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "256",
                jpName: " ミスターエンジェル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "367",
                jpName: "キャプテン・モ グー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "44_超越サバンナ → 02_霊峰ニクマンジャロ": {
            info: [
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "368",
                jpName: "スペースマンボルグ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "44_超越サバンナ → 03_原始の強敵、再び": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "005",
                jpName: "カバちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "44_超越サバンナ → 04_ウキウキ乾季": {
            info: [
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "362",
                jpName: "エリートエイリワン",
              },
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "185",
                jpName: "サイバーX",
              },
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "44_超越サバンナ → 05_エレクトロサファリパーク": {
            info: [
              {
                id: "362",
                jpName: "エリートエイリワン",
              },
              {
                id: "363",
                jpName: "スター・ペン",
              },
              {
                id: "362",
                jpName: "エ リートエイリワン",
              },
              {
                id: "364",
                jpName: "グレゴリー将軍",
              },
              {
                id: "363",
                jpName: "スター・ペン",
              },
              {
                id: "365",
                jpName: "ハハパオン",
              },
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "363",
                jpName: "スター・ ペン",
              },
              {
                id: "367",
                jpName: "キャプテン・モグー",
              },
              {
                id: "368",
                jpName: "スペースマンボルグ",
              },
              {
                id: "364",
                jpName: "グレゴリー将軍",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "44_超越サバンナ → 06_天国に一番近い水飲み場": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "053",
                jpName: "ブラッゴリ",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "048",
                jpName: "殺意 のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天 使ガブリエル",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "381",
                jpName: "天使ブッタ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "45_ブリザード自動車道 → 01_あかぎれジャンクション": {
            info: [
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "116",
                jpName: "天使ガ ブリエル",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "381",
                jpName: "天使ブッタ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "45_ブリザード自動車道 → 02_ダダ洩れ海底トンネル": {
            info: [
              {
                id: "357",
                jpName: "ケロ助",
              },
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "45_ブリザード自動車道 → 03_しもやけパーキングエリア": {
            info: [
              {
                id: "289",
                jpName: "トンシー",
              },
              {
                id: "287",
                jpName: "にょろろん",
              },
              {
                id: "294",
                jpName: "ワニボン",
              },
              {
                id: "289",
                jpName: "トンシー",
              },
              {
                id: "289",
                jpName: "トンシー",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "289",
                jpName: "トンシー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "45_ブリザード自動車道 → 04_ぬくもり対向車線": {
            info: [
              {
                id: "020",
                jpName: "カオル君",
              },
              {
                id: "342",
                jpName: "イカ天",
              },
              {
                id: "342",
                jpName: "イカ天",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "45_ブリザード自動車道 → 05_眠眠交通警備隊": {
            info: [
              {
                id: "365",
                jpName: "ハハパオン",
              },
              {
                id: "364",
                jpName: "グレゴリー将軍",
              },
              {
                id: "365",
                jpName: "ハハパオン",
              },
              {
                id: "364",
                jpName: "グレゴリー将軍",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "45_ブリザード自動車道 → 06_料金所ヒートショック": {
            info: [
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "389",
                jpName: "ヒウマ",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "46_シンギュラリティ村 → 01_ユビキタス販売所": {
            info: [
              {
                id: "179",
                jpName: "イノヴァルカン",
              },
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "366",
                jpName: "巨匠",
              },
              {
                id: "364",
                jpName: "グレゴリー将軍",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "46_シンギュラリティ村 → 02_VR稲刈り場": {
            info: [
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "151",
                jpName: "松 黒蔵",
              },
              {
                id: "389",
                jpName: "ヒウマ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "013",
                jpName: "一角くん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "46_シンギュラリティ村 → 03_ウェアラブル一軒家": {
            info: [
              {
                id: "390",
                jpName: "ウルトラメェメェ",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "46_シンギュラリティ村 → 04_8K肥溜め": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "053",
                jpName: " ブラッゴリ",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "023",
                jpName: "カンバン 娘",
              },
            ],
          },
          "46_シンギュラリティ村 → 05_夕焼けブロックチェーン": {
            info: [
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "061",
                jpName: "メタルゴマさま",
              },
              {
                id: "024",
                jpName: "ガガガガ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "46_シンギュラリティ村 → 06_ゲノム盆踊り": {
            info: [
              {
                id: "390",
                jpName: "ウルトラメェメェ",
              },
              {
                id: "006",
                jpName: "ブタヤロウ",
              },
              {
                id: "117",
                jpName: "天使ゴンザレス",
              },
              {
                id: "116",
                jpName: "天 使ガブリエル",
              },
              {
                id: "162",
                jpName: "天使ヒオコエル",
              },
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "390",
                jpName: "ウルトラメェメェ",
              },
              {
                id: "390",
                jpName: "ウルトラメェメェ",
              },
              {
                id: "025",
                jpName: "悪の帝王ニャンダム",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "47_オワーリ大陸 → 01_最果ての祠": {
            info: [
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "043",
                jpName: "だっふんど",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "148",
                jpName: "はぐれたヤツ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "47_オワーリ大陸 → 02_終末の谷": {
            info: [
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "041",
                jpName: "ナマルケモルル",
              },
              {
                id: "051",
                jpName: "赤井ブン太郎",
              },
              {
                id: "126",
                jpName: "ブラッコ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "47_オワーリ大陸 → 03_ファイナルタワー": {
            info: [
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "058",
                jpName: "メタルサイボーグ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "061",
                jpName: "メタルゴマさま",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "47_オワーリ大陸 → 04_ラストラビリンス": {
            info: [
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "039",
                jpName: "まゆげどり",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "209",
                jpName: "ツバメンズ",
              },
              {
                id: "038",
                jpName: "アヒルンルン",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "47_オワーリ大陸 → 05_終焉の洞窟": {
            info: [
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "046",
                jpName: "ダディ",
              },
              {
                id: "119",
                jpName: "カベわんこ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "47_オワーリ大陸 → 06_フィナーレ神殿": {
            info: [
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "208",
                jpName: "バトルコアラッキョ",
              },
              {
                id: "042",
                jpName: "ナカイくん",
              },
              {
                id: "023",
                jpName: " カンバン娘",
              },
            ],
          },
          "48_伝説のおわり → 01_決断の時": {
            info: [
              {
                id: "207",
                jpName: "カルピンチョ",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "48_伝説のおわり → 02_復讐の準備": {
            info: [
              {
                id: "187",
                jpName: "教授",
              },
              {
                id: "282",
                jpName: "イノワ ール",
              },
              {
                id: "258",
                jpName: "タッちゃん",
              },
              {
                id: "389",
                jpName: "ヒウマ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "48_伝説のおわり → 03_栄光のグローリー": {
            info: [
              {
                id: "311",
                jpName: "ヒツギイヌ",
              },
              {
                id: "312",
                jpName: "キャベロン",
              },
              {
                id: "306",
                jpName: "オオさん",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "48_伝説のおわり → 04_命のせせらぎ": {
            info: [
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "342",
                jpName: "イカ天",
              },
              {
                id: "381",
                jpName: "天使ブッタ",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "263",
                jpName: "イノエンジ ェル",
              },
              {
                id: "121",
                jpName: "マンボーグ鈴木",
              },
              {
                id: "256",
                jpName: "ミスターエンジェル",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "48_伝説のおわり → 05_復活の偽呪文": {
            info: [
              {
                id: "317",
                jpName: "わんこの城",
              },
              {
                id: "237",
                jpName: "ドリュウ",
              },
              {
                id: "268",
                jpName: "ヒカル",
              },
              {
                id: "320",
                jpName: "イルカ娘",
              },
              {
                id: "357",
                jpName: "ケロ助",
              },
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "018",
                jpName: "ブラックマ",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "48_伝説のおわり → 06_契約の杯": {
            info: [
              {
                id: "390",
                jpName: "ウルトラメェメェ",
              },
              {
                id: "390",
                jpName: "ウルトラメェメェ",
              },
              {
                id: "390",
                jpName: "ウルト ラメェメェ",
              },
              {
                id: "390",
                jpName: "ウルトラメェメェ",
              },
              {
                id: "390",
                jpName: "ウルトラメェメェ",
              },
              {
                id: "390",
                jpName: "ウルトラメェメェ",
              },
              {
                id: "257",
                jpName: "キョセーヌ",
              },
              {
                id: "377",
                jpName: "大夢くん",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "125",
                jpName: "ド鳩・サブ・レー",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "48_伝説のおわり → 07_風そよぐ黄昏時": {
            info: [
              {
                id: "019",
                jpName: "赤羅我王",
              },
              {
                id: "033",
                jpName: "師匠",
              },
              {
                id: "036",
                jpName: "コアラッキョ",
              },
              {
                id: "058",
                jpName: "メタルサイボーグ",
              },
              {
                id: "055",
                jpName: "クロサワ監督",
              },
              {
                id: "040",
                jpName: "イノシャシ",
              },
              {
                id: "037",
                jpName: "こぶへい",
              },
              {
                id: "034",
                jpName: "ダチョウ同好会",
              },
              {
                id: "263",
                jpName: "イ ノエンジェル",
              },
              {
                id: "026",
                jpName: "ぶんぶん先生",
              },
            ],
          },
          "48_伝説のおわり → 08_破られた誓い": {
            info: [
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "362",
                jpName: "エリートエイリワン",
              },
              {
                id: "048",
                jpName: "殺 意のわんこ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "149",
                jpName: "メタルわんこ",
              },
              {
                id: "169",
                jpName: "エイリワン",
              },
              {
                id: "286",
                jpName: "ゾンビワン",
              },
              {
                id: "362",
                jpName: "エリート エイリワン",
              },
              {
                id: "023",
                jpName: "カンバン娘",
              },
            ],
          },
          "49_古代研究所 → 01_太古の力": {
            info: [
              {
                id: "274",
                jpName: "ちびぶんぶん",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "116",
                jpName: "天使ガブリエル",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "116",
                jpName: "天使ガブリエ ル",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "048",
                jpName: "殺意のわんこ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "120",
                jpName: "赤毛のにょろ",
              },
              {
                id: "015",
                jpName: "ワニック",
              },
              {
                id: "004",
                jpName: "例のヤツ",
              },
              {
                id: "003",
                jpName: "にょろ",
              },
              {
                id: "002",
                jpName: "わんこ",
              },
              {
                id: "407",
                jpName: "レジェンドブンブンΩ",
              },
              {
                id: "023",
                jpName: " カンバン娘",
              },
            ],
          },
        },
      },

      stageLegendConvert: {
        "01_長崎県": { ct: "01_台灣", jp: "01_長崎県", en: "01_Korea" },
        "02_佐賀県": { ct: "02_香港", jp: "02_佐賀県", en: "02_Mongolia" },
        "03_鹿児島県": { ct: "03_泰國", jp: "03_鹿児島県", en: "03_China" },
        "04_熊本県": { ct: "04_中國", jp: "04_熊本県", en: "04_Thailand" },
        "05_宮崎県": { ct: "05_蒙古", jp: "05_宮崎県", en: "05_Cambodia" },
        "06_大分県": { ct: "06_韓國", jp: "06_大分県", en: "06_Philippines" },
        "07_福岡県": { ct: "07_日本", jp: "07_福岡県", en: "07_Japan" },
        "08_高知県": {
          ct: "08_澳大利亞",
          jp: "08_高知県",
          en: "08_Australia",
        },
        "09_愛媛県": { ct: "09_新加坡", jp: "09_愛媛県", en: "09_Singapore" },
        "10_徳島県": {
          ct: "10_馬爾地夫",
          jp: "10_徳島県",
          en: "10_Maldives",
        },
        "11_香川県": { ct: "11_印度", jp: "11_香川県", en: "11_India" },
        "12_山口県": { ct: "12_尼泊爾", jp: "12_山口県", en: "12_Nepal" },
        "13_広島県": { ct: "13_杜拜", jp: "13_広島県", en: "13_Dubai" },
        "14_島根県": {
          ct: "14_沙烏地阿拉伯",
          jp: "14_島根県",
          en: "14_Saudi Arabia",
        },
        "15_岡山県": { ct: "15_肯亞", jp: "15_岡山県", en: "15_Kenya" },
        "16_鳥取県": {
          ct: "16_馬達加斯加",
          jp: "16_ 鳥取県",
          en: "16_Madagascar",
        },
        "17_兵庫県": {
          ct: "17_南非",
          jp: "17_兵庫県",
          en: "17_South Africa",
        },
        "18_和歌山県": { ct: "18_迦納", jp: "18_和歌山県", en: "18_Ghana" },
        "19_大阪府": {
          ct: "19_撒哈拉沙漠",
          jp: "19_大阪府",
          en: "19_Sahara",
        },
        "20_京都府": { ct: "20_埃及", jp: "20_京都府", en: "20_Egypt" },
        "21_奈良県": { ct: "21_土耳其", jp: "21_奈良県", en: "21_Turkey" },
        "22_三重県": { ct: "22_俄羅斯", jp: "22_三重県", en: "22_Russia" },
        "23_滋賀県": { ct: "23_希臘", jp: "23_滋賀県", en: "23_Greece" },
        "24_福井県": { ct: "24_義大利", jp: "24_福井県", en: "24_Italy" },
        "25_石川県": { ct: "25_摩納哥", jp: "25_石川県", en: "25_Monaco" },
        "26_愛知県": { ct: "26_西班牙", jp: "26_愛知県", en: "26_Spain" },
        "27_岐阜県": { ct: "27_法國", jp: "27_岐阜県", en: "27_France" },
        "28_富山県": { ct: "28_德國", jp: "28_富山県", en: "28_Germany" },
        "29_静岡県": { ct: "29_丹麥", jp: "29_静岡県", en: "29_Denmark" },
        "30_山梨県": { ct: "30_挪威", jp: "30_山梨県", en: "30_Norway" },
        "31_長野県": {
          ct: "31_英國",
          jp: "31_長野県",
          en: "31_United Kingdom",
        },
        "32_新潟県": {
          ct: "32_格陵蘭島",
          jp: "32_新潟県",
          en: "32_Greenland",
        },
        "33_神奈川県": {
          ct: "33_加拿大",
          jp: "33_神奈川県",
          en: "33_Canada",
        },
        "34_千葉県": { ct: "34_紐約", jp: "34_千葉県", en: "34_New York" },
        "35_東京都": { ct: "35_百慕達", jp: "35_東京都", en: "35_Bermuda" },
        "36_埼玉県": { ct: "36_牙買加", jp: "36_埼玉県", en: "36_Jamaica" },
        "37_群馬県": {
          ct: "37_哥倫比亞",
          jp: "37_群馬県",
          en: "37_Colombia",
        },
        "38_栃木県": { ct: "38_巴西", jp: "38_栃木県", en: "38_Brazil" },
        "39_茨城県": { ct: "39_阿根廷", jp: "39_茨城県", en: "39_Argentina" },
        "40_福島県": {
          ct: "40_馬丘比丘",
          jp: "40_福島県",
          en: "40_Machu Picchu",
        },
        "41_宮城県": {
          ct: "41_復活島",
          jp: "41_宮城県",
          en: "41_Easter Island",
        },
        "42_山形県": { ct: "42_墨西哥", jp: "42_山形県", en: "42_Mexico" },
        "43_岩手県": {
          ct: "43_美國太空總署",
          jp: "43_岩手県",
          en: "43_NASA",
        },
        "44_秋田県": {
          ct: "44_拉斯維加斯",
          jp: "44_秋田県",
          en: "44_Las Vegas",
        },
        "45_青森県": { ct: "45_好萊塢", jp: "45_青森県", en: "45_Hollywood" },
        "46_北海道": { ct: "46_阿拉斯加", jp: "46_北海道", en: "46_Alaska" },
        "47_沖縄県": { ct: "47_夏威夷", jp: "47_沖縄県", en: "47_Hawaii" },
        "48_西表島": { ct: "48_月球", jp: "48_西表島", en: "48_Moon" },

        "01_日本": { ct: "01_日本", jp: "01_日本", en: "01_Japan" },
        "02_韓国": { ct: "02_韓國", jp: "02_韓国", en: "02_Korea" },
        "03_中国": { ct: "03_台灣", jp: "03_中国", en: "03_China" },
        "04_モンゴル": {
          ct: "04_中國",
          jp: "04_モンゴル",
          en: "04_Mongolia",
        },
        "05_ロシア": { ct: "05_蒙古", jp: "05_ロシア", en: "05_Russia" },
        "06_ノルウェー": {
          ct: "06_俄羅斯",
          jp: "06_ノルウェー",
          en: "06_Norway",
        },
        "07_イギリス": {
          ct: "07_挪威",
          jp: "07_イギリス",
          en: "07_United Kingdom",
        },
        "08_デンマーク": {
          ct: "08_英國",
          jp: "08_デンマーク",
          en: "08_Denmark",
        },
        "09_ドイツ": { ct: "09_丹麥", jp: "09_ドイツ", en: "09_Germany" },
        "10_フランス": { ct: "10_德國", jp: "10_フランス", en: "10_France" },
        "11_スペイン": { ct: "11_法國", jp: "11_スペイン", en: "11_Spain" },
        "12_モナコ": { ct: "12_西班牙", jp: "12_モナコ", en: "12_Monaco" },
        "13_イタリア": { ct: "13_摩洛哥", jp: "13_イタリア", en: "13_Italy" },
        "14_ギリシャ": {
          ct: "14_義大利",
          jp: "14_ギリシャ",
          en: "14_Greece",
        },
        "15_トルコ": { ct: "15_希臘", jp: "15_トルコ", en: "15_Turkey" },
        "16_ドバイ": { ct: "16_土耳其", jp: "16_ドバイ", en: "16_Dubai" },
        "17_インド": { ct: "17_杜拜", jp: "17_インド", en: "17_India" },
        "18_ネパール": { ct: "18_印度", jp: "18_ネパール", en: "18_Nepal" },
        "19_タイ": { ct: "19_尼泊爾", jp: "19_タイ", en: "19_Thailand" },
        "20_カンボジア": {
          ct: "20_泰國",
          jp: "20_カンボジア",
          en: "20_Cambodia",
        },
        "21_フィリピン": {
          ct: "21_香港",
          jp: "21_フィリピン",
          en: "21_Philippines",
        },
        "22_シンガポール": {
          ct: "22_新加坡",
          jp: "22_シンガポール",
          en: "22_Singapore",
        },
        "23_オーストラリア": {
          ct: "23_澳大利亞",
          jp: "23_オーストラリ ア",
          en: "23_Australia",
        },
        "24_深淵の大渦": {
          ct: "24_深淵的大渦",
          jp: "24_深淵の大渦",
          en: "24_The Great Abyss",
        },
        "25_マダガスカル": {
          ct: "25_馬達加斯加",
          jp: "25_マダガスカル",
          en: "25_Madagascar",
        },
        "26_ケニア": { ct: "26_肯亞", jp: "26_ケニア", en: "26_Kenya" },
        "27_サウジアラビア": {
          ct: "27_沙烏地阿拉伯",
          jp: "27_サウジアラビア",
          en: "27_Saudi Arabia",
        },
        "28_エジプト": { ct: "28_埃及", jp: "28_エジプト", en: "28_Egypt" },
        "29_サハラ": {
          ct: "29_撒哈拉沙漠",
          jp: "29_サハラ",
          en: "29_Sahara",
        },
        "30_ガーナ": { ct: "30_迦納", jp: "30_ガーナ", en: "30_Ghana" },
        "31_南アフリカ": {
          ct: "31_南非",
          jp: "31_南アフリカ",
          en: "31_South Africa",
        },
        "32_アルゼンチン": {
          ct: "32_阿根廷",
          jp: "32_アルゼンチン",
          en: "32_Argentina",
        },
        "33_イースター島": {
          ct: "33_復活島",
          jp: "33_イースター島",
          en: "33_Easter Island",
        },
        "34_マチュピチュ": {
          ct: "34_馬丘比丘",
          jp: "34_マチュピチュ",
          en: "34_Machu Picchu",
        },
        "35_コロンビア": {
          ct: "35_哥倫比亞",
          jp: "35_コロンビア",
          en: "35_Columbia",
        },
        "36_ジャマイカ": {
          ct: "36_牙買加",
          jp: "36_ジャマイカ",
          en: "36_Jamaica",
        },
        "37_メキシコ": {
          ct: "37_墨西哥",
          jp: "37_メキシコ",
          en: "37_Mexico",
        },
        "38_ハリウッド": {
          ct: "38_好萊塢",
          jp: "38_ハリウッド",
          en: "38_Hollywood",
        },
        "39_ラスベガス": {
          ct: "39_拉斯維加斯",
          jp: "39_ラスベガス",
          en: "39_Las Vegas",
        },
        "40_アラスカ": {
          ct: "40_阿拉斯加",
          jp: "40_アラスカ",
          en: "40_Alaska",
        },
        "41_カナダ": { ct: "41_ 加拿大", jp: "41_カナダ", en: "41_Canada" },
        "42_グリーンランド": {
          ct: "42_格陵蘭島",
          jp: "42_グリーンランド",
          en: "42_Greenland",
        },
        "43_ニューヨーク": {
          ct: "43_紐約",
          jp: "43_ニューヨーク",
          en: "43_New York",
        },
        "44_NASA": { ct: "44_美國太空總署", jp: "44_NASA", en: "44_NASA" },
        "45_バミューダ": {
          ct: "45_百慕達",
          jp: "45_バミューダ",
          en: "45_Bermuda",
        },
        "46_ブラジル": { ct: "46_巴西", jp: "46_ブラジル", en: "46_Brazil" },
        "47_浮遊大陸": {
          ct: "47_浮遊大陸",
          jp: "47_浮遊大陸",
          en: "47_Floating Continent",
        },
        "48_月": { ct: "48_月球", jp: "48_月", en: "48_Moon" },

        "01_地球": { ct: "01_地球", jp: "01_地球", en: "01_Earth" },
        "02_火星": { ct: "02_火星", jp: "02_火星", en: "02_Mars" },
        "03_木星": { ct: "03_木星", jp: "03_木星", en: "03_Jupiter" },
        "04_土星": { ct: "04_土星", jp: "04_土星", en: "04_Saturn" },
        "05_金星": { ct: "05_金星", jp: "05_金星", en: "05_Venus" },
        "06_水星": { ct: "06_水星", jp: "06_水星", en: "06_Mercury" },
        "07_太陽": { ct: "07_太陽", jp: "07_太陽", en: "07_Sun" },
        "08_ウラヌス": {
          ct: "08_天王星",
          jp: "08_ウラヌス",
          en: "08_Uranus",
        },
        "09_ネプチューン": {
          ct: "09_海王星",
          jp: "09_ネプチューン",
          en: "09_Neptune",
        },
        "10_トリトン": {
          ct: "10_海衛一",
          jp: "10_トリトン",
          en: "10_Triton",
        },
        "11_プルートゥ": {
          ct: "11_冥王星",
          jp: "11_プルートゥ",
          en: "11_Pluto",
        },
        "12_赤い長方形星雲": {
          ct: "12_紅色長方形星雲",
          jp: "12_赤い長方形星雲",
          en: "12_Red Rectangle",
        },
        "13_エスキモー星雲": {
          ct: "13_愛斯基摩星雲",
          jp: "13_エスキモー星雲",
          en: "13_Eskimo Nebula",
        },
        "14_キャッツアイ星雲": {
          ct: "14_貓眼星雲",
          jp: "14_キャッツアイ星雲",
          en: "14_Catseye Nebula",
        },
        "15_卵星雲": {
          ct: "15_蛋星雲",
          jp: "15_卵星雲",
          en: "15_Egg Nebula",
        },
        "16_ひょうたん星雲": {
          ct: "16_葫蘆星雲",
          jp: "16_ひょうたん星雲",
          en: "16_Calabash Nebula",
        },
        "17_アルタイル": {
          ct: "17_牛郎星",
          jp: "17_アルタイル",
          en: "17_Altair",
        },
        "18_シリウス": {
          ct: "18_天狼星",
          jp: "18_シリウス",
          en: "18_Sirius",
        },
        "19_カノープス": {
          ct: "19_老人星",
          jp: "19_カノープス",
          en: "19_Canopus",
        },
        "20_ベガ": { ct: "20_織女星", jp: "20_ベガ", en: "20_Vega" },
        "21_アルデバラン": {
          ct: "21_畢宿五",
          jp: "21_アルデバラン",
          en: "21_Aldebaran",
        },
        "22_ベテルギウス": {
          ct: "22_參宿四",
          jp: "22_ベテルギウス",
          en: "22_Betelgeuse",
        },
        "23_デネブ": { ct: "23_天津四", jp: "23_デネブ", en: "23_Deneb" },
        "24_惑星スナック": {
          ct: "24_鼻涕蟲星",
          jp: "24_惑星スナック",
          en: "24_Cosmic Lounge",
        },
        "25_サイータ星": {
          ct: "25_打耳星",
          jp: "25_サイータ星",
          en: "25_Sighter's Star",
        },
        "26_魁皇星": { ct: "26_戒王星", jp: "26_魁皇星", en: "26_Kaiou" },
        "27_大マゼラン星雲": {
          ct: "27_大麥哲倫星雲",
          jp: "27_大マゼラン星雲",
          en: "27_Magellanic",
        },
        "28_ブータラ星": {
          ct: "28_布達拉星",
          jp: "28_ブータラ 星",
          en: "28_Buutara",
        },
        "29_モスカンダグ": {
          ct: "29_摩斯坎達克",
          jp: "29_モスカンダグ",
          en: "29_Moskandag",
        },
        "30_コロン星": {
          ct: "30_水果星",
          jp: "30_コロン星",
          en: "30_Corona",
        },
        "31_ヤキソパーン": {
          ct: "31_炒麵星",
          jp: "31_ヤキソパーン",
          en: "31_Soba IV",
        },
        "32_ウメ星": { ct: "32_梅乾星", jp: "32_ウメ星", en: "32_Plumpit" },
        "33_ダラララ": {
          ct: "33_達拉拉拉",
          jp: "33_ダラララ",
          en: "33_Darararah",
        },
        "34_マイドムリ": {
          ct: "34_月背三",
          jp: "34_マイドムリ",
          en: "34_Thanxbye",
        },
        "35_メルトズ": {
          ct: "35_大軸基地",
          jp: "35_メルトズ",
          en: "35_Mertoz",
        },
        "36_ウラルー": {
          ct: "36_魯神五號",
          jp: "36_ウラルー",
          en: "36_Urura",
        },
        "37_アグハムム": {
          ct: "37_亞掛哈姆",
          jp: "37_アグハムム",
          en: "37_Aguham",
        },
        "38_ソモロン": {
          ct: "38_所門羅",
          jp: "38_ソモロン",
          en: "38_Somolon",
        },
        "39_アバ・ブア": {
          ct: "39_阿巴．布亞",
          jp: "39_アバ・ブア",
          en: "39_Ababwa",
        },
        "40_ティターン": {
          ct: "40_泰 坦",
          jp: "40_ティターン",
          en: "40_Titan",
        },
        "41_デススタン": {
          ct: "41_暈死星",
          jp: "41_デススタン",
          en: "41_Skelling",
        },
        "42_ゴリラの惑星": {
          ct: "42_人猿星",
          jp: "42_ゴリラの惑星",
          en: "42_Gorigori",
        },
        "43_チョイバトロン星": {
          ct: "43_超博坦星",
          jp: "43_\tチョイバトロン星",
          en: "43_Broton",
        },
        "44_クリムゾン星": {
          ct: "44_深紅星",
          jp: "44_クリムゾン星",
          en: "44_Crimson Star",
        },
        "45_N77星雲": {
          ct: "45_N77星雲",
          jp: "45_N77星雲",
          en: "45_N77 Nebula",
        },
        "46_アンドロメダ": {
          ct: "46_仙女座星系",
          jp: "46_アンドロメダ",
          en: "46_Andromeda",
        },
        "47_ブラックホール": {
          ct: "47_黑洞",
          jp: "47_ブラックホール",
          en: "47_Black Hole",
        },
        "48_ビッグバン": {
          ct: "48_大霹靂",
          jp: "48_ビッグバン",
          en: "48_The Big Bang",
        },

        "01_伝説のはじまり → 01_大地を揺るがす": {
          ct: "01_傳說的開始 → 01_天搖地動",
          en: "01_The Legend Begins → 01_Earthshaker",
          jp: "01_伝説のはじまり → 01_大地を揺るがす",
        },
        "01_伝説のはじまり → 02_あの恐怖、再び": {
          ct: "01_傳說的開始 → 02_恐怖再現",
          en: "01_The Legend Begins → 02_Return of Terror",
          jp: "01_伝説のはじまり → 02_あの恐怖、再び",
        },
        "01_伝説のはじまり → 03_おつかれサンセット": {
          ct: "01_傳說的開始 → 03_疲累日落",
          en: "01_The Legend Begins → 03_Sunset Blues",
          jp: "01_伝説のはじまり → 03_おつかれサンセット",
        },
        "01_伝説のはじまり → 04_メランコリー湿地": {
          ct: "01_傳說的開始 → 04_憂鬱濕 地",
          en: "01_The Legend Begins → 04_Melancholy Damp",
          jp: "01_伝説のはじまり → 04_メランコリー湿地",
        },
        "01_伝説のはじまり → 05_ぷるるん広場": {
          ct: "01_傳說的開始 → 05_碰碰廣場",
          en: "01_The Legend Begins → 05_Bouncy Park",
          jp: "01_伝説のはじまり → 05_ぷるるん広場",
        },
        "01_伝説のはじまり → 06_愛情のまなざし": {
          ct: "01_傳說的開始 → 06_愛意眼神",
          en: "01_The Legend Begins → 06_Gentle Smile",
          jp: "01_伝説のはじまり → 06_愛情のまなざし",
        },
        "01_伝説のはじまり → 07_牧場の守護者": {
          ct: "01_傳說的開始 → 07_牧場的守護者",
          en: "01_The Legend Begins → 07_Guardian of the Ranch",
          jp: "01_伝説のはじまり → 07_牧場の守護者",
        },
        "01_伝説のはじまり → 08_眠れる獅子": {
          ct: "01_傳說的開始 → 08_沉睡的 獅子",
          en: "01_The Legend Begins → 08_Sleeping Lion",
          jp: "01_伝説のはじまり → 08_眠れる獅子",
        },
        "02_情熱の国 → 01_ニャンダルシア": {
          ct: "02_熱情的國家 → 01_喵塔露琪亞",
          en: "02_Passion Land → 01_Nyandalucia",
          jp: "02_情熱の国 → 01_ニャンダルシア",
        },
        "02_情熱の国 → 02_パエリア草原": {
          ct: "02_熱情的國家 → 02_海鮮飯草原",
          en: "02_Passion Land → 02_Paella Field",
          jp: "02_情熱の国 → 02_パエリア草原",
        },
        "02_情熱の国 → 03_フラメン坑": {
          ct: "02_熱情的國家 → 03_佛朗明坑",
          en: "02_Passion Land → 03_Flamenco Hole",
          jp: "02_情熱の国 → 03_フラメン坑",
        },
        "02_情熱の国 → 04_サングリア川": {
          ct: "02_熱情的國家 → 04_桑格利亞川",
          en: "02_Passion Land  → 04_Sangria River",
          jp: "02_情熱の国 → 04_サングリア川",
        },
        "02_情熱の国 → 05_ガスパチョ高原": {
          ct: "02_熱情的國家 → 05_涼菜湯高原",
          en: "02_Passion Land → 05_Gazpacho Highland",
          jp: "02_情熱の国 → 05_ガスパチョ高原",
        },
        "02_情熱の国 → 06_チュロス・ナイト": {
          ct: "02_熱情的國家 → 06_巧羅絲之夜",
          en: "02_Passion Land → 06_Churros Night",
          jp: "02_情熱の国 → 06_チュロス・ナイト",
        },
        "02_情熱の国 → 07_乾いた庭園": {
          ct: "02_熱 情的國家 → 07_風乾庭院",
          en: "02_Passion Land → 07_Bone Dry Gardens",
          jp: "02_情熱の国 → 07_乾いた庭園",
        },
        "02_情熱の国 → 08_タパス砂漠": {
          ct: "02_熱情的國家 → 08_塔帕斯沙漠",
          en: "02_Passion Land → 08_Tapas Desert",
          jp: "02_情熱の国 → 08_タパス砂漠",
        },
        "03_グルコサミン砂漠 → 01_コンドロイチン砂丘": {
          ct: "03_葡萄糖胺沙漠 → 01_軟骨素 沙丘",
          en: "03_Glucosamine Desert → 01_Chondroitin Sandhill",
          jp: "03_グルコサミン砂漠 → 01_コンド ロイチン砂丘",
        },
        "03_グルコサミン砂漠 → 02_セサ民遺跡": {
          ct: "03_葡萄糖 胺沙漠 → 02_芝麻素遺跡",
          en: "03_Glucosamine Desert → 02_Sesamin Ruins",
          jp: "03_グルコサミン砂漠 → 02_セサ民遺跡",
        },
        "03_グルコサミン砂漠 → 03_イソフラボン洞窟": {
          ct: "03_葡萄糖胺沙漠 → 03_大豆異黃酮洞窟",
          en: "03_Glucosamine Desert → 03_Isoflavone Cave",
          jp: "03_グルコサミン砂漠 → 03_イソフラボン洞窟",
        },
        "03_グルコサミン砂漠 → 04_カテキン丘陵": {
          ct: "03_葡萄糖胺沙漠 → 04_兒茶素丘陵",
          en: "03_Glucosamine Desert → 04_Catechin Hills",
          jp: "03_グルコサミン砂漠 → 04_カテキン丘陵",
        },
        "03_グルコサミン砂漠 → 05_リコピンの夕焼け": {
          ct: "03_葡萄糖胺沙漠 → 05_茄紅素的夕陽",
          en: "03_Glucosamine Desert → 05_Lycopene Sunset",
          jp: "03_グルコサミン砂漠 → 05_リコピンの夕焼け",
        },
        "03_グルコサミン砂漠 → 06_プロポリスオアシス": {
          ct: "03_ 葡萄糖胺沙漠 → 06_蜂膠綠洲",
          en: "03_Glucosamine Desert → 06_Propolis Oasis",
          jp: "03_グルコサミン砂漠 → 06_プロポリスオアシス",
        },
        "03_グルコサミン砂漠 → 07_ペプチド雪原": {
          ct: "03_葡萄糖胺沙漠 → 07_肽雪原",
          en: "03_Glucosamine Desert → 07_Peptide Snowfield",
          jp: "03_グルコサミン砂漠 → 07_ペプチド雪原",
        },
        "03_グルコサミン砂漠 → 08_ヒアルロン山": {
          ct: "03_葡萄糖胺沙漠 → 08_玻尿酸山",
          en: "03_Glucosamine Desert → 08_Hyaluronan Mountain",
          jp: "03_グルコサミン砂漠 → 08_ヒアルロン山",
        },
        "04_ネコども海を渡る → 01_無茶ぶり進水式": {
          ct: "04_貓咪們渡海 → 01_魯莽出航",
          en: "04_Swimming Cats → 01_Premature Launch",
          jp: "04_ネコども海を渡る → 01_無茶ぶり進水式",
        },
        "04_ネコども海を渡る → 02_ユーザン海原": {
          ct: "04_貓咪們渡海 → 02_廣闊海洋",
          en: "04_Swimming Cats → 02_Deep Ocean Blue",
          jp: "04_ネコ ども海を渡る → 02_ユーザン海原",
        },
        "04_ネコども海を渡る → 03_人魚の入り江": {
          ct: "04_貓咪們渡 海 → 03_人魚海灣",
          en: "04_Swimming Cats → 03_Mermaid Cove",
          jp: "04_ネコども海を渡る → 03_人魚の入り江",
        },
        "04_ネコども海を渡る → 04_カオスラグーン": {
          ct: "04_貓咪們渡海 → 04_渾沌潟湖",
          en: "04_Swimming Cats → 04_Chaos Lagoon",
          jp: "04_ネコども海を渡る → 04_カオスラグーン",
        },
        "04_ネコども海を渡る → 05_なんちゃって海賊": {
          ct: "04_貓咪們渡海 → 05_冒牌海盜",
          en: "04_Swimming Cats → 05_Playing Pirates",
          jp: "04_ネコども海を渡る → 05_なんちゃって海賊",
        },
        "04_ネコども海を渡る → 06_ホコタテ漁場": {
          ct: "04_貓咪們渡海 → 06_矛盾漁場",
          en: "04_Swimming Cats → 06_Fisherman's Dilemma",
          jp: "04_ネコども海を渡る → 06_ホコタテ漁場",
        },
        "04_ネコども海を渡る → 07_テングサ島": {
          ct: "04_貓咪們渡海 → 07_ 海藻島",
          en: "04_Swimming Cats → 07_Seaweed Shallows",
          jp: "04_ネコども海を渡る → 07_テングサ島",
        },
        "04_ネコども海を渡る → 08_海の水は塩辛い": {
          ct: "04_貓咪們渡海 → 08_海水很鹹",
          en: "04_Swimming Cats → 08_Salty is Seawater",
          jp: "04_ネコども海を渡る → 08_海の水は塩辛い",
        },
        "05_見つめてキャッツアイ → 01_ぽろり鉱石": {
          ct: "05_凝視著貓眼石 → 01_露點礦石",
          en: "05_Risqué Terrain → 01_Lovely Minerals",
          jp: "05_見つめてキャッツアイ → 01_ぽろり鉱石",
        },
        "05_見つめてキャッツアイ → 02_セクシー鍾乳洞": {
          ct: "05_ 凝視著貓眼石 → 02_性感鐘乳洞",
          en: "05_Risqué Terrain → 02_Shapely Caverns",
          jp: "05_見つめてキャッツアイ → 02_セクシー鍾乳洞",
        },
        "05_見つめてキャッツアイ → 03_ドキドキ穴": {
          ct: "05_凝視著貓眼石 → 03_心跳加速洞",
          en: "05_Risqué Terrain → 03_Enticing Tunnels",
          jp: "05_見つめてキャッツアイ → 03_ドキ ドキ穴",
        },
        "05_見つめてキャッツアイ → 04_ぷりぷりくぼみ": {
          ct: "05_凝視著貓眼石 → 04_豐臀水窪",
          en: "05_Risqué Terrain → 04_Squishy Hollows",
          jp: "05_見つめてキャッツアイ → 04_ぷりぷりくぼみ",
        },
        "05_見つめてキャッツアイ → 05_フタこぶ岩": {
          ct: "05_凝視著貓眼石 → 05_雙 峰岩",
          en: "05_Risqué Terrain → 05_Twin Peaks",
          jp: "05_見つめてキャッツアイ → 05_フタこぶ岩",
        },
        "05_見つめてキャッツアイ → 06_スリルの代償": {
          ct: "05_凝視著貓眼石 → 06_刺激的代價",
          en: "05_Risqué Terrain → 06_Thriller Bridge",
          jp: "05_見つめてキャッツアイ → 06_スリルの代償",
        },
        "06_ウエスタン街道 → 01_ガンマンの黄昏": {
          ct: "06_西 方街道 → 01_槍手的黃昏",
          en: "06_Western Street → 01_Gunman's Dawn",
          jp: "06_ウエスタン街道 → 01_ ガンマンの黄昏",
        },
        "06_ウエスタン街道 → 02_カウボーイ天国": {
          ct: "06_西方街道 → 02_牛仔天堂",
          en: "06_Western Street → 02_Cowboy Haven",
          jp: "06_ウエスタン街道 → 02_カウボーイ天国",
        },
        "06_ウエスタン街道 → 03_お尋ね者の夜": {
          ct: "06_西方街道 → 03_通緝犯之夜",
          en: "06_Western Street → 03_Wanted Night",
          jp: "06_ウエスタン街道 → 03_お尋ね者の夜",
        },
        "06_ウエスタン街道 → 04_マカロニタウン": {
          ct: "06_西 方街道 → 04_通心麵城",
          en: "06_Western Street → 04_Macaroni Town",
          jp: "06_ウエスタン街道 → 04_マカロニタウン",
        },
        "06_ウエスタン街道 → 05_さすらいの口笛": {
          ct: "06_西方街道 → 05_流浪的哨子",
          en: "06_Western Street → 05_Wandering Traveler",
          jp: "06_ウエスタン街道 → 05_さすらいの口笛",
        },
        "06_ウエスタン街道 → 06_がっかり用心棒": {
          ct: "06_西方街道 → 06_失望的保鑣",
          en: "06_Western Street → 06_Disappointed Guard",
          jp: "06_ウエスタン街道 → 06_がっかり用心棒",
        },
        "06_ウエスタン街道 → 07_テンガロン山": {
          ct: "06_西方街道 → 07_牛仔山",
          en: "06_Western Street → 07_Cowboy Mountain",
          jp: "06_ウエスタン 街道 → 07_テンガロン山",
        },
        "06_ウエスタン街道 → 08_ロデオナイト": {
          ct: "06_西方街 道 → 08_騎術夜",
          en: "06_Western Street → 08_Rodeo Night",
          jp: "06_ウエスタン街道 → 08_ロデオナイト",
        },
        "07_マグロ海域 → 01_ベニマグロ海岸": {
          ct: "07_鮪魚海域 → 01_紅鮪魚海岸",
          en: "07_Sea of Tuna → 01_Red Tuna Coast",
          jp: "07_マグロ海域 → 01_ベニマグロ海岸",
        },
        "07_マグロ海域 → 02_ピチピチ漁場": {
          ct: "07_鮪魚海域 → 02_新鮮漁場",
          en: "07_Sea of Tuna → 02_Fresh Wharf",
          jp: "07_マグロ海域 → 02_ピチピチ漁場",
        },
        "07_マグロ海域 → 03_ぷらっとオーシャン": {
          ct: "07_鮪魚海域 → 03_蔚藍海洋",
          en: "07_Sea of Tuna  → 03_Blue Ocean",
          jp: "07_マグロ海域 → 03_ぷらっとオーシャン",
        },
        "07_マグロ海域 → 04_カルパッチョ沖": {
          ct: "07_鮪魚海域 → 04_生魚片海面",
          en: "07_Sea of Tuna → 04_Carapaccio Waters",
          jp: "07_マグロ海域 → 04_カルパッチョ沖",
        },
        "07_マグロ海域 → 05_排他的経済水域": {
          ct: "07_鮪魚海域 → 05_獨佔性經濟海域",
          en: "07_Sea of Tuna → 05_Economic Sea",
          jp: "07_マグロ海域 → 05_排他的経済水域",
        },
        "07_マグロ海域 → 06_最終兵器トロ": {
          ct: "07_鮪 魚海域 → 06_最終武器鮪魚",
          en: "07_Sea of Tuna → 06_Tactical War Tuna",
          jp: "07_マグロ海域 → 06_最終兵器トロ",
        },
        "07_マグロ海域 → 07_冷凍マグロ戦線": {
          ct: "07_鮪魚海域 → 07_冷凍鮪魚戰線",
          en: "07_Sea of Tuna → 07_Frozen Tuna Front",
          jp: "07_マグロ海域 → 07_冷凍マグロ戦線",
        },
        "07_マグロ海域 → 08_解体ショー洞窟": {
          ct: "07_鮪魚海域 → 08_解剖秀洞窟",
          en: "07_Sea of Tuna → 08_Cave Fillet",
          jp: "07_マグロ海域 → 08_解体ショー洞窟",
        },
        "08_バンブー島 → 01_チクチク高原": {
          ct: "08_竹子島 → 01_刺痛高原",
          en: "08_Bamboo Island → 01_Prickly Field",
          jp: "08_バンブー島 → 01_ チクチク高原",
        },
        "08_バンブー島 → 02_タケノコ海岸": {
          ct: "08_竹子島 → 02_竹筍海岸",
          en: "08_Bamboo Island → 02_Bamboo Coast",
          jp: "08_バンブー島 → 02_タケノコ海岸",
        },
        "08_バンブー島 → 03_殺人鬼ジャングル": {
          ct: "08_竹子島 → 03_殺人鬼叢林",
          en: "08_Bamboo Island → 03_Serial Killer Jungle",
          jp: "08_バンブー島 → 03_殺人鬼ジャングル",
        },
        "08_バンブー島 → 04_げろげろ沼": {
          ct: "08_竹子島 → 04_噁心沼澤",
          en: "08_Bamboo Island → 04_Disgusting Swamp",
          jp: "08_バンブー島 → 04_げろげろ沼",
        },
        "08_バンブー島 → 05_もっさり坑道": {
          ct: "08_竹子島 → 05_笨拙坑道",
          en: "08_Bamboo Island → 05_Dumpy Cave",
          jp: "08_バンブー島 → 05_もっさり坑道",
        },
        "08_バンブー島 → 06_星くず街道": {
          ct: "08_竹子島 → 06_星塵街道",
          en: "08_Bamboo Island → 06_Stardust Street",
          jp: "08_バンブー島 → 06_星くず街道",
        },
        "08_バンブー島 → 07_キノコ崖": {
          ct: "08_竹子島 → 07_蘑菇懸崖",
          en: "08_Bamboo Island → 07_Mushroom Cliff",
          jp: "08_バンブー島 → 07_キノコ崖",
        },
        "08_バンブー島 → 08_暁フロンティア": {
          ct: "08_竹子島 → 08_破曉邊線",
          en: "08_Bamboo Island → 08_Frontier Spirit",
          jp: "08_バンブー島 → 08_暁フロンティア",
        },
        "09_ぷにぷに鍾乳洞 → 01_ミルキートンネル": {
          ct: "09_黏糊糊 的鐘乳洞 → 01_乳白隧道",
          en: "09_Squishy Cave → 01_Milky Tunnel",
          jp: "09_ぷにぷに鍾乳洞 → 01_ミルキートンネル",
        },
        "09_ぷにぷに鍾乳洞 → 02_ふわふわ暗黒兵器": {
          ct: "09_黏糊糊的鐘乳洞 → 02_軟綿綿的暗黑兵器",
          en: "09_Squishy Cave → 02_Fluffy Dark Weapon",
          jp: "09_ぷにぷに鍾乳洞 → 02_ふわふわ暗黒兵器",
        },
        "09_ぷにぷに鍾乳洞 → 03_悪魔の壁画": {
          ct: "09_黏糊糊的鐘乳洞 → 03_惡魔的壁畫",
          en: "09_Squishy Cave → 03_Mural of the Devil",
          jp: "09_ぷにぷに鍾乳 洞 → 03_悪魔の壁画",
        },
        "09_ぷにぷに鍾乳洞 → 04_隙間風のささやき": {
          ct: "09_黏糊糊的鐘乳洞 → 04_輕風細雨",
          en: "09_Squishy Cave → 04_The Wind Blows",
          jp: "09_ぷにぷに鍾乳洞 → 04_隙間風のささやき",
        },
        "09_ぷにぷに鍾乳洞 → 05_甘えんぼ暗殺者": {
          ct: "09_黏糊糊的鐘乳洞 → 05_撒嬌殺手",
          en: "09_Squishy Cave → 05_Juvenile Killer",
          jp: "09_ぷにぷに鍾乳洞 → 05_甘えんぼ暗殺者",
        },
        "09_ぷにぷに鍾乳洞 → 06_うろたえる岩": {
          ct: "09_黏糊糊的鐘乳洞 → 06_煩惱的岩石",
          en: "09_Squishy Cave → 06_Upset Rock",
          jp: "09_ぷにぷに鍾乳洞 → 06_うろたえる岩",
        },
        "09_ぷにぷに鍾乳洞 → 07_雨漏り洞窟": {
          ct: "09_黏糊糊的鐘乳洞 → 07_漏水洞窟",
          en: "09_Squishy Cave → 07_Flooded Cave",
          jp: "09_ぷにぷに鍾乳洞 → 07_雨漏り洞窟",
        },
        "09_ぷにぷに鍾乳洞 → 08_ぽっちゃり性善説": {
          ct: "09_黏糊糊的鐘乳洞 → 08_豐滿的性 善論",
          en: "09_Squishy Cave → 08_Chubby B. Goode",
          jp: "09_ぷにぷに鍾乳洞 → 08_ぽっちゃり性善説",
        },
        "10_ボルケーノ火山 → 01_半身浴岩": {
          ct: "10_瓦魯肯諾火山 → 01_半身浴岩石",
          en: "10_Volkanos Volcano → 01_Hot Bath Rock",
          jp: "10_ボルケーノ火山 → 01_半身浴岩",
        },
        "10_ボルケーノ火山 → 02_ほっこり間欠泉": {
          ct: "10_瓦魯肯 諾火山 → 02_放鬆間歇泉",
          en: "10_Volkanos Volcano → 02_Gentle Geyser",
          jp: "10_ボルケーノ火山 → 02_ほっこり間欠泉",
        },
        "10_ボルケーノ火山 → 03_とろーりマグマ": {
          ct: "10_瓦魯肯諾火山 → 03_濃稠岩漿",
          en: "10_Volkanos Volcano → 03_Thick Magma",
          jp: "10_ボルケーノ火山 → 03_とろーりマグマ",
        },
        "10_ボルケーノ火山 → 04_炎の檻": {
          ct: "10_瓦魯肯諾火山  → 04_火焰牢籠",
          en: "10_Volkanos Volcano → 04_Fire Cage",
          jp: "10_ボルケーノ火山 → 04_炎の檻",
        },
        "10_ボルケーノ火山 → 05_火口を守る者": {
          ct: "10_瓦魯肯諾 火山 → 05_火山口守護人",
          en: "10_Volkanos Volcano → 05_Volcanic Defender",
          jp: "10_ボルケーノ火山  → 05_火口を守る者",
        },
        "10_ボルケーノ火山 → 06_メラメラカルデラ": {
          ct: "10_瓦魯肯諾火山 → 06_熊熊火山 臼",
          en: "10_Volkanos Volcano → 06_Flame Caldera",
          jp: "10_ボルケーノ火山 → 06_メラメラカルデラ",
        },
        "11_千里の道 → 01_ポテンシャルロード": {
          ct: "11_千里之道 → 01_潛力之路",
          en: "11_Neverending Cat Story → 01_Potential Road",
          jp: "11_千里の道 → 01_ポテンシャルロード",
        },
        "11_千里の道 → 02_憂愁の木": {
          ct: "11_千里之道 → 02_憂愁之樹",
          en: "11_Neverending Cat Story → 02_Gloomy Tree",
          jp: "11_千里の道 → 02_憂愁の木",
        },
        "11_千里の道 → 03_そよかぜの歌声": {
          ct: "11_千里之道 → 03_微風的歌聲",
          en: "11_Neverending Cat Story → 03_A Song in the Wind",
          jp: "11_千里の道 → 03_そよかぜの歌声",
        },
        "11_千里の道 → 04_哲学の道": {
          ct: "11_千里之道 → 04_哲學之道",
          en: "11_Neverending Cat Story → 04_Philosophy Road",
          jp: "11_千里の道 → 04_哲学の道",
        },
        "11_千里の道 → 05_境界線の晩鐘": {
          ct: "11_千里之道 → 05_境界線的晩鐘",
          en: "11_Neverending Cat Story → 05_Frontier Bell",
          jp: "11_千里の道 → 05_境界線の晩鐘",
        },
        "11_千里の道 → 06_流した涙の川": {
          ct: "11_千里之道 → 06_流淚之川",
          en: "11_Neverending Cat Story → 06_River of Tears",
          jp: "11_千里の道 → 06_流した涙の川",
        },
        "11_千里の道 → 07_輝く道": {
          ct: "11_ 千里之 道 → 07_光輝之道",
          en: "11_Neverending Cat Story → 07_Shining Road",
          jp: "11_千里の道 → 07_輝く道",
        },
        "11_千里の道 → 08_試練の谷底": {
          ct: "11_千里之道 → 08_試煉谷底",
          en: "11_Neverending Cat Story → 08_The Trial Deep",
          jp: "11_千里の道 → 08_試練の谷底",
        },
        "12_アオ・ザ・カナ → 01_磯のささやき": {
          ct: "12_鹹魚要塞 → 01_海岩的耳語",
          en: "12_Castle of Fish → 01_The Sea Whispers",
          jp: "12_ア オ・ザ・カナ → 01_磯のささやき",
        },
        "12_アオ・ザ・カナ → 02_サザナミ・アイランド": {
          ct: "12_鹹魚要塞 → 02_漣漪島",
          en: "12_Castle of Fish → 02_Ripples Island",
          jp: "12_アオ・ザ・カナ → 02_サザナミ・ア イランド",
        },
        "12_アオ・ザ・カナ → 03_ダークオクトパスの海": {
          ct: "12_鹹魚要塞 → 03_黑暗章魚海",
          en: "12_Castle of Fish → 03_Octopus Sea",
          jp: "12_アオ・ザ・カナ → 03_ダークオクトパスの海",
        },
        "12_アオ・ザ・カナ → 04_ポセイドンのこしかけ": {
          ct: "12_鹹魚要塞 → 04_波賽頓的小憩",
          en: "12_Castle of Fish  → 04_Poseidon Rest",
          jp: "12_アオ・ザ・カナ → 04_ポセイドンのこしかけ",
        },
        "12_アオ・ザ・カナ → 05_月明かりのビーチ": {
          ct: "12_鹹魚要塞 → 05_月光海灘",
          en: "12_Castle of Fish → 05_Moonlight Beach",
          jp: "12_アオ・ザ・カナ → 05_月明かりのビーチ",
        },
        "12_アオ・ザ・カナ → 06_コーラルサンゴ礁": {
          ct: "12_ 鹹魚要塞 → 06_珊瑚礁",
          en: "12_Castle of Fish → 06_Coral Coral Reef",
          jp: "12_アオ・ザ・カナ → 06_コーラルサンゴ礁",
        },
        "12_アオ・ザ・カナ → 07_月の箱舟": {
          ct: "12_鹹魚要塞 → 07_月之方舟",
          en: "12_Castle of Fish → 07_Ark of the Month",
          jp: "12_アオ・ザ・カナ → 07_月の箱舟",
        },
        "12_アオ・ザ・カナ → 08_殺戮兵器 シラ・ス": {
          ct: "12_鹹魚要塞 → 08_殺戮兵器-沙・丁魚",
          en: "12_Castle of Fish → 08_Killer Sardines",
          jp: "12_アオ・ザ・カナ → 08_殺戮兵器 シラ・ス",
        },
        "13_軍艦島 → 01_ネギトロ平野": {
          ct: "13_軍艦島 → 01_青蔥魚腩平原",
          en: "13_Sushi Island → 01_Tuna Field",
          jp: "13_軍艦島 → 01_ネギトロ平 野",
        },
        "13_軍艦島 → 02_カニミソ草原": {
          ct: "13_軍艦島 → 02_蟹黃平原",
          en: "13_Sushi Island → 02_Crab Field",
          jp: "13_軍艦島 → 02_カニミソ草原",
        },
        "13_軍艦島 → 03_イクラ岩窟": {
          ct: "13_軍艦島 → 03_鮭魚卵岩窟",
          en: "13_Sushi Island → 03_Salmon Cave",
          jp: "13_軍艦島 → 03_イクラ岩窟",
        },
        "13_軍艦島 → 04_ウニ街道": {
          ct: "13_軍艦島 → 04_海膽街道",
          en: "13_Sushi Island → 04_Sea Urchin Cave",
          jp: "13_軍艦島 → 04_ウニ街道",
        },
        "13_軍艦島 → 05_トビコ原生林": {
          ct: "13_軍艦島 → 05_魚子醬原始林",
          en: "13_Sushi Island → 05_Caviar Woods",
          jp: "13_軍艦島 → 05_トビコ原生林",
        },
        "13_軍艦島 → 06_納豆海岸": {
          ct: "13_軍艦島 → 06_納豆海岸",
          en: "13_Sushi Island → 06_Natto Bay",
          jp: "13_軍艦島 → 06_納豆海岸",
        },
        "13_軍艦島 → 07_エンガワの森": {
          ct: "13_軍艦島 → 07_比目魚森 林",
          en: "13_Sushi Island → 07_Halibut Forest",
          jp: "13_軍艦島 → 07_エンガワの森",
        },
        "13_軍艦島 → 08_アマエビフロンティア": {
          ct: "13_軍艦島 → 08_甜蝦邊境",
          en: "13_Sushi Island → 08_Shrimp Frontier",
          jp: "13_軍艦島 → 08_アマエビフ ロンティア",
        },
        "14_つめとぎの廊下 → 01_ダンボール回廊": {
          ct: "14_貓咪磨爪的走廊 → 01_紙箱迴廊",
          en: "14_The Scratching Post → 01_Cardboard Corridor",
          jp: "14_つめとぎの廊下 → 01_ダンボール回廊",
        },
        "14_つめとぎの廊下 → 02_マタタビの夢": {
          ct: "14_貓咪磨爪的走廊 → 02_貓薄荷之夢",
          en: "14_The Scratching Post → 02_Catnip Dream",
          jp: "14_つめとぎの廊下 → 02_マタタビの夢",
        },
        "14_つめとぎの廊下 → 03_ガリガリウォール": {
          ct: "14_貓咪磨爪的走廊 → 03_嘎吱嘎吱牆",
          en: "14_The Scratching Post → 03_Crunchy Wall",
          jp: "14_つめとぎの廊下 → 03_ガリガリウォール",
        },
        "14_つめとぎの廊下 → 04_木くずを掻き分けて": {
          ct: "14_貓咪磨爪的走廊 → 04_撥開木屑",
          en: "14_The Scratching Post → 04_Wading Woodchips",
          jp: "14_つめとぎの廊下 → 04_木くずを掻き分けて",
        },
        "14_つめとぎの廊下 → 05_バリバリ柱": {
          ct: "14_貓咪磨爪的走廊 → 05_嘎吱嘎吱柱",
          en: "14_The Scratching Post → 05_Crunchy Pillar",
          jp: "14_つめとぎの廊下 → 05_バリバリ柱",
        },
        "14_つめとぎの廊下 → 06_乱暴者の番人": {
          ct: "14_貓咪磨爪的走廊 → 06_野蠻人的看守人",
          en: "14_The Scratching Post → 06_Disapproving Giant",
          jp: "14_つめとぎの廊下 → 06_乱暴者の番人",
        },
        "15_パルテノン神殿 → 01_ゼウスの祭壇": {
          ct: "15_帕德嫩神殿 → 01_宙斯的祭壇",
          en: "15_Parthenon → 01_Altar of Zeus",
          jp: "15_パルテノン神殿 → 01_ゼウスの祭壇",
        },
        "15_パルテノン神殿 → 02_アキレスの剣": {
          ct: "15_帕德嫩神殿 → 02_阿基里斯之劍",
          en: "15_Parthenon → 02_Sword of Achilles",
          jp: "15_パルテノン神殿 → 02_アキレスの剣",
        },
        "15_パルテノン神殿 → 03_エロスの街道": {
          ct: "15_帕德嫩神殿 → 03_厄洛斯之路",
          en: "15_Parthenon → 03_Road of Eros",
          jp: "15_パルテノン神殿 → 03_エロスの街道",
        },
        "15_パルテノン神殿 → 04_ガイアの夜明け": {
          ct: "15_帕德嫩神殿 → 04_蓋亞的黎明",
          en: "15_Parthenon → 04_Dawn of Gaia",
          jp: "15_パルテノン神殿 → 04_ガイアの夜明け",
        },
        "15_パルテノン神殿 → 05_アフロディテの門": {
          ct: "15_帕德嫩神殿 → 05_阿芙蘿黛蒂大門",
          en: "15_Parthenon → 05_Gates of Aphrodite",
          jp: "15_パルテノン神殿 → 05_アフロディテの門",
        },
        "15_パルテノン神殿 → 06_ハデスの迷宮": {
          ct: "15_帕德嫩神殿 → 06_黑帝斯的迷宮",
          en: "15_Parthenon → 06_Labyrinth of Hades",
          jp: "15_パルテノン神殿 → 06_ハデスの迷宮",
        },
        "16_ずんどこ海水浴場 → 01_潮干狩りの浜": {
          ct: "16_退潮的海水浴場 → 01_摸蜆仔沙灘",
          en: "16_Low Tide Beach → 01_Clammy Cove",
          jp: "16_ずんどこ海水浴場 → 01_潮干狩りの浜",
        },
        "16_ずんどこ海水浴場 → 02_ムツゴロウパーク": {
          ct: "16_退潮的海水浴場 → 02_彈塗魚公園",
          en: "16_Low Tide Beach → 02_Beached Mammals",
          jp: "16_ずんどこ海水浴場 → 02_ムツゴロウパーク",
        },
        "16_ずんどこ海水浴場 → 03_水着美女の面影": {
          ct: "16_退潮的海水浴場 → 03_泳衣美女的影子",
          en: "16_Low Tide Beach → 03_Bikini Territory",
          jp: "16_ずんどこ海水浴場 → 03_水着美女の面影",
        },
        "16_ずんどこ海水浴場 → 04_イモ洗いプール": {
          ct: "16_退潮的 海水浴場 → 04_人山人海游泳池",
          en: "16_Low Tide Beach → 04_Apple Bobbing Ocean",
          jp: "16_ずんどこ海水浴場 → 04_イモ洗いプール",
        },
        "16_ずんどこ海水浴場 → 05_ビーチパラソル畑": {
          ct: "16_退潮的海水浴場  → 05_遮陽傘田",
          en: "16_Low Tide Beach → 05_Parasol Field",
          jp: "16_ずんどこ海水浴場 → 05_ビーチパラソル畑",
        },
        "16_ずんどこ海水浴場 → 06_いにしえのビキニ": {
          ct: "16_退潮的海水浴場 → 06_古早的比基尼",
          en: "16_Low Tide Beach → 06_Ancient One-Piece",
          jp: "16_ずんどこ海水浴場 → 06_いにしえのビキニ",
        },
        "16_ずんどこ海水浴場 → 07_カラフルカクテル": {
          ct: "16_退潮的海水浴場 → 07_七彩雞尾酒",
          en: "16_Low Tide Beach → 07_Glassy Sands",
          jp: "16_ずんどこ海水浴場 → 07_カラフルカクテル",
        },
        "16_ずんどこ海水浴場 → 08_星降る大海": {
          ct: "16_退潮的海水浴場 → 08_星降大海",
          en: "16_Low Tide Beach → 08_Star Ocean",
          jp: "16_ずんどこ海水浴場 → 08_星降る大海",
        },
        "17_アルカトラズ島 → 01_カモメ海岸": {
          ct: "17_惡魔 島 → 01_海鷗海岸",
          en: "17_Alcatraz → 01_Gull Coast",
          jp: "17_アルカトラズ島 → 01_カモメ海岸",
        },
        "17_アルカトラズ島 → 02_ペリカン島": {
          ct: "17_惡魔島 → 02_鵜鶘島",
          en: "17_Alcatraz → 02_Pelican Island",
          jp: "17_アルカトラズ島 → 02_ペリカン島",
        },
        "17_アルカトラズ島 → 03_地下制御室": {
          ct: "17_惡魔 島 → 03_地下控制室",
          en: "17_Alcatraz → 03_Underground Base",
          jp: "17_アルカトラズ島 → 03_地下制御室",
        },
        "17_アルカトラズ島 → 04_悪党の密林": {
          ct: "17_惡魔島 → 04_壞蛋的密林",
          en: "17_Alcatraz → 04_Villains Jungle",
          jp: "17_アルカトラズ島 → 04_悪党の密林",
        },
        "17_アルカトラズ島 → 05_バラバラチキンレース": {
          ct: "17_惡魔島 → 05_咕咕雞賽跑",
          en: "17_Alcatraz → 05_Chicken Game",
          jp: "17_アルカトラ ズ島 → 05_バラバラチキンレース",
        },
        "17_アルカトラズ島 → 06_ねこ裁判": {
          ct: "17_惡魔島 → 06_貓咪審判",
          en: "17_Alcatraz → 06_Cat Trial",
          jp: "17_アルカトラズ島 → 06_ねこ裁判",
        },
        "17_アルカトラズ島 → 07_監獄草原": {
          ct: "17_惡魔島 → 07_監獄草原",
          en: "17_Alcatraz → 07_Prison Prairie",
          jp: "17_アルカトラズ島 → 07_監獄草原",
        },
        "17_アルカトラズ島 → 08_看守と墓守": {
          ct: "17_惡魔島 → 08_看守人與守墓人",
          en: "17_Alcatraz → 08_Jailer in the Morgue",
          jp: "17_アルカトラズ島 → 08_看守と墓守",
        },
        "18_脱獄トンネル → 01_茶罪～ギル・ティ～": {
          ct: "18_越獄隧道 → 01_罪與罰",
          en: "18_Jail Break Tunnel → 01_Sin and Punishment",
          jp: "18_脱獄トンネル → 01_茶罪～ギル・ティ～",
        },
        "18_脱獄トンネル → 02_実刑判決": {
          ct: "18_越獄隧道  → 02_實刑判決",
          en: "18_Jail Break Tunnel → 02_Prison Sentence",
          jp: "18_脱獄トンネル → 02_実刑判決",
        },
        "18_脱獄トンネル → 03_ハリートンネル": {
          ct: "18_越獄隧道 → 03_哈利隧道",
          en: "18_Jail Break Tunnel → 03_Harry Tunnel",
          jp: "18_脱獄トンネル → 03_ハリートンネル",
        },
        "18_脱獄トンネル → 04_夜のしじま": {
          ct: "18_越獄隧道 → 04_夜之寂靜",
          en: "18_Jail Break Tunnel → 04_Dead Falls",
          jp: "18_脱獄トンネル → 04_夜のしじま",
        },
        "18_脱獄トンネル → 05_落とし穴地帯": {
          ct: "18_越獄隧道  → 05_陷阱地帶",
          en: "18_Jail Break Tunnel → 05_Pitfall Zone",
          jp: "18_脱獄トンネル → 05_落とし穴地帯",
        },
        "18_脱獄トンネル → 06_大脱走": {
          ct: "18_越獄隧道 → 06_大逃亡",
          en: "18_Jail Break Tunnel → 06_The Great Escaper",
          jp: "18_脱獄トンネル → 06_大脱走",
        },
        "19_カポネの監獄 → 01_脱獄日誌": {
          ct: "19_卡彭監獄 → 01_越獄日誌",
          en: "19_Capone's Jail → 01_Jailbreak Diary",
          jp: "19_カポネの監獄 → 01_ 脱獄日誌",
        },
        "19_カポネの監獄 → 02_ラスト・ギャング": {
          ct: "19_卡彭監獄 → 02_最後的流氓",
          en: "19_Capone's Jail → 02_Last Gang",
          jp: "19_カポネの監獄 → 02_ラスト・ギャング",
        },
        "19_カポネの監獄 → 03_プリズン・破": {
          ct: "19_卡彭監獄 → 03_監獄破壞",
          en: "19_Capone's Jail → 03_Prison Destruction",
          jp: "19_カポネの監獄 → 03_プリズン・破",
        },
        "19_カポネの監獄 → 04_シャバの王者": {
          ct: "19_卡彭監獄 → 04_自由之王",
          en: "19_Capone's Jail → 04_King of Freedom",
          jp: "19_カポネの監獄 → 04_シャバの王者",
        },
        "19_カポネの監獄 → 05_嘘つきの末路": {
          ct: "19_卡彭監獄 → 05_撒謊的下場",
          en: "19_Capone's Jail → 05_Liar's Fate",
          jp: "19_カポネの監獄 → 05_嘘つきの末路",
        },
        "19_カポネの監獄 → 06_豚小屋のタブー": {
          ct: "19_卡彭監獄 → 06_豬圈的忌諱",
          en: "19_Capone's Jail → 06_Pigpen Taboo",
          jp: "19_カポネの監獄 → 06_豚小屋のタブー",
        },
        "20_シルクロード → 01_ガンダーラ休憩所": {
          ct: "20_絲綢之路 → 01_犍陀羅的休息處",
          en: "20_Silk Road → 01_Gandara's Rest",
          jp: "20_シルクロード → 01_ガンダーラ休憩所",
        },
        "20_シルクロード → 02_ユートピアはあちら": {
          ct: "20_絲綢之路 → 02_烏托邦就在那裡",
          en: "20_Silk Road → 02_Utopia is Over There",
          jp: "20_シルクロード → 02_ユートピアはあちら",
        },
        "20_シルクロード → 03_ゴダイゴ峠": {
          ct: "20_絲綢之路 → 03_後醍醐山脊",
          en: "20_Silk Road → 03_Godiego Pass",
          jp: "20_シルクロード → 03_ゴダイゴ峠",
        },
        "20_シルクロード → 04_モンキーマジック": {
          ct: "20_絲綢之路 → 04_猴子魔法",
          en: "20_Silk Road → 04_Monkey Magic",
          jp: "20_シルクロード → 04_モンキーマジック",
        },
        "20_シルクロード → 05_異国の門": {
          ct: "20_絲綢之路 → 05_異國 之門",
          en: "20_Silk Road → 05_Outsider's Gate",
          jp: "20_シルクロード → 05_異国の門",
        },
        "20_シルクロード → 06_マルコ・ポーロード": {
          ct: "20_絲綢之路 → 06_馬可波羅之路",
          en: "20_Silk Road → 06_Marco Po Road",
          jp: "20_シルクロード → 06_マルコ・ポーロード",
        },
        "20_シルクロード → 07_豚の残飯": {
          ct: "20_絲綢之路 → 07_豬的剩飯",
          en: "20_Silk Road → 07_Pig Swill",
          jp: "20_シルクロード → 07_豚の残飯",
        },
        "20_シルクロード → 08_河童の冷や汗": {
          ct: "20_絲綢之路 → 08_河童的冷汗",
          en: "20_Silk Road → 08_Imp's cold sweat",
          jp: "20_シルクロード → 08_河童の冷や汗",
        },
        "21_闇へと続く地下道 → 01_転ばぬ先の杖": {
          ct: "21_邁向黑暗的地下道 → 01_有備無患",
          en: "21_Stairway To Darkness → 01_Safe and Not Sorry",
          jp: "21_闇へと続く地下道 → 01_転ばぬ先の杖",
        },
        "21_闇へと続く地下道 → 02_暗い・狭い・怖い道": {
          ct: "21_邁向黑暗的地下道 → 02_黑暗狹窄恐怖陰道",
          en: "21_Stairway To Darkness → 02_Claustronyctophobia",
          jp: "21_闇へと続く地下道 → 02_暗い・狭い・怖い道",
        },
        "21_闇へと続く地下道 → 03_レッド・アラート": {
          ct: "21_邁向黑暗的地下道 → 03_紅色警報",
          en: "21_Stairway To Darkness → 03_Red Alert",
          jp: "21_闇へと続く地下道 → 03_レッド・アラート",
        },
        "21_闇へと続く地下道 → 04_人生の落とし穴": {
          ct: "21_邁向黑暗的地下道  → 04_人生的陷阱",
          en: "21_Stairway To Darkness → 04_Pitfalls of Life",
          jp: "21_闇へと続く地下道 → 04_人生の落とし穴",
        },
        "21_闇へと続く地下道 → 05_かすかな晩鐘": {
          ct: "21_邁向黑暗的地下道 → 05_隱約的晚鐘",
          en: "21_Stairway To Darkness → 05_Subtle Curfew",
          jp: "21_闇へと続く地下道 → 05_かすかな晩鐘",
        },
        "21_闇へと続く地下道 → 06_アンダーワールド": {
          ct: "21_邁向黑暗的地下道 → 06_地底世界",
          en: "21_Stairway To Darkness → 06_Underground",
          jp: "21_闇へと続く地下道 → 06_アンダーワールド",
        },
        "22_魔王の豪邸 → 01_セレブな玄関": {
          ct: "22_魔王的豪宅 → 01_有錢人家的玄關",
          en: "22_Prince of Darkness → 01_The Red Carpet",
          jp: "22_魔王の豪邸 → 01_セレブな玄関",
        },
        "22_魔王の豪邸 → 02_バスルーム": {
          ct: "22_魔王的豪宅 → 02_浴室",
          en: "22_Prince of Darkness → 02_The Bathroom",
          jp: "22_魔王の豪邸 → 02_バスルーム",
        },
        "22_魔王の豪邸 → 03_オシャレVIPルーム": {
          ct: "22_魔王的豪宅 → 03_時尚的VIP室",
          en: "22_Prince of Darkness → 03_The VIP Room",
          jp: "22_魔王の豪邸 → 03_オシャレVIPルーム",
        },
        "22_魔王の豪邸 → 04_拷問部屋": {
          ct: "22_魔王的豪宅 → 04_拷問間",
          en: "22_Prince of Darkness → 04_Torture Room",
          jp: "22_魔王の豪邸 → 04_拷問部屋",
        },
        "22_魔王の豪邸 → 05_独裁者の庭": {
          ct: "22_魔王的豪宅 → 05_獨裁者的花園",
          en: "22_Prince of Darkness → 05_Dictator's Garden",
          jp: "22_魔王の豪邸 → 05_独裁者の庭",
        },
        "22_魔王の豪邸 → 06_魔王の寝室": {
          ct: "22_魔王的豪宅 → 06_魔王的寢室",
          en: "22_Prince of Darkness → 06_Satan's Bedroom",
          jp: "22_魔王の豪邸 → 06_魔王の寝室",
        },
        "23_終わりを告げる夜 → 01_裏切りの宴": {
          ct: "23_終焉宣告之夜 → 01_背叛之宴",
          en: "23_Dead End Night → 01_Feast of Betrayal",
          jp: "23_終わりを告げる夜 → 01_裏切りの宴",
        },
        "23_終わりを告げる夜 → 02_終焉のカタルシス": {
          ct: "23_終焉宣告之夜 → 02_終焉的淨化",
          en: "23_Dead End Night → 02_Catharsis' End",
          jp: "23_終わりを告げる夜 → 02_終焉のカタルシス",
        },
        "23_終わりを告げる夜 → 03_黒い予感": {
          ct: "23_終焉宣告之夜 → 03_黑色預感",
          en: "23_Dead End Night → 03_Black Premonition",
          jp: "23_終わりを告げる夜 → 03_黒い予感",
        },
        "23_終わりを告げる夜 → 04_砕けた仮面": {
          ct: "23_終焉宣告之夜 → 04_破碎的面具",
          en: "23_Dead End Night → 04_Broken Mask",
          jp: "23_終わりを告げる夜 → 04_砕けた仮面",
        },
        "23_終わりを告げる夜 → 05_アガペーの檻": {
          ct: "23_終焉宣告之夜 → 05_神愛之籠",
          en: "23_Dead End Night → 05_Agape's Cage",
          jp: "23_終わりを告げる夜 → 05_アガペーの檻",
        },
        "23_終わりを告げる夜 → 06_赤いきつねの聖者": {
          ct: "23_終焉宣告之夜 → 06_紅狐之聖者",
          en: "23_Dead End Night → 06_Saint Red Fox",
          jp: "23_終わりを告げる夜 → 06_赤いきつねの聖者",
        },
        "24_バトルロワイアル → 01_ロイヤル・ミル・クティ": {
          ct: "24_大混戰 → 01_皇家奶茶",
          en: "24_Battle Royale → 01_Her Highness, Milk T.",
          jp: "24_バトルロワイアル → 01_ロイヤル・ミル・クティ",
        },
        "24_バトルロワイアル → 02_怒りと闘争心": {
          ct: "24_大混戰 → 02_憤怒與爭鬥心",
          en: "24_Battle Royale → 02_Angry Fighting",
          jp: "24_バトルロワイアル → 02_怒りと闘争心",
        },
        "24_バトルロワイアル → 03_忍び寄る戦慄の詩": {
          ct: "24_大混戰 → 03_悄 悄接近的戰慄之詩",
          en: "24_Battle Royale → 03_The Horrible Song",
          jp: "24_バトルロワイアル → 03_忍び寄る戦慄の詩",
        },
        "24_バトルロワイアル → 04_卑怯者の罠": {
          ct: "24_大混戰 → 04_膽小鬼的陷阱",
          en: "24_Battle Royale → 04_Trap of Cowards",
          jp: "24_バトルロワイアル → 04_卑怯者の罠",
        },
        "24_バトルロワイアル → 05_闇より生まれし宿敵": {
          ct: "24_大混戰 → 05_黑暗中誕生的宿敵",
          en: "24_Battle Royale → 05_Dark Nemesis",
          jp: "24_バトルロ ワイアル → 05_闇より生まれし宿敵",
        },
        "24_バトルロワイアル → 06_魚介類と血のにおい": {
          ct: "24_大混戰 → 06_海鮮與血的腥味",
          en: "24_Battle Royale → 06_Scent of Gore &amp; Fish",
          jp: "24_バトルロワイアル → 06_魚介類と血のにおい",
        },
        "25_戦争のつめあと → 01_ワルキューレ平原": {
          ct: "25_戰爭的傷痕 → 01_瓦爾 基麗平原",
          en: "25_Scars of War → 01_Valkyrie Plains",
          jp: "25_戦争のつめあと → 01_ワルキューレ平原",
        },
        "25_戦争のつめあと → 02_ぶっとび地雷原": {
          ct: "25_戰爭的傷痕 → 02_地雷區",
          en: "25_Scars of War → 02_Minefield",
          jp: "25_戦争のつめあと → 02_ぶっとび地雷原",
        },
        "25_戦争のつめあと → 03_クーゲルシュライバー": {
          ct: "25_戰爭的傷痕 → 03_秘密武器",
          en: "25_Scars of War → 03_Kugel Schreiber",
          jp: "25_戦争のつめあと → 03_クーゲルシュライバー",
        },
        "25_戦争のつめあと → 04_ぬかるみ塹壕": {
          ct: "25_戰爭的 傷痕 → 04_泥濘的壕溝",
          en: "25_Scars of War → 04_Muddy Trench",
          jp: "25_戦争のつめあと → 04_ぬかるみ塹壕",
        },
        "25_戦争のつめあと → 05_スナイパージャングル": {
          ct: "25_戰爭的傷痕 → 05_狙擊手叢林",
          en: "25_Scars of War → 05_Sniper Jungle",
          jp: "25_戦争のつめあと → 05_スナイパージャングル",
        },
        "25_戦争のつめあと → 06_斜陽のソルジャー": {
          ct: "25_戰爭的傷痕 → 06_斜陽的士兵",
          en: "25_Scars of War → 06_Sunset Soldier",
          jp: "25_戦争のつめあと → 06_斜陽のソルジャー",
        },
        "25_戦争のつめあと → 07_父の背中": {
          ct: "25_戰爭的傷痕 → 07_父親的背影",
          en: "25_Scars of War → 07_Father's Back",
          jp: "25_戦争のつめ あと → 07_父の背中",
        },
        "25_戦争のつめあと → 08_境界線奪還作戦": {
          ct: "25_戰爭的傷痕 → 08_境界線奪還作戦",
          en: "25_Scars of War → 08_Winning Back",
          jp: "25_戦争のつめあと → 08_境界線奪還作戦",
        },
        "26_海を汚す悪しき者 → 01_石油プラットホーム": {
          ct: "26_污染海洋的壞人 → 01_鑽油平台",
          en: "26_Sea Polluter → 01_Oil Platform",
          jp: "26_海を汚す悪しき者 → 01_石油プラットホーム",
        },
        "26_海を汚す悪しき者 → 02_汗とアルデヒド": {
          ct: "26_污染海洋的壞人 → 02_汗與乙醛",
          en: "26_Sea Polluter → 02_Sweat and Aldehyde",
          jp: "26_海を汚す悪しき者 → 02_汗とアルデヒド",
        },
        "26_海を汚す悪しき者 → 03_いにしえの裁判": {
          ct: "26_污染海洋的壞人 → 03_古代的審判",
          en: "26_Sea Polluter → 03_Ancient Trial",
          jp: "26_海を汚 す悪しき者 → 03_いにしえの裁判",
        },
        "26_海を汚す悪しき者 → 04_あやしい自治体": {
          ct: "26_污染海洋的壞人 → 04_可疑的自治團體",
          en: "26_Sea Polluter → 04_I'm onto you",
          jp: "26_海を汚す悪しき者 → 04_あや しい自治体",
        },
        "26_海を汚す悪しき者 → 05_ポイステ海岸": {
          ct: "26_污染海洋的壞人 → 05_垃圾海岸",
          en: "26_Sea Polluter → 05_Littering Coast",
          jp: "26_海を汚す悪しき者 → 05_ポイステ海岸",
        },
        "26_海を汚す悪しき者 → 06_ベンゼン畑": {
          ct: "26_污染海洋的壞人 → 06_苯田",
          en: "26_Sea Polluter → 06_Benzene Field",
          jp: "26_海を汚す悪しき者 → 06_ベンゼン畑",
        },
        "26_海を汚す悪しき者 → 07_政府の犬": {
          ct: "26_污染海洋的壞人 → 07_政 府的走狗",
          en: "26_Sea Polluter → 07_Government Watchdog",
          jp: "26_海を汚す悪しき者 → 07_政府の犬",
        },
        "26_海を汚す悪しき者 → 08_あまくだり海流": {
          ct: "26_污染海洋的壞人 → 08_空降的海流",
          en: "26_Sea Polluter → 08_Revolving-door Floats",
          jp: "26_海を汚す悪しき者 → 08_あまくだり海流",
        },
        "27_心と体、繋ぐもの → 01_夕焼けの咆哮": {
          ct: "27_連接心身的東西 → 01_晚霞的咆哮",
          en: "27_Body &amp; Soul → 01_Sunset's Howl",
          jp: "27_心と体、繋ぐもの → 01_夕焼けの咆哮",
        },
        "27_心と体、繋ぐもの → 02_ゲシュタルト、崩壊": {
          ct: "27_連接心身的東西 → 02_格式塔,崩壞",
          en: "27_Body &amp; Soul → 02_Gestalt, Decay",
          jp: "27_心と体、繋ぐもの → 02_ゲシュタルト、崩壊",
        },
        "27_心と体、繋ぐもの → 03_戦士の黎明": {
          ct: "27_連接心身的東西 → 03_戰士的黎明",
          en: "27_Body &amp; Soul → 03_Warrior's Dawn",
          jp: "27_心と体、繋ぐもの → 03_戦士の黎明",
        },
        "27_心と体、繋ぐもの → 04_呪われた永久凍土": {
          ct: "27_連 接心身的東西 → 04_被詛咒的永久凍土",
          en: "27_Body &amp; Soul → 04_Cursed Blizzards",
          jp: "27_心と体、繋ぐもの → 04_呪われた永久凍土",
        },
        "27_心と体、繋ぐもの → 05_ねこの証": {
          ct: "27_連接心身的東西 → 05_貓的印証",
          en: "27_Body &amp; Soul → 05_Sign of the Cat",
          jp: "27_心と体、繋ぐもの → 05_ねこの証",
        },
        "27_心と体、繋ぐもの → 06_愚者の絶望": {
          ct: "27_連接心身的東西 → 06_愚者的絶望",
          en: "27_Body &amp; Soul → 06_Out of Despair",
          jp: "27_心と体、繋ぐもの → 06_愚者の絶望",
        },
        "27_心と体、繋ぐもの → 07_メタボリック症候群": {
          ct: "27_連接心身的東西 → 07_代謝症候群",
          en: "27_Body &amp; Soul → 07_Metabolic Syndrome",
          jp: "27_心と体、繋ぐもの → 07_メタボリック症候群",
        },
        "27_心と体、繋ぐもの → 08_愛と死": {
          ct: "27_連接心身的東西 → 08_愛與死",
          en: "27_Body &amp; Soul → 08_Love and Death",
          jp: "27_心と体、繋ぐもの → 08_愛と死",
        },
        "28_脆弱性と弱酸性 → 01_せめて、ネコらしく": {
          ct: "28_脆弱性和弱酸性 → 01_至少像隻貓",
          en: "28_Weak &amp; Mildly Acidic → 01_At Least I'm a Cat",
          jp: "28_脆弱性と弱酸性 → 01_せめて、ネコらしく",
        },
        "28_脆弱性と弱酸性 → 02_円卓の騎士": {
          ct: "28_脆弱性和弱酸性 → 02_圓桌武士",
          en: "28_Weak &amp; Mildly Acidic → 02_Knights of the Round",
          jp: "28_脆弱性と弱酸性 → 02_円卓の騎 士",
        },
        "28_脆弱性と弱酸性 → 03_おにゃんこカタルシス": {
          ct: "28_脆弱性和弱酸性 → 03_貓族淨化",
          en: "28_Weak &amp; Mildly Acidic → 03_Cat Catharsis",
          jp: "28_脆弱性と弱酸性 → 03_おにゃんこカタルシス",
        },
        "28_脆弱性と弱酸性 → 04_美しい終わり": {
          ct: "28_脆弱性和弱酸性 → 04_美麗終結",
          en: "28_Weak &amp; Mildly Acidic → 04_Beautiful Finale",
          jp: "28_脆弱性と弱酸性 → 04_美しい終わり",
        },
        "28_脆弱性と弱酸性 → 05_悪夢からの覚醒": {
          ct: "28_脆弱性和弱酸性 → 05_從惡夢中驚醒",
          en: "28_Weak &amp; Mildly Acidic → 05_No More Bad Dreams",
          jp: "28_脆弱性と弱酸性 → 05_悪夢からの覚醒",
        },
        "28_脆弱性と弱酸性 → 06_おぼえたての愛": {
          ct: "28_脆弱性和弱酸性 → 06_剛學會去愛",
          en: "28_Weak &amp; Mildly Acidic → 06_Learned to Love",
          jp: "28_脆弱性と弱酸性 → 06_おぼえたての愛",
        },
        "29_導かれしネコ達 → 01_新たなる戦い": {
          ct: "29_被引導的貓咪 們 → 01_新的戰役",
          en: "29_Intrepid Cats → 01_Renewed Conflict",
          jp: "29_導かれしネコ達 → 01_新たなる戦い",
        },
        "29_導かれしネコ達 → 02_ミステリーサークル": {
          ct: "29_被引導的貓咪們 → 02_麥田圈",
          en: "29_Intrepid Cats → 02_Mysterious Order",
          jp: "29_導かれしネコ達 → 02_ミステリーサークル",
        },
        "29_導かれしネコ達 → 03_野鳥観察": {
          ct: "29_被引導的貓咪們 → 03_野鳥觀察",
          en: "29_Intrepid Cats → 03_Birdwatching",
          jp: "29_導かれしネコ達 → 03_野鳥観察",
        },
        "29_導かれしネコ達 → 04_言葉の端のトゲ": {
          ct: "29_被引導的貓咪們 → 04_語中帶刺",
          en: "29_Intrepid Cats → 04_Thorny Dialogue",
          jp: "29_導かれしネコ達 → 04_言葉の端のトゲ",
        },
        "29_導かれしネコ達 → 05_ブラックウェーブ": {
          ct: "29_被引導的貓 咪們 → 05_黑色波浪",
          en: "29_Intrepid Cats → 05_Darkweb",
          jp: "29_導かれしネコ達 → 05_ブラックウェーブ",
        },
        "30_暗黒コスモポリス → 01_ハングリーフォレスト": {
          ct: "30_黑暗的國際城市 → 01_飢餓森林",
          en: "30_Shadow Cosmopolis → 01_Hungry Forest",
          jp: "30_暗黒コスモポリス → 01_ハングリーフォレスト",
        },
        "30_暗黒コスモポリス → 02_身の程知らずの巣": {
          ct: "30_黑暗的國際城市 → 02_自不量力者的巢穴",
          en: "30_Shadow Cosmopolis → 02_Overachiever Central",
          jp: "30_暗黒コスモポリス → 02_身の程知らずの巣",
        },
        "30_暗黒コスモポリス → 03_通勤ラッシュ": {
          ct: "30_黑暗的國際城市 → 03_通勤尖峰",
          en: "30_Shadow Cosmopolis → 03_Morning Rush Hour",
          jp: "30_暗黒コスモポリス → 03_通勤ラッシュ",
        },
        "30_暗黒コスモポリス → 04_ドッキングジェノサイダー": {
          ct: "30_黑暗的國際城市 → 04_集體大滅絕",
          en: "30_Shadow Cosmopolis  → 04_Docking Massacre",
          jp: "30_暗黒コスモポリス → 04_ドッキングジェノサイダー",
        },
        "30_暗黒コスモポリス → 05_地下帝国からの刺客": {
          ct: "30_黑暗的國際城市 → 05_來自地底帝國的刺客",
          en: "30_Shadow Cosmopolis → 05_Subterranean Stalker",
          jp: "30_暗黒コスモポリス → 05_地下帝国からの刺客",
        },
        "30_暗黒コスモポリス → 06_暗黒街の支配者": {
          ct: "30_黑暗的國際城市 → 06_無法地帶支配者",
          en: "30_Shadow Cosmopolis → 06_Lord of the Abyss",
          jp: "30_暗黒コスモポリス → 06_暗黒街の支配者",
        },
        "31_ガラ・パ・ゴス → 01_DNAとDHA": {
          ct: "31_加拉・巴・哥 → 01_DNA與DHA",
          en: "31_Galapa-Goth → 01_DNA &amp; DHA",
          jp: "31_ガラ・パ・ゴス → 01_DNAとDHA",
        },
        "31_ガラ・パ・ゴス → 02_夕焼けの密猟者": {
          ct: "31_加拉・巴・哥 → 02_夕陽盜獵者",
          en: "31_Galapa-Goth → 02_Twilight Poachers",
          jp: "31_ガラ・パ・ゴス → 02_夕焼けの密猟者",
        },
        "31_ガラ・パ・ゴス → 03_遭難者の群れ": {
          ct: "31_加拉・巴・哥 → 03_遇難者們",
          en: "31_Galapa-Goth → 03_Surviving Herd",
          jp: "31_ガラ・パ・ゴス → 03_遭難者の群れ",
        },
        "31_ガラ・パ・ゴス → 04_異星生態調査団": {
          ct: "31_加拉・巴・哥 → 04_異星生態調查團",
          en: "31_Galapa-Goth → 04_Alien Ecology",
          jp: "31_ガラ・パ・ゴス → 04_異星生態調査団",
        },
        "31_ガラ・パ・ゴス → 05_楽園のいきもの達": {
          ct: "31_加拉・巴・ 哥 → 05_樂園生物",
          en: "31_Galapa-Goth → 05_Heavenly Creatures",
          jp: "31_ガラ・パ・ゴス → 05_楽園のいきもの達",
        },
        "31_ガラ・パ・ゴス → 06_環境保護団体": {
          ct: "31_加拉・巴・哥 → 06_環境保護團體",
          en: "31_Galapa-Goth → 06_Conservation Society",
          jp: "31_ガラ・パ・ゴス → 06_環境保護団体",
        },
        "32_岩海苔半島 → 01_りんりん防風林": {
          ct: "32_岩海苔半島 → 01_凜凜防風林",
          en: "32_Kombu Cape → 01_Rinrin Shelterbelt",
          jp: "32_岩海苔半島 → 01_りんりん防風林",
        },
        "32_岩海苔半島 → 02_イベリコ平野": {
          ct: "32_岩海苔半島 → 02_伊比利亞平野",
          en: "32_Kombu Cape → 02_Iberian Plains",
          jp: "32_岩海苔半島 → 02_イベリコ平野",
        },
        "32_岩海苔半島 → 03_泣き砂海岸": {
          ct: "32_岩海苔半島 → 03_哭砂海岸",
          en: "32_Kombu Cape → 03_Weeping Dunes",
          jp: "32_岩海苔半島 → 03_泣き砂海岸",
        },
        "32_岩海苔半島 → 04_ゴールデン街": {
          ct: "32_岩海苔半島 → 04_黃金街",
          en: "32_Kombu Cape → 04_Golden Gai",
          jp: "32_岩海苔半島 → 04_ゴールデン街",
        },
        "32_岩海苔半島 → 05_鈍足ドライブウェイ": {
          ct: "32_岩海苔半島 → 05_超級慢車道",
          en: "32_Kombu Cape → 05_Leadfoot Drive",
          jp: "32_岩海苔半島 → 05_鈍足ドライブウェイ",
        },
        "32_岩海苔半島 → 06_武家屋敷お家騒動": {
          ct: "32_岩海苔半島 → 06_武家大院家族內鬥",
          en: "32_Kombu Cape → 06_Trouble at the Mansion",
          jp: "32_岩海苔半島 → 06_武家屋敷お家騒動",
        },
        "33_恐ろし連邦 → 01_クリムゾン広場": {
          ct: "33_惡羅斯聯邦 → 01_緋 紅廣場",
          en: "33_Axis of Evil → 01_Pecking Order",
          jp: "33_恐ろし連邦 → 01_クリムゾン広場",
        },
        "33_恐ろし連邦 → 02_インテリゲンチャ": {
          ct: "33_ 惡羅斯聯邦 → 02_知識階級",
          en: "33_Axis of Evil → 02_Technocracy",
          jp: "33_恐ろし連邦 → 02_インテリゲンチャ",
        },
        "33_恐ろし連邦 → 03_ポッポー領土": {
          ct: "33_惡羅斯聯邦 → 03_霸道領土",
          en: "33_Axis of Evil → 03_Merciless Onslaught",
          jp: "33_恐ろし連邦 → 03_ポッポー領土",
        },
        "33_恐ろし連邦 → 04_バトル海の決戦": {
          ct: "33_惡羅斯聯邦 → 04_決戰霸王海",
          en: "33_Axis of Evil → 04_Celestial Seas",
          jp: "33_恐ろし連邦 → 04_バトル海の決戦",
        },
        "33_恐ろし連邦 → 05_宇宙開発局": {
          ct: "33_惡羅斯聯邦 → 05_宇宙開發局",
          en: "33_Axis of Evil  → 05_Close Encounters",
          jp: "33_恐ろし連邦 → 05_宇宙開発局",
        },
        "33_恐ろし連邦 → 06_スパイより愛を込めて": {
          ct: "33_惡羅斯聯邦 → 06_間諜之戀",
          en: "33_Axis of Evil → 06_The Spy Who Pet Me",
          jp: "33_恐ろし連邦 → 06_スパイより愛を込めて",
        },
        "34_亡者の住まう地 → 01_死霊の館": {
          ct: "34_亡者聚集之地 → 01_亡魂鬼屋",
          en: "34_Suburbs of the Dead → 01_Home Sweet Mausoleum",
          jp: "34_亡者の住まう地 → 01_死霊の館",
        },
        "34_亡者の住まう地 → 02_いけにえ沼": {
          ct: "34_亡者聚集之地 → 02_活祭品沼澤",
          en: "34_Suburbs of the Dead → 02_Swamp of Sacrifice",
          jp: "34_亡者の住まう地 → 02_いけにえ沼",
        },
        "34_亡者の住まう地 → 03_ムール街の悪夢": {
          ct: "34_亡者聚集之地 → 03_半夜鬼上床",
          en: "34_Suburbs of the Dead → 03_Dungeon of Dreams",
          jp: "34_亡者の住まう地 → 03_ムール街の悪夢",
        },
        "34_亡者の住まう地 → 04_ポルターガイストリート": {
          ct: "34_亡者聚集之地 → 04_騷靈街",
          en: "34_Suburbs of the Dead → 04_Revenant Road",
          jp: "34_亡者の住まう地 → 04_ポルターガイストリート",
        },
        "34_亡者の住まう地 → 05_ホワイト・ライト・ナイト": {
          ct: "34_亡者聚集之地 → 05_白光之夜",
          en: "34_Suburbs of the Dead → 05_Ghostlight Gardens",
          jp: "34_亡者の住まう地 → 05_ホワイト・ライト・ナイト",
        },
        "34_亡者の住まう地 → 06_猫たちの沈黙": {
          ct: "34_亡者聚集之地 → 06_沉默的小貓",
          en: "34_Suburbs of the Dead → 06_Silenced Meowing",
          jp: "34_亡者 の住まう地 → 06_猫たちの沈黙",
        },
        "35_絶島パンデミック → 01_感染者密航": {
          ct: "35_孤島大瘟疫 → 01_感染者偷渡",
          en: "35_Quarantine Isles → 01_Virus Smugglers",
          jp: "35_絶島パンデミック → 01_感染者密航",
        },
        "35_絶島パンデミック → 02_ハイテク昆布漁": {
          ct: "35_孤島大瘟疫 → 02_高科技採海帶法",
          en: "35_Quarantine Isles → 02_Bionic Seaweed",
          jp: "35_絶島パンデミック → 02_ハイテク昆布漁",
        },
        "35_絶島パンデミック → 03_先祖の行進": {
          ct: "35_孤島 大瘟疫 → 03_祖先大遊行",
          en: "35_Quarantine Isles → 03_Ancestral Ways",
          jp: "35_絶島パンデミック → 03_先祖の行進",
        },
        "35_絶島パンデミック → 04_脱出を阻む者": {
          ct: "35_孤島大瘟疫 → 04_反脫逃部隊",
          en: "35_Quarantine Isles → 04_High Watchtower",
          jp: "35_絶島パンデミック → 04_脱出を阻む者",
        },
        "35_絶島パンデミック → 05_怒りのマグロ戦線": {
          ct: "35_孤島大瘟疫 → 05_憤怒鮪魚戰線",
          en: "35_Quarantine Isles → 05_Tunafish Trenches",
          jp: "35_絶島パンデミック → 05_怒りのマグロ戦線",
        },
        "35_絶島パンデミック → 06_感染、島の主": {
          ct: "35_孤島大瘟疫 → 06_受感染的島主",
          en: "35_Quarantine Isles → 06_The Infected King",
          jp: "35_絶島パンデミック → 06_感染、島の主",
        },
        "36_ふくろのねずみランド → 01_お出迎え入場門": {
          ct: "36_迪死你樂園 → 01_入場大門",
          en: "36_Mouseyland → 01_Greeter at the Gates",
          jp: "36_ふくろのねずみランド → 01_お出迎え入場門",
        },
        "36_ふくろのねずみランド → 02_無気力コースター": {
          ct: "36_迪死你樂園 → 02_慢吞吞飛車",
          en: "36_Mouseyland → 02_Rickety Coaster",
          jp: "36_ふくろのねずみランド → 02_無気力コースター",
        },
        "36_ふくろのねずみランド → 03_リアルVR地獄": {
          ct: "36_迪死你樂園 → 03_真實VR地獄",
          en: "36_Mouseyland → 03_Virtual Nightmare",
          jp: "36_ふくろのねずみランド → 03_リアルVR地獄",
        },
        "36_ふくろのねずみランド → 04_プラス50度の世界": {
          ct: "36_迪 死你樂園 → 04_50度樂園",
          en: "36_Mouseyland → 04_50 Degrees Hotter",
          jp: "36_ふくろのねずみランド → 04_プラス50度の世界",
        },
        "36_ふくろのねずみランド → 05_誘惑のチキンルーム": {
          ct: "36_迪死你樂園 → 05_提雞神殿",
          en: "36_Mouseyland → 05_Irresistable Henhouse",
          jp: "36_ふくろのねずみランド → 05_誘惑 のチキンルーム",
        },
        "36_ふくろのねずみランド → 06_ボーンデッドアパートメント": {
          ct: "36_迪死你樂園 → 06_骨灰公寓",
          en: "36_Mouseyland → 06_The Haunted 1LDK",
          jp: "36_ふくろのねずみランド → 06_ボーンデッドアパートメント",
        },
        "37_ハリーウッド帝国 → 01_パパラッチフィーバー": {
          ct: "37_豪來塢帝國 → 01_狗仔狂 熱潮",
          en: "37_Walk of Fame → 01_Paparazzi Paradise",
          jp: "37_ハリーウッド帝国 → 01_パパラッチフィ ーバー",
        },
        "37_ハリーウッド帝国 → 02_因縁ゴシップスター": {
          ct: "37_豪來塢帝國 → 02_因緣緋聞明星",
          en: "37_Walk of Fame → 02_Gossip Rags",
          jp: "37_ハリーウッド帝国 → 02_因縁ゴシップスター",
        },
        "37_ハリーウッド帝国 → 03_バブリーヒルズ白書": {
          ct: "37_豪來塢帝國 → 03_飛越泡沫期",
          en: "37_Walk of Fame → 03_Beverly Hills Scoop",
          jp: "37_ハリーウッド帝国 → 03_バブリーヒルズ白書",
        },
        "37_ハリーウッド帝国 → 04_子役上がり": {
          ct: "37_豪來塢帝國 → 04_童星出身",
          en: "37_Walk of Fame → 04_Lovechild Lane",
          jp: "37_ハリーウッド帝国 → 04_子役上がり",
        },
        "37_ハリーウッド帝国 → 05_セクシースキャンダル": {
          ct: "37_豪來塢帝國 → 05_花邊醜聞",
          en: "37_Walk of Fame → 05_Saucy Scandals",
          jp: "37_ハリーウッド帝国 → 05_セクシースキャンダル",
        },
        "37_ハリーウッド帝国 → 06_ウニバーサンスタジオ": {
          ct: "37_豪來塢帝國 → 06_大 膽換囚影城",
          en: "37_Walk of Fame → 06_Multiversal Studios",
          jp: "37_ハリーウッド帝国 → 06_ウニバーサンスタジオ",
        },
        "38_こしぎんちゃくの浜辺 → 01_よたもの遊泳大会": {
          ct: "38_小跟班海岸 → 01_呆瓜游泳大 會",
          en: "38_Cutpurse Coast → 01_Swim Meet",
          jp: "38_こしぎんちゃくの浜辺 → 01_よたもの遊泳大会",
        },
        "38_こしぎんちゃくの浜辺 → 02_ヘアーサロン潮風": {
          ct: "38_小跟班海岸 → 02_海風美容院",
          en: "38_Cutpurse Coast → 02_Sea Breeze Salon",
          jp: "38_こしぎんちゃくの浜辺 → 02_ヘアーサロン潮風",
        },
        "38_こしぎんちゃくの浜辺 → 03_ディープシー決死隊": {
          ct: "38_小跟班海岸 → 03_深海敢死隊",
          en: "38_Cutpurse Coast → 03_Deep Sea Dying",
          jp: "38_こしぎんちゃくの浜辺 → 03_ディープシー決死隊",
        },
        "38_こしぎんちゃくの浜辺 → 04_ぺこぺこパレード": {
          ct: "38_小跟班海岸 → 04_鞠躬大遊行",
          en: "38_Cutpurse Coast → 04_Procrastinator Parade",
          jp: "38_こしぎんちゃくの浜辺 → 04_ぺこぺこパレード",
        },
        "38_こしぎんちゃくの浜辺 → 05_大御所大博覧会": {
          ct: "38_小跟班海岸 → 05_影藝重鎮博覽會",
          en: "38_Cutpurse Coast → 05_Grand Exhibition",
          jp: "38_こしぎんちゃくの浜辺 → 05_大御所大博覧会",
        },
        "38_こしぎんちゃくの浜辺 → 06_もう陸には帰れない": {
          ct: "38_小跟班海岸 → 06_無法再上陸",
          en: "38_Cutpurse Coast → 06_No Return Flights",
          jp: "38_こしぎんちゃくの浜辺 → 06_もう陸には帰れない",
        },
        "39_雲泥温泉郷 → 01_自家製電気風呂": {
          ct: "39_雲泥温泉郷 → 01_自家製電療浴缸",
          en: "39_Above &amp; Below → 01_Electric Bath",
          jp: "39_雲泥温泉郷 → 01_自家製電気風呂",
        },
        "39_雲泥温泉郷 → 02_熱湯風呂我慢大会": {
          ct: "39_雲泥温泉郷 → 02_熱水澡忍耐大賽",
          en: "39_Above &amp; Below → 02_Boiling Spring",
          jp: "39_雲泥温泉郷 → 02_熱湯風呂我慢大会",
        },
        "39_雲泥温泉郷 → 03_ケミカル長寿の湯": {
          ct: "39_雲泥温泉郷 → 03_化學奇蹟長壽湯",
          en: "39_Above &amp; Below → 03_Mineral Treatment",
          jp: "39_雲泥温泉郷 → 03_ケミカル長寿の湯",
        },
        "39_雲泥温泉郷 → 04_垢い敵、黒い汗": {
          ct: "39_雲泥温泉郷 → 04_汙垢敵人黑色汗",
          en: "39_Above &amp; Below → 04_Soap Scum",
          jp: "39_雲泥温泉郷 → 04_垢い敵、黒い汗",
        },
        "39_雲泥温泉郷 → 05_源泉に潜む者達": {
          ct: "39_雲泥温泉郷  → 05_溫泉源頭潛伏者",
          en: "39_Above &amp; Below → 05_The Sauna Crew",
          jp: "39_雲泥温泉郷 → 05_源泉に潜む者達",
        },
        "39_雲泥温泉郷 → 06_湯けむり極楽地獄": {
          ct: "39_雲泥温泉郷 → 06_氤氳鄉極樂地獄",
          en: "39_Above &amp; Below → 06_Steamed to Death",
          jp: "39_雲泥温泉郷 → 06_湯けむり極楽地獄",
        },
        "40_風待ちアイランド → 01_むっちり隠れ港": {
          ct: "40_濃濃春色島 → 01_豐腴無人碼頭",
          en: "40_Windless Island → 01_Narrow Docks",
          jp: "40_風待ちアイランド → 01_むっちり隠れ港",
        },
        "40_風待ちアイランド → 02_ロマンスグレーハイウェイ": {
          ct: "40_濃濃春色島 → 02_浪漫高速公路",
          en: "40_Windless Island → 02_Romantic Highway",
          jp: "40_風待ちアイランド → 02_ロマンスグレーハイウェイ",
        },
        "40_風待ちアイランド → 03_泥酔マッサージャー": {
          ct: "40_濃濃春色島 → 03_爛醉的按摩師",
          en: "40_Windless Island → 03_Drunken Backrub",
          jp: "40_風待ちアイランド → 03_泥酔マッサージャー",
        },
        "40_風待ちアイランド → 04_豚箱恋愛沼": {
          ct: "40_濃濃春色島 → 04_看守所大熱戀",
          en: "40_Windless Island → 04_Gulag of Love",
          jp: "40_風待ちアイランド → 04_豚箱恋愛沼",
        },
        "40_風待ちアイランド → 05_フェロモン門": {
          ct: "40_濃濃春色島 → 05_費洛蒙的大門",
          en: "40_Windless Island → 05_Perfume Room",
          jp: "40_風待ちアイランド → 05_フェロモン門",
        },
        "40_風待ちアイランド → 06_天空秘宝の館": {
          ct: "40_濃濃春色島 → 06_春風雲雨之館",
          en: "40_Windless Island → 06_Houses of the Holy",
          jp: "40_風待ちアイランド → 06_天空秘宝の館",
        },
        "41_ITカタコンベ → 01_キリバンの番人": {
          ct: "41_IT地下墓穴 → 01_頭香警衛隊",
          en: "41_IT Catacombs → 01_Caliban's Keeper",
          jp: "41_ITカタコンベ → 01_キリバンの番人",
        },
        "41_ITカタコンベ → 02_ダイヤルアップ回廊": {
          ct: "41_IT地下墓 穴 → 02_撥接式迴廊",
          en: "41_IT Catacombs → 02_Dial-Up Dreams",
          jp: "41_ITカタコンベ → 02_ダイヤルアップ回廊",
        },
        "41_ITカタコンベ → 03_テレホー台座": {
          ct: "41_IT地下墓穴 → 03_吃到飽基座",
          en: "41_IT Catacombs → 03_Throne of Phone",
          jp: "41_ITカタコンベ → 03_テレホー台座",
        },
        "41_ITカタコンベ → 04_Mrs.ドスの墓": {
          ct: "41_IT地下墓穴 → 04_Mrs.DOS之墓",
          en: "41_IT Catacombs → 04_0S Graveyard",
          jp: "41_ITカタコンベ → 04_Mrs.ドスの墓",
        },
        "41_ITカタコンベ → 05_聖人ブラクラの遺骨": {
          ct: "41_IT地下 墓穴 → 05_惡意網站遺址",
          en: "41_IT Catacombs → 05_The Holy Exploit",
          jp: "41_ITカタコンベ → 05_聖人ブラクラの遺骨",
        },
        "41_ITカタコンベ → 06_怨叫カプラ": {
          ct: "41_IT地下墓穴 → 06_神像耦合器",
          en: "41_IT Catacombs → 06_Broadband Omens",
          jp: "41_ITカタコンベ → 06_怨叫カプラ",
        },
        "42_変覧会の絵 → 01_ヘタうまキュビズム": {
          ct: "42_怪展會之畫 → 01_藝術立體派",
          en: "42_Grotesque Gallery → 01_Cubist Crimes",
          jp: "42_変覧会の絵 → 01_ヘタうまキュビズム",
        },
        "42_変覧会の絵 → 02_癒し系地獄絵図": {
          ct: "42_怪展會之畫 → 02_療癒地獄繪",
          en: "42_Grotesque Gallery → 02_Surrealist Sins",
          jp: "42_変覧会の絵 → 02_癒し系地獄絵図",
        },
        "42_変覧会の絵 → 03_和尚のスケベな水墨画": {
          ct: "42_怪展會之畫 → 03_色和尚水墨",
          en: "42_Grotesque Gallery → 03_Gouache Ghouls",
          jp: "42_変覧会の絵 → 03_和尚のスケベな水墨画",
        },
        "42_変覧会の絵 → 04_一筆三億五千万円": {
          ct: "42_怪展會之畫 → 04_一劃三億五",
          en: "42_Grotesque Gallery → 04_Death by Dada",
          jp: "42_変覧会の絵 → 04_一筆三億五千万円",
        },
        "42_変覧会の絵 → 05_ヤンキー宗教画": {
          ct: "42_怪展會之畫 → 05_不良宗教畫",
          en: "42_Grotesque Gallery → 05_Baroque Beasts",
          jp: "42_変覧会の絵 → 05_ヤンキー宗教画",
        },
        "42_変覧会の絵 → 06_館長の自画像": {
          ct: "42_怪展會之畫 → 06_館長自畫像",
          en: "42_Grotesque Gallery → 06_Atrocious Deco",
          jp: "42_変覧会の絵 → 06_館長の自画像",
        },
        "43_エリア22 → 01_ローズウェイ事件": {
          ct: "43_22區 → 01_羅斯威爾路事件",
          en: "43_Area 22 → 01_Roswell Incident",
          jp: "43_エリア22 → 01_ローズウェイ事件",
        },
        "43_エリア22 → 02_キャットミューティレーション": {
          ct: "43_22 區 → 02_大規模屠貓奇案",
          en: "43_Area 22 → 02_Cat Abduction",
          jp: "43_エリア22 → 02_キャットミューティレーション",
        },
        "43_エリア22 → 03_マダムスキー型UFO": {
          ct: "43_22區 → 03_亞當斯基型 飛盤",
          en: "43_Area 22 → 03_Adamski Type",
          jp: "43_エリア22 → 03_マダムスキー型UFO",
        },
        "43_エリア22 → 04_チュパチュパカブラ遭遇": {
          ct: "43_22區 → 04_遇見吸吸小山羊",
          en: "43_Area 22 → 04_Chupacabra Love",
          jp: "43_エリア22 → 04_チュパチュパカブラ遭遇",
        },
        "43_エリア22 → 05_グースカツンツン大爆発": {
          ct: "43_22區 → 05_古斯通通大爆炸",
          en: "43_Area 22 → 05_Tunguska Event",
          jp: "43_エリア22 → 05_グースカツンツン大爆発",
        },
        "43_エリア22 → 06_あなた疲れてるのよ": {
          ct: "43_22區 → 06_親愛的你累了嗎",
          en: "43_Area 22 → 06_Offworld Weary",
          jp: "43_エリア22 → 06_あなた疲れてるのよ",
        },
        "44_超越サバンナ → 01_弱肉朝食": {
          ct: "44_超越大草原 → 01_弱肉強食",
          en: "44_Beyond the Savannah → 01_Eat the Weak",
          jp: "44_超越サバンナ → 01_弱肉朝食",
        },
        "44_超越サバンナ → 02_霊峰ニクマンジャロ": {
          ct: "44_超越大草 原 → 02_靈峰肌力馬札羅山",
          en: "44_Beyond the Savannah → 02_Nikumanjaro",
          jp: "44_超越サバンナ → 02_霊峰ニクマンジャロ",
        },
        "44_超越サバンナ → 03_原始の強敵、再び": {
          ct: "44_超越大草原 → 03_原始強敵,再現",
          en: "44_Beyond the Savannah → 03_The Noble Tribe",
          jp: "44_超越サバンナ → 03_原始の強敵、再び",
        },
        "44_超越サバンナ → 04_ウキウキ乾季": {
          ct: "44_超越大草原 → 04_歡喜的乾季",
          en: "44_Beyond the Savannah → 04_Dry Season",
          jp: "44_超越サバンナ → 04_ウキウキ乾季",
        },
        "44_超越サバンナ → 05_エレクトロサファリパーク": {
          ct: "44_超越大草原 → 05_電子野生動物園",
          en: "44_Beyond the Savannah → 05_Electrosafari",
          jp: "44_超越サバンナ → 05_エレクトロサファリパーク",
        },
        "44_超越サバンナ → 06_天国に一番近い水飲み場": {
          ct: "44_超越大草原 → 06_離天國最近的飲水場",
          en: "44_Beyond the Savannah → 06_Heaven's Oasis",
          jp: "44_超越サバンナ → 06_天国に一番近い水飲み場",
        },
        "45_ブリザード自動車道 → 01_あかぎれジャンクション": {
          ct: "45_暴風雪車道 → 01_乾裂交流道",
          en: "45_Blizzard Boulevard → 01_Shiver Junction",
          jp: "45_ブリザード自動車道 → 01_あかぎれジャンクション",
        },
        "45_ブリザード自動車道 → 02_ダダ洩れ海底トンネル": {
          ct: "45_暴風雪車道 → 02_流不停海底隧道",
          en: "45_Blizzard Boulevard → 02_Leaky Tunnel",
          jp: "45_ブリザード自動車道 → 02_ダダ洩れ海底トンネル",
        },
        "45_ブリザード自動車道 → 03_しもやけパーキングエリア": {
          ct: "45_暴 風雪車道 → 03_凍瘡休息站",
          en: "45_Blizzard Boulevard → 03_Frostbite Park",
          jp: "45_ブリザード自動車道 → 03_しもやけパーキングエリア",
        },
        "45_ブリザード自動車道 → 04_ぬくもり対向車線": {
          ct: "45_暴風雪車道 → 04_暖和對向車道",
          en: "45_Blizzard Boulevard → 04_Toasty Turnpike",
          jp: "45_ブリザード自動車道 → 04_ぬくもり対向車線",
        },
        "45_ブリザード自動車道 → 05_眠眠交通警備隊": {
          ct: "45_暴風雪車道 → 05_眠眠交通警備隊",
          en: "45_Blizzard Boulevard → 05_Sleepy Signals",
          jp: "45_ブリザード自動車道 → 05_眠眠交通警備隊",
        },
        "45_ブリザード自動車道 → 06_料金所ヒートショック": {
          ct: "45_暴 風雪車道 → 06_休克收費站",
          en: "45_Blizzard Boulevard → 06_Scorched Tollbooth",
          jp: "45_ブリザード自動車道 → 06_料金所ヒートショック",
        },
        "46_シンギュラリティ村 → 01_ユビキタス販売所": {
          ct: "46_奇點村 → 01_無所不在販賣處",
          en: "46_Singularityville → 01_Ubiquitous Sales",
          jp: "46_シンギュラリティ村  → 01_ユビキタス販売所",
        },
        "46_シンギュラリティ村 → 02_VR稲刈り場": {
          ct: "46_奇 點村 → 02_VR割稻場",
          en: "46_Singularityville → 02_Virtual Harvest",
          jp: "46_シンギュラリティ村 → 02_VR稲刈り場",
        },
        "46_シンギュラリティ村 → 03_ウェアラブル一軒家": {
          ct: "46_奇點村 → 03_穿戴式透天厝",
          en: "46_Singularityville → 03_Wearable Homes",
          jp: "46_シンギュラリティ村 → 03_ウェアラブル一軒家",
        },
        "46_シンギュラリティ村 → 04_8K肥溜め": {
          ct: "46_奇點村 → 04_8K堆肥桶",
          en: "46_Singularityville → 04_8K Fertilizer",
          jp: "46_シンギュラリティ村 → 04_8K肥溜め",
        },
        "46_シンギュラリティ村 → 05_夕焼けブロックチェーン": {
          ct: "46_奇點村 → 05_日落區塊 鏈",
          en: "46_Singularityville → 05_Blockchain Twilight",
          jp: "46_シンギ ュラリティ村 → 05_夕焼けブロックチェーン",
        },
        "46_シンギュラリティ村 → 06_ゲノム盆踊り": {
          ct: "46_奇點 村 → 06_基因盆舞",
          en: "46_Singularityville → 06_Haunted Genome",
          jp: "46_シンギュラリティ村 → 06_ゲノム盆踊り",
        },
        "47_オワーリ大陸 → 01_最果ての祠": {
          ct: "47_最終大陸 → 01_天涯小廟",
          en: "47_Ends of the Earth → 01_Ultimate Shrine",
          jp: "47_オワーリ大陸 → 01_最果ての祠",
        },
        "47_オワーリ大陸 → 02_終末の谷": {
          ct: "47_最終大陸 → 02_末日之谷",
          en: "47_Ends of the Earth → 02_Valley of the End",
          jp: "47_オワーリ大陸 → 02_終末の谷",
        },
        "47_オワーリ大陸 → 03_ファイナルタワー": {
          ct: "47_最終大陸 → 03_ 最後高塔",
          en: "47_Ends of the Earth → 03_Final Tower",
          jp: "47_オワーリ大陸 → 03_ファイナルタワー",
        },
        "47_オワーリ大陸 → 04_ラストラビリンス": {
          ct: "47_最終大陸 → 04_終點迷宮",
          en: "47_Ends of the Earth → 04_Last Labyrinth",
          jp: "47_オワーリ大陸 → 04_ラストラビリンス",
        },
        "47_オワーリ大陸 → 05_終焉の洞窟": {
          ct: "47_最終大陸 → 05_止境洞窟",
          en: "47_Ends of the Earth → 05_Cave Conclusion",
          jp: "47_オワーリ大陸 → 05_終焉の洞窟",
        },
        "47_オワーリ大陸 → 06_フィナーレ神殿": {
          ct: "47_最終大陸 → 06_海角神殿",
          en: "47_Ends of the Earth → 06_Apocalypse Temple",
          jp: "47_オワーリ大陸 → 06_フィナーレ神殿",
        },
        "48_伝説のおわり → 01_決断の時": {
          ct: "48_傳說的終點 → 01_ 決斷時刻",
          en: "48_The Legend Ends → 01_A Day of Reckoning",
          jp: "48_伝説のおわり → 01_決断の時",
        },
        "48_伝説のおわり → 02_復讐の準備": {
          ct: "48_傳說的終點 → 02_復仇準備",
          en: "48_The Legend Ends → 02_Thirst for Vengeance",
          jp: "48_伝説のおわり → 02_復讐の準備",
        },
        "48_伝説のおわり → 03_栄光のグローリー": {
          ct: "48_傳說的終點 → 03_驕傲光榮",
          en: "48_The Legend Ends → 03_Glory of Glories",
          jp: "48_伝説のおわり → 03_栄光のグローリー",
        },
        "48_伝説のおわり → 04_命のせせらぎ": {
          ct: "48_傳說的終點 → 04_生命低語",
          en: "48_The Legend Ends → 04_A Moment of Serenity",
          jp: "48_伝説のおわり → 04_命のせせらぎ",
        },
        "48_伝説のおわり → 05_復活の偽呪文": {
          ct: "48_傳說的終點 → 05_復活 偽咒",
          en: "48_The Legend Ends → 05_False Resurrection",
          jp: "48_伝説のおわり → 05_復活の偽呪文",
        },
        "48_伝説のおわり → 06_契約の杯": {
          ct: "48_ 傳說的終點 → 06_契約之杯",
          en: "48_The Legend Ends → 06_Goblet of the Oath",
          jp: "48_伝説のおわり → 06_契約の杯",
        },
        "48_伝説のおわり → 07_風そよぐ黄昏時": {
          ct: "48_傳說的終點 → 07_黃昏風起",
          en: "48_The Legend Ends → 07_Twilight Zephyr",
          jp: "48_伝説のおわり → 07_風そよぐ黄昏時",
        },
        "48_伝説のおわり → 08_破られた誓い": {
          ct: "48_傳說的終點 → 08_破碎誓言",
          en: "48_The Legend Ends → 08_Unkept Promises",
          jp: "48_伝説のおわり → 08_破られた誓い",
        },
        "49_古代研究所 → 01_太古の力": {
          ct: "49_古代研究所 → 01_太古之力",
          en: "49_Laboratory of Relics → 01_Eldritch Forces",
          jp: "49_古代研究所 → 01_太古の力",
        },
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// [type="radio"] {
//   display: none;
// }
#radioBtn .notActive {
  color: #3276b1;
  background-color: #fff;
}
// [data-toggle="buttons-radio"] > .btn > input[type="radio"] {
//   display: none;
// }

// [data-toggle="buttons-checkbox"] > .btn > input[type="checkbox"] {
//   display: none;
// }
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.tltleFont {
  font-size: 3rem;
  font-weight: bold;
}
.addBtn {
  font-size: 3rem;
  color: wheat;
  padding: 2px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.selectCircle {
  position: relative;
  top: -100%;
  left: 0%;
  opacity: 20%;
  font-size: 350%;
  color: #ff5f5f;
}
.unSelect {
  display: none;
}
.unSelectFliter {
  border: solid 1px #ccc !important;
  background-color: rgb(203 203 255) !important;
}
.stageEnemyImg {
  width: 60px;
  padding-top: 5px;
}
.stageEnemyName {
  display: block;
}
.stageEnemyTable {
  height: 140px;
  width: 10%;
}
.enemyList {
  font-size: 0.8rem;
}
@media (max-width: 800px) {
  .stageEnemyImg {
    width: 22px;
    padding-top: 5px;
  }
  .stageEnemyName {
    display: none;
  }
  .stageEnemyTable {
    height: 60px;
    width: 10%;
  }
  .stageEnemyBullseye {
    font-size: 200%;
    top: -60% !important;
  }
  .enemyList {
    font-size: 0.4rem !important;
  }
}
@media (max-width: 1050px) {
  .tltleFont {
    font-size: 1.8rem;
    font-weight: bold;
  }
}
@media (max-width: 576px) {
  .tltleFont {
    font-size: 1.3rem;
    font-weight: bold;
  }
}
</style>
